/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** The `ID` scalar type represents a unique MongoDB identifier in collection. MongoDB by default use 12-byte ObjectId value (https://docs.mongodb.com/manual/reference/bson-types/#objectid). But MongoDB also may accepts string or integer as correct values for _id field. */
  MongoID: { input: any; output: any };
  /** The string representation of JavaScript regexp. You may provide it with flags "/^abc.*\/i" or without flags like "^abc.*". More info about RegExp characters and flags: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions */
  RegExpAsString: { input: any; output: any };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any };
};

export type Category = {
  __typename?: 'Category';
  _id: Scalars['MongoID']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<File>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeyWords?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<File>;
};

/** A connection to a list of items. */
export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<CategoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CategoryEdge = {
  __typename?: 'CategoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Category;
};

export type CategoryPaginationType = {
  __typename?: 'CategoryPaginationType';
  items?: Maybe<Array<Maybe<Category>>>;
  pageInfo?: Maybe<PageInfoType>;
};

export type Company = {
  __typename?: 'Company';
  _id: Scalars['MongoID']['output'];
  courseDirections?: Maybe<Array<Maybe<CompanyCourseDirections>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<CompanySettings>;
  thumbnail?: Maybe<File>;
};

/** A connection to a list of items. */
export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<CompanyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CompanyCourseDirections = {
  __typename?: 'CompanyCourseDirections';
  _id?: Maybe<Scalars['MongoID']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  courseDirectionName?: Maybe<Scalars['String']['output']>;
};

export type CompanyCourseDirectionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  courseDirectionName?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Company;
};

/** List of items with pagination. */
export type CompanyPagination = {
  __typename?: 'CompanyPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Company>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CompanySettings = {
  __typename?: 'CompanySettings';
  isShowCompanyLogo?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanySettingsInput = {
  isShowCompanyLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompleteCourseCategoryInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
};

export type Consultation = {
  __typename?: 'Consultation';
  _id: Scalars['MongoID']['output'];
  consultationStatus?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Course>;
  isConsulted?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type ConsultationConnection = {
  __typename?: 'ConsultationConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<ConsultationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ConsultationEdge = {
  __typename?: 'ConsultationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Consultation;
};

/** List of items with pagination. */
export type ConsultationPagination = {
  __typename?: 'ConsultationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Consultation>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CopyFilesResult = {
  __typename?: 'CopyFilesResult';
  copiedCount: Scalars['Int']['output'];
  errors?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CopyItemInput = {
  id: Scalars['ID']['input'];
};

export type Course = {
  __typename?: 'Course';
  _id: Scalars['MongoID']['output'];
  alias: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  countOfVotes?: Maybe<Scalars['Float']['output']>;
  courseDirection: Scalars['MongoID']['output'];
  courseType: EnumCourseCourseType;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  currency?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  files?: Maybe<Array<Maybe<File>>>;
  image?: Maybe<File>;
  isFreeCourse?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  isRemoved?: Maybe<Scalars['Boolean']['output']>;
  isTrialLessons?: Maybe<Scalars['Boolean']['output']>;
  language: EnumCourseLanguage;
  metaDescription: Scalars['String']['output'];
  metaKeyWords: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  settings?: Maybe<CourseSettings>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  thumbnail?: Maybe<File>;
  title: Scalars['String']['output'];
  totalModules?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  videos?: Maybe<Array<Maybe<File>>>;
  voteRate?: Maybe<Scalars['Float']['output']>;
};

export type CourseCategory = {
  __typename?: 'CourseCategory';
  _id: Scalars['MongoID']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  categoryIndex?: Maybe<Scalars['Int']['output']>;
  course?: Maybe<Course>;
  courseCategoryStudents: Array<User>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  data?: Maybe<CourseCategoryData>;
  id?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<File>;
  lessonTemplate?: Maybe<Scalars['MongoID']['output']>;
  lessonsInTemplateCount?: Maybe<Scalars['Int']['output']>;
  studentsCount?: Maybe<Scalars['Int']['output']>;
  teacherLessonTemplate?: Maybe<LessonTemplate>;
  title?: Maybe<Scalars['String']['output']>;
  zeroLesson?: Maybe<Lesson>;
};

export type CourseCategoryCourseArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCourseInput>;
};

export type CourseCategoryCourseCategoryStudentsArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};

export type CourseCategoryCreatorArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

export type CourseCategoryTeacherLessonTemplateArgs = {
  filter?: InputMaybe<FilterFindOneLessonTemplateInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneLessonTemplateInput>;
};

export type CourseCategoryZeroLessonArgs = {
  filter?: InputMaybe<FilterFindOneLessonInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneLessonInput>;
};

/** A connection to a list of items. */
export type CourseCategoryConnection = {
  __typename?: 'CourseCategoryConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<CourseCategoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CourseCategoryData = {
  __typename?: 'CourseCategoryData';
  color?: Maybe<Scalars['String']['output']>;
  course?: Maybe<Scalars['MongoID']['output']>;
  isCommonCourseCategory?: Maybe<Scalars['Boolean']['output']>;
};

/** An edge in a connection. */
export type CourseCategoryEdge = {
  __typename?: 'CourseCategoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CourseCategory;
};

export type CourseCategoryPaginationType = {
  __typename?: 'CourseCategoryPaginationType';
  items?: Maybe<Array<Maybe<CourseCategory>>>;
  pageInfo?: Maybe<PageInfoType>;
};

export type CourseCategoryShort = {
  __typename?: 'CourseCategoryShort';
  _id: Scalars['MongoID']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CourseCategoryType = {
  __typename?: 'CourseCategoryType';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type CourseConnection = {
  __typename?: 'CourseConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<CourseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CourseEdge = {
  __typename?: 'CourseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Course;
};

export type CourseInfoById = {
  __typename?: 'CourseInfoById';
  courseCategories?: Maybe<Array<Maybe<CourseCategoryShort>>>;
  courseId: Scalars['MongoID']['output'];
  teachers?: Maybe<Array<Maybe<TeacherShort>>>;
};

export type CourseMetricDefinition = {
  __typename?: 'CourseMetricDefinition';
  _id: Scalars['MongoID']['output'];
  chart?: Maybe<CourseMetricDefinitionChart>;
  course?: Maybe<Course>;
  courseCategory?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  inputSettings?: Maybe<CourseMetricDefinitionInputSettings>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  isVisibleToStudent?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<CourseMetricDefinitionOptions>>>;
  order?: Maybe<Scalars['Float']['output']>;
  scope?: Maybe<EnumCourseMetricDefinitionScope>;
  translations?: Maybe<CourseMetricDefinitionTranslations>;
  uiType?: Maybe<EnumCourseMetricDefinitionUiType>;
  unit?: Maybe<CourseMetricDefinitionUnit>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  validation?: Maybe<CourseMetricDefinitionValidation>;
  valueType: EnumCourseMetricDefinitionValueType;
};

export type CourseMetricDefinitionCourseArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCourseInput>;
};

export type CourseMetricDefinitionChart = {
  __typename?: 'CourseMetricDefinitionChart';
  defaultType?: Maybe<EnumCourseMetricDefinitionChartDefaultType>;
};

export type CourseMetricDefinitionChartInput = {
  defaultType?: InputMaybe<Scalars['String']['input']>;
};

export type CourseMetricDefinitionInput = {
  chart?: InputMaybe<CourseMetricDefinitionChartInput>;
  course: Scalars['MongoID']['input'];
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  inputSettings?: InputMaybe<CourseMetricDefinitionInputSettingsInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisibleToStudent?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<InputMaybe<CourseMetricDefinitionOptionInput>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<CourseMetricDefinitionTranslationsInput>;
  uiType?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<CourseMetricDefinitionUnitInput>;
  validation?: InputMaybe<CourseMetricDefinitionValidationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type CourseMetricDefinitionInputSettings = {
  __typename?: 'CourseMetricDefinitionInputSettings';
  allowDecimals?: Maybe<Scalars['Boolean']['output']>;
  allowNegative?: Maybe<Scalars['Boolean']['output']>;
};

export type CourseMetricDefinitionInputSettingsInput = {
  allowDecimals?: InputMaybe<Scalars['Boolean']['input']>;
  allowNegative?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CourseMetricDefinitionOptionInput = {
  translations?: InputMaybe<CourseMetricDefinitionTranslationInput>;
};

export type CourseMetricDefinitionOptions = {
  __typename?: 'CourseMetricDefinitionOptions';
  key: Scalars['String']['output'];
  translations?: Maybe<CourseMetricDefinitionTranslationsName>;
};

export type CourseMetricDefinitionTranslationInput = {
  ua?: InputMaybe<Scalars['String']['input']>;
};

export type CourseMetricDefinitionTranslations = {
  __typename?: 'CourseMetricDefinitionTranslations';
  description?: Maybe<CourseMetricDefinitionTranslationsName>;
  helpText?: Maybe<CourseMetricDefinitionTranslationsName>;
  name?: Maybe<CourseMetricDefinitionTranslationsName>;
  placeholder?: Maybe<CourseMetricDefinitionTranslationsName>;
  unitName?: Maybe<CourseMetricDefinitionTranslationsName>;
};

export type CourseMetricDefinitionTranslationsInput = {
  description?: InputMaybe<CourseMetricDefinitionTranslationInput>;
  helpText?: InputMaybe<CourseMetricDefinitionTranslationInput>;
  name?: InputMaybe<CourseMetricDefinitionTranslationInput>;
  placeholder?: InputMaybe<CourseMetricDefinitionTranslationInput>;
  unitName?: InputMaybe<CourseMetricDefinitionTranslationInput>;
};

export type CourseMetricDefinitionTranslationsName = {
  __typename?: 'CourseMetricDefinitionTranslationsName';
  ua?: Maybe<Scalars['String']['output']>;
};

export type CourseMetricDefinitionUnit = {
  __typename?: 'CourseMetricDefinitionUnit';
  code?: Maybe<Scalars['String']['output']>;
};

export type CourseMetricDefinitionUnitInput = {
  code?: InputMaybe<Scalars['String']['input']>;
};

export type CourseMetricDefinitionValidation = {
  __typename?: 'CourseMetricDefinitionValidation';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type CourseMetricDefinitionValidationInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type CoursePaginationType = {
  __typename?: 'CoursePaginationType';
  items?: Maybe<Array<Maybe<Course>>>;
  pageInfo?: Maybe<PageInfoType>;
};

export type CourseSettings = {
  __typename?: 'CourseSettings';
  brandColor?: Maybe<Scalars['String']['output']>;
  isAutoSelectionOfFilesWhenDragging?: Maybe<Scalars['Boolean']['output']>;
  isAutoShowingOfNextFileExercise?: Maybe<Scalars['Boolean']['output']>;
  isBlockBreadcrumbsNavigationInLesson?: Maybe<Scalars['Boolean']['output']>;
  isDisabledCompleteLessonInfoForStudent?: Maybe<Scalars['Boolean']['output']>;
  isEditableModuleForTeacher?: Maybe<Scalars['Boolean']['output']>;
  isEnableAutomaticTransitionToExerciseFile?: Maybe<Scalars['Boolean']['output']>;
  isEnableSurveyByDefault?: Maybe<Scalars['Boolean']['output']>;
  isExerciseSurvey?: Maybe<Scalars['Boolean']['output']>;
  isFilesListOpenedInLesson?: Maybe<Scalars['Boolean']['output']>;
  isFilesOpenedInModal?: Maybe<Scalars['Boolean']['output']>;
  isGoNextAfterCompletionFile?: Maybe<Scalars['Boolean']['output']>;
  isHiddenCameraWhenSharingScreen?: Maybe<Scalars['Boolean']['output']>;
  isHiddenLessonIsNotCompleteButton?: Maybe<Scalars['Boolean']['output']>;
  isHiddenSlidesRibbonInPresentation?: Maybe<Scalars['Boolean']['output']>;
  isHideShowingOfExercisesInLessonCardsForStudent?: Maybe<Scalars['Boolean']['output']>;
  isProgressBar?: Maybe<Scalars['Boolean']['output']>;
  isSelectionOfAnyLesson?: Maybe<Scalars['Boolean']['output']>;
  isStudentAbilityToDrawDuringTheLesson?: Maybe<Scalars['Boolean']['output']>;
  isStudentAbilityToRecordLesson?: Maybe<Scalars['Boolean']['output']>;
};

export type CourseSettingsInput = {
  brandColor?: InputMaybe<Scalars['String']['input']>;
  isAutoSelectionOfFilesWhenDragging?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoShowingOfNextFileExercise?: InputMaybe<Scalars['Boolean']['input']>;
  isBlockBreadcrumbsNavigationInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabledCompleteLessonInfoForStudent?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableModuleForTeacher?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableAutomaticTransitionToExerciseFile?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableSurveyByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isExerciseSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesListOpenedInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesOpenedInModal?: InputMaybe<Scalars['Boolean']['input']>;
  isGoNextAfterCompletionFile?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenCameraWhenSharingScreen?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenLessonIsNotCompleteButton?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenSlidesRibbonInPresentation?: InputMaybe<Scalars['Boolean']['input']>;
  isHideShowingOfExercisesInLessonCardsForStudent?: InputMaybe<Scalars['Boolean']['input']>;
  isProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  isSelectionOfAnyLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentAbilityToDrawDuringTheLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentAbilityToRecordLesson?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CoursesDataInputTc = {
  course: Scalars['MongoID']['input'];
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  teacher?: InputMaybe<Scalars['MongoID']['input']>;
  zeroLessonDateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateContentDataTc = {
  __typename?: 'CreateContentDataTC';
  content?: Maybe<Scalars['String']['output']>;
};

export type CreateManyFileInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FileDataInput>;
  isFolder?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyFilePayload = {
  __typename?: 'CreateManyFilePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<File>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateManyTagInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyTagPayload = {
  __typename?: 'CreateManyTagPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Tag>>;
};

export type CreateOneCategoryInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<FileInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<FileInput>;
};

export type CreateOneCategoryPayload = {
  __typename?: 'CreateOneCategoryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<Category>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneCompanyInput = {
  courseDirections?: InputMaybe<Array<InputMaybe<CompanyCourseDirectionsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsInput>;
  thumbnail?: InputMaybe<FileInput>;
};

export type CreateOneCompanyPayload = {
  __typename?: 'CreateOneCompanyPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<Company>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneConsultationInput = {
  consultationStatus?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['MongoID']['input']>;
  isConsulted?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneConsultationPayload = {
  __typename?: 'CreateOneConsultationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<Consultation>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneCourseCategoryPayload = {
  __typename?: 'CreateOneCourseCategoryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<CourseCategory>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneCourseInput = {
  alias: Scalars['String']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  countOfVotes?: InputMaybe<Scalars['Float']['input']>;
  courseDirection: Scalars['MongoID']['input'];
  courseType: EnumCourseCourseType;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<InputMaybe<FileInput>>>;
  image?: InputMaybe<FileInput>;
  isFreeCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialLessons?: InputMaybe<Scalars['Boolean']['input']>;
  language: EnumCourseLanguage;
  metaDescription: Scalars['String']['input'];
  metaKeyWords: Scalars['String']['input'];
  metaTitle: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<CourseSettingsInput>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  thumbnail?: InputMaybe<FileInput>;
  title: Scalars['String']['input'];
  totalModules?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  videos?: InputMaybe<Array<InputMaybe<FileInput>>>;
  voteRate?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOneCourseMetricDefinitionPayload = {
  __typename?: 'CreateOneCourseMetricDefinitionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CourseMetricDefinition>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCoursePayload = {
  __typename?: 'CreateOneCoursePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<Course>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneDialogPayload = {
  __typename?: 'CreateOneDialogPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<Dialog>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneEventPayload = {
  __typename?: 'CreateOneEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneFavoriteTopicPayload = {
  __typename?: 'CreateOneFavoriteTopicPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<FavoriteTopic>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneFileInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FileDataInput>;
  isFolder?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneFilePayload = {
  __typename?: 'CreateOneFilePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<File>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneFormTemplateInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FormTemplateDataInput>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneFormTemplatePayload = {
  __typename?: 'CreateOneFormTemplatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<FormTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneHomeTaskPayload = {
  __typename?: 'CreateOneHomeTaskPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<HomeTask>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneLessonExerciseInput = {
  attachments?: InputMaybe<Array<InputMaybe<FileInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<LessonExerciseDataInput>;
  files?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  filesStatuses?: InputMaybe<Array<InputMaybe<LessonExerciseFilesStatusesInput>>>;
  image?: InputMaybe<FileInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  originalLessonExercise?: InputMaybe<Scalars['MongoID']['input']>;
  slides?: InputMaybe<Array<InputMaybe<LessonExerciseSlidesInput>>>;
  thumbnail?: InputMaybe<FileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<FileInput>>>;
};

export type CreateOneLessonExercisePayload = {
  __typename?: 'CreateOneLessonExercisePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<LessonExercise>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneLessonPayload = {
  __typename?: 'CreateOneLessonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<Lesson>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneLessonTemplatePayload = {
  __typename?: 'CreateOneLessonTemplatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<LessonTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneMessagePayload = {
  __typename?: 'CreateOneMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Message>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePostInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  countOfVotes?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<FileInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  thumbnail?: InputMaybe<FileInput>;
  timeForReading?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  voteRate?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOnePostPayload = {
  __typename?: 'CreateOnePostPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<Post>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneSubscriptionPayload = {
  __typename?: 'CreateOneSubscriptionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<Subscription>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneUserGroupPayload = {
  __typename?: 'CreateOneUserGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<UserGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneUserPayload = {
  __typename?: 'CreateOneUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateOneVotePayload = {
  __typename?: 'CreateOneVotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Created document */
  record?: Maybe<Vote>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Dialog = {
  __typename?: 'Dialog';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  data?: Maybe<DialogData>;
  dialogUsers?: Maybe<Array<Maybe<DialogDialogUsers>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DialogCreatorArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

/** A connection to a list of items. */
export type DialogConnection = {
  __typename?: 'DialogConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<DialogEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DialogData = {
  __typename?: 'DialogData';
  course?: Maybe<Course>;
  courseCategory?: Maybe<CourseCategory>;
  isCommonDialog?: Maybe<Scalars['Boolean']['output']>;
  lesson?: Maybe<Scalars['MongoID']['output']>;
};

export type DialogDataCourseArgs = {
  filter?: InputMaybe<FilterFindOneCourseInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCourseInput>;
};

export type DialogDataCourseCategoryArgs = {
  filter?: InputMaybe<FilterFindOneCourseCategoryInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCourseCategoryInput>;
};

export type DialogDialogUsers = {
  __typename?: 'DialogDialogUsers';
  countOfSentMessages?: Maybe<Scalars['Float']['output']>;
  countOfUnreadMessages?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
};

/** An edge in a connection. */
export type DialogEdge = {
  __typename?: 'DialogEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Dialog;
};

export type DialogType = {
  __typename?: 'DialogType';
  creator?: Maybe<User>;
};

export type DialogUsersPaginationType = {
  __typename?: 'DialogUsersPaginationType';
  items?: Maybe<Array<Maybe<DialogType>>>;
  pageInfo?: Maybe<PaginationType>;
};

export type DialogsPaginationType = {
  __typename?: 'DialogsPaginationType';
  items?: Maybe<Array<Maybe<Dialog>>>;
  pageInfo?: Maybe<PaginationType>;
};

export type EmptyType = {
  __typename?: 'EmptyType';
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum EnumCourseCourseType {
  Course = 'course',
  OnlineCourse = 'onlineCourse',
}

export enum EnumCourseLanguage {
  En = 'en',
  Ru = 'ru',
  Ua = 'ua',
}

export enum EnumCourseMetricDefinitionChartDefaultType {
  Area = 'area',
  Bar = 'bar',
  Line = 'line',
  Table = 'table',
}

export enum EnumCourseMetricDefinitionScope {
  Exercise = 'exercise',
  Lesson = 'lesson',
}

export enum EnumCourseMetricDefinitionUiType {
  Input = 'input',
  Radio = 'radio',
  Select = 'select',
  Slider = 'slider',
  Switch = 'switch',
  Textarea = 'textarea',
}

export enum EnumCourseMetricDefinitionValueType {
  Boolean = 'boolean',
  Number = 'number',
  Select = 'select',
  String = 'string',
}

export enum EnumMetricValueSource {
  Manual = 'manual',
  System = 'system',
}

export enum EnumUserRole {
  Admin = 'ADMIN',
  Author = 'AUTHOR',
  Manager = 'MANAGER',
  Student = 'STUDENT',
  SuperTeacher = 'SUPER_TEACHER',
  Teacher = 'TEACHER',
  User = 'USER',
}

export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  __typename?: 'Event';
  _id: Scalars['MongoID']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  data?: Maybe<EventData>;
  dateTime?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EventCreatorArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

/** A connection to a list of items. */
export type EventConnection = {
  __typename?: 'EventConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<EventEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type EventData = {
  __typename?: 'EventData';
  course?: Maybe<Scalars['MongoID']['output']>;
  courseCategory?: Maybe<CourseCategory>;
  lesson?: Maybe<Lesson>;
  studentsGroup?: Maybe<Scalars['MongoID']['output']>;
  users?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

/** An edge in a connection. */
export type EventEdge = {
  __typename?: 'EventEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Event;
};

export type EventPaginationType = {
  __typename?: 'EventPaginationType';
  items?: Maybe<Array<Maybe<Event>>>;
  pageInfo?: Maybe<PageInfoType>;
};

export type FavoriteTopic = {
  __typename?: 'FavoriteTopic';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  entity?: Maybe<Post>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FavoriteTopicCreatorArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

export type FavoriteTopicEntityArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePostInput>;
};

/** A connection to a list of items. */
export type FavoriteTopicConnection = {
  __typename?: 'FavoriteTopicConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<FavoriteTopicEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FavoriteTopicEdge = {
  __typename?: 'FavoriteTopicEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: FavoriteTopic;
};

/** List of items with pagination. */
export type FavoriteTopicPagination = {
  __typename?: 'FavoriteTopicPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<FavoriteTopic>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type File = {
  __typename?: 'File';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<Scalars['MongoID']['output']>;
  data?: Maybe<FileData>;
  isFolder?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type FileData = {
  __typename?: 'FileData';
  course?: Maybe<Scalars['MongoID']['output']>;
  folder?: Maybe<Scalars['MongoID']['output']>;
  isLink?: Maybe<Scalars['Boolean']['output']>;
  isNotHandout?: Maybe<Scalars['Boolean']['output']>;
  isPublicAccess?: Maybe<Scalars['Boolean']['output']>;
  isShared?: Maybe<Scalars['Boolean']['output']>;
  parentFile?: Maybe<Scalars['MongoID']['output']>;
};

export type FileDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  folder?: InputMaybe<Scalars['MongoID']['input']>;
  isLink?: InputMaybe<Scalars['Boolean']['input']>;
  isNotHandout?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  parentFile?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FileInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FileDataInput>;
  isFolder?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilePaginationType = {
  __typename?: 'FilePaginationType';
  items?: Maybe<Array<Maybe<File>>>;
  pageInfo?: Maybe<PageInfoType>;
};

export type FilePartInfoDataTc = {
  __typename?: 'FilePartInfoDataTC';
  bucket?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
};

export type FilePartInfoDataTcInput = {
  ETag?: InputMaybe<Scalars['String']['input']>;
  PartNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type FileTypeTc = {
  __typename?: 'FileTypeTC';
  createdAt?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<Scalars['String']['output']>;
  isFolder?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FileWithStatus = {
  __typename?: 'FileWithStatus';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  data?: Maybe<FileWithStatusData>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FileWithStatusData = {
  __typename?: 'FileWithStatusData';
  isLink?: Maybe<Scalars['Boolean']['output']>;
  isPublicAccess?: Maybe<Scalars['Boolean']['output']>;
  isShared?: Maybe<Scalars['Boolean']['output']>;
};

export type FilesMetaInfoDataTc = {
  chunkNumber?: InputMaybe<Scalars['Int']['input']>;
  contentRange?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  totalChunks?: InputMaybe<Scalars['Int']['input']>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type FilesTc = {
  data?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
};

export type FilterByTypeFindManyCourseInput = {
  courseIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  courseType?: InputMaybe<Scalars['String']['input']>;
  isFreeCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCategoryAliasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountCategoryInput = {
  AND?: InputMaybe<Array<FilterCountCategoryInput>>;
  OR?: InputMaybe<Array<FilterCountCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCategoryOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<FilterCountFileInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<FilterCountFileInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCategoryOperatorsInput = {
  _id?: InputMaybe<FilterCountCategory_IdOperatorsInput>;
  alias?: InputMaybe<FilterCountCategoryAliasOperatorsInput>;
};

export type FilterCountCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCompanyCourseDirectionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  courseDirectionName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountCompanyInput = {
  AND?: InputMaybe<Array<FilterCountCompanyInput>>;
  OR?: InputMaybe<Array<FilterCountCompanyInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCompanyOperatorsInput>;
  courseDirections?: InputMaybe<Array<InputMaybe<FilterCountCompanyCourseDirectionsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<FilterCountCompanySettingsInput>;
  thumbnail?: InputMaybe<FilterCountFileInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCompanyOperatorsInput = {
  _id?: InputMaybe<FilterCountCompany_IdOperatorsInput>;
};

export type FilterCountCompanySettingsInput = {
  isShowCompanyLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountCompany_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountConsultationInput = {
  AND?: InputMaybe<Array<FilterCountConsultationInput>>;
  OR?: InputMaybe<Array<FilterCountConsultationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountConsultationOperatorsInput>;
  consultationStatus?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['MongoID']['input']>;
  isConsulted?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountConsultationOperatorsInput = {
  _id?: InputMaybe<FilterCountConsultation_IdOperatorsInput>;
};

export type FilterCountConsultation_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCourseAliasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountCourseCategoryDataInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  isCommonCourseCategory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountCourseCategoryInput = {
  AND?: InputMaybe<Array<FilterCountCourseCategoryInput>>;
  OR?: InputMaybe<Array<FilterCountCourseCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCourseCategoryOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterCountCourseCategoryDataInput>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<FilterCountFileInput>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCourseCategoryOperatorsInput = {
  _id?: InputMaybe<FilterCountCourseCategory_IdOperatorsInput>;
};

export type FilterCountCourseCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCourseCourseDirectionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCourseCourseTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCourseCourseType>;
  gte?: InputMaybe<EnumCourseCourseType>;
  in?: InputMaybe<Array<InputMaybe<EnumCourseCourseType>>>;
  lt?: InputMaybe<EnumCourseCourseType>;
  lte?: InputMaybe<EnumCourseCourseType>;
  ne?: InputMaybe<EnumCourseCourseType>;
  nin?: InputMaybe<Array<InputMaybe<EnumCourseCourseType>>>;
};

export type FilterCountCourseCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCourseInput = {
  AND?: InputMaybe<Array<FilterCountCourseInput>>;
  OR?: InputMaybe<Array<FilterCountCourseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCourseOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  countOfVotes?: InputMaybe<Scalars['Float']['input']>;
  courseDirection?: InputMaybe<Scalars['MongoID']['input']>;
  courseType?: InputMaybe<EnumCourseCourseType>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<InputMaybe<FilterCountFileInput>>>;
  image?: InputMaybe<FilterCountFileInput>;
  isFreeCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialLessons?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<EnumCourseLanguage>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<FilterCountCourseSettingsInput>;
  tags?: InputMaybe<Array<InputMaybe<FilterCountTagInput>>>;
  thumbnail?: InputMaybe<FilterCountFileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalModules?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  videos?: InputMaybe<Array<InputMaybe<FilterCountFileInput>>>;
  voteRate?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountCourseIsFreeCourseOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterCountCourseIsRemovedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterCountCourseLanguageOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCourseLanguage>;
  gte?: InputMaybe<EnumCourseLanguage>;
  in?: InputMaybe<Array<InputMaybe<EnumCourseLanguage>>>;
  lt?: InputMaybe<EnumCourseLanguage>;
  lte?: InputMaybe<EnumCourseLanguage>;
  ne?: InputMaybe<EnumCourseLanguage>;
  nin?: InputMaybe<Array<InputMaybe<EnumCourseLanguage>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCourseOperatorsInput = {
  _id?: InputMaybe<FilterCountCourse_IdOperatorsInput>;
  alias?: InputMaybe<FilterCountCourseAliasOperatorsInput>;
  courseDirection?: InputMaybe<FilterCountCourseCourseDirectionOperatorsInput>;
  courseType?: InputMaybe<FilterCountCourseCourseTypeOperatorsInput>;
  creator?: InputMaybe<FilterCountCourseCreatorOperatorsInput>;
  isFreeCourse?: InputMaybe<FilterCountCourseIsFreeCourseOperatorsInput>;
  isRemoved?: InputMaybe<FilterCountCourseIsRemovedOperatorsInput>;
  language?: InputMaybe<FilterCountCourseLanguageOperatorsInput>;
  title?: InputMaybe<FilterCountCourseTitleOperatorsInput>;
};

export type FilterCountCourseSettingsInput = {
  brandColor?: InputMaybe<Scalars['String']['input']>;
  isAutoSelectionOfFilesWhenDragging?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoShowingOfNextFileExercise?: InputMaybe<Scalars['Boolean']['input']>;
  isBlockBreadcrumbsNavigationInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabledCompleteLessonInfoForStudent?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableModuleForTeacher?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableAutomaticTransitionToExerciseFile?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableSurveyByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isExerciseSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesListOpenedInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesOpenedInModal?: InputMaybe<Scalars['Boolean']['input']>;
  isGoNextAfterCompletionFile?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenCameraWhenSharingScreen?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenLessonIsNotCompleteButton?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenSlidesRibbonInPresentation?: InputMaybe<Scalars['Boolean']['input']>;
  isHideShowingOfExercisesInLessonCardsForStudent?: InputMaybe<Scalars['Boolean']['input']>;
  isProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  isSelectionOfAnyLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentAbilityToDrawDuringTheLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentAbilityToRecordLesson?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountCourseTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountCourse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountDialogCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountDialogDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  isCommonDialog?: InputMaybe<Scalars['Boolean']['input']>;
  lesson?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountDialogDialogUsersInput = {
  countOfSentMessages?: InputMaybe<Scalars['Float']['input']>;
  countOfUnreadMessages?: InputMaybe<Scalars['Float']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountDialogInput = {
  AND?: InputMaybe<Array<FilterCountDialogInput>>;
  OR?: InputMaybe<Array<FilterCountDialogInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDialogOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterCountDialogDataInput>;
  dialogUsers?: InputMaybe<Array<InputMaybe<FilterCountDialogDialogUsersInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountDialogOperatorsInput = {
  _id?: InputMaybe<FilterCountDialog_IdOperatorsInput>;
  creator?: InputMaybe<FilterCountDialogCreatorOperatorsInput>;
};

export type FilterCountDialog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountEventCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountEventDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  lesson?: InputMaybe<Scalars['MongoID']['input']>;
  studentsGroup?: InputMaybe<Scalars['MongoID']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountEventInput = {
  AND?: InputMaybe<Array<FilterCountEventInput>>;
  OR?: InputMaybe<Array<FilterCountEventInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountEventOperatorsInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterCountEventDataInput>;
  dateTime?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountEventOperatorsInput = {
  _id?: InputMaybe<FilterCountEvent_IdOperatorsInput>;
  creator?: InputMaybe<FilterCountEventCreatorOperatorsInput>;
};

export type FilterCountEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountFavoriteTopicCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountFavoriteTopicEntityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountFavoriteTopicInput = {
  AND?: InputMaybe<Array<FilterCountFavoriteTopicInput>>;
  OR?: InputMaybe<Array<FilterCountFavoriteTopicInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountFavoriteTopicOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  entity?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountFavoriteTopicOperatorsInput = {
  _id?: InputMaybe<FilterCountFavoriteTopic_IdOperatorsInput>;
  creator?: InputMaybe<FilterCountFavoriteTopicCreatorOperatorsInput>;
  entity?: InputMaybe<FilterCountFavoriteTopicEntityOperatorsInput>;
};

export type FilterCountFavoriteTopic_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountFileInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FileDataInput>;
  isFolder?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterCountFormTemplateDataFieldsFormFieldItemsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountFormTemplateDataFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  formFieldItems?: InputMaybe<Array<InputMaybe<FilterCountFormTemplateDataFieldsFormFieldItemsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountFormTemplateDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FilterCountFormTemplateDataFieldsInput>>>;
};

export type FilterCountFormTemplateInput = {
  AND?: InputMaybe<Array<FilterCountFormTemplateInput>>;
  OR?: InputMaybe<Array<FilterCountFormTemplateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountFormTemplateOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterCountFormTemplateDataInput>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountFormTemplateOperatorsInput = {
  _id?: InputMaybe<FilterCountFormTemplate_IdOperatorsInput>;
};

export type FilterCountFormTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountHomeTaskDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountHomeTaskInput = {
  AND?: InputMaybe<Array<FilterCountHomeTaskInput>>;
  OR?: InputMaybe<Array<FilterCountHomeTaskInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountHomeTaskOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterCountHomeTaskDataInput>;
  files?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountHomeTaskOperatorsInput = {
  _id?: InputMaybe<FilterCountHomeTask_IdOperatorsInput>;
};

export type FilterCountHomeTask_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountLessonDataFilesOfExercisesFilesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountLessonDataFilesOfExercisesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  exerciseId?: InputMaybe<Scalars['MongoID']['input']>;
  files?: InputMaybe<Array<InputMaybe<FilterCountLessonDataFilesOfExercisesFilesInput>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountLessonDataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  filesOfExercises?: InputMaybe<Array<InputMaybe<FilterCountLessonDataFilesOfExercisesInput>>>;
  homeTaskStatus?: InputMaybe<Scalars['String']['input']>;
  isZeroLesson?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountLessonExerciseDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  isTodo?: InputMaybe<Scalars['Boolean']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountLessonExerciseFilesStatusesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountLessonExerciseInput = {
  AND?: InputMaybe<Array<FilterCountLessonExerciseInput>>;
  OR?: InputMaybe<Array<FilterCountLessonExerciseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountLessonExerciseOperatorsInput>;
  attachments?: InputMaybe<Array<InputMaybe<FilterCountFileInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterCountLessonExerciseDataInput>;
  files?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  filesStatuses?: InputMaybe<Array<InputMaybe<FilterCountLessonExerciseFilesStatusesInput>>>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<FilterCountFileInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  originalLessonExercise?: InputMaybe<Scalars['MongoID']['input']>;
  slides?: InputMaybe<Array<InputMaybe<FilterCountLessonExerciseSlidesInput>>>;
  thumbnail?: InputMaybe<FilterCountFileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<FilterCountFileInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountLessonExerciseOperatorsInput = {
  _id?: InputMaybe<FilterCountLessonExercise_IdOperatorsInput>;
};

export type FilterCountLessonExerciseSlidesInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  slide?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountLessonExercise_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountLessonHomeTaskOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountLessonInput = {
  AND?: InputMaybe<Array<FilterCountLessonInput>>;
  OR?: InputMaybe<Array<FilterCountLessonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountLessonOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<FilterCountFileInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterCountLessonDataInput>;
  files?: InputMaybe<Array<InputMaybe<FilterCountFileInput>>>;
  homeTask?: InputMaybe<Scalars['MongoID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<FilterCountFileInput>;
  lessonExercises?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesAboutStudent?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  studentMark?: InputMaybe<Scalars['Float']['input']>;
  studentSurvey?: InputMaybe<Array<InputMaybe<Array<InputMaybe<FilterCountLessonStudentSurveyInput>>>>>;
  thumbnail?: InputMaybe<FilterCountFileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoCallStatus?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<FilterCountFileInput>>>;
  workOnHomeTask?: InputMaybe<FilterCountLessonWorkOnHomeTaskInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountLessonOperatorsInput = {
  _id?: InputMaybe<FilterCountLesson_IdOperatorsInput>;
  homeTask?: InputMaybe<FilterCountLessonHomeTaskOperatorsInput>;
};

export type FilterCountLessonStudentSurveyInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountLessonWorkOnHomeTaskInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountLesson_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountMessageCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountMessageDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exerciseSerialNumber?: InputMaybe<Scalars['Float']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lessonSerialNumber?: InputMaybe<Scalars['Float']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountMessageDialogOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountMessageInput = {
  AND?: InputMaybe<Array<FilterCountMessageInput>>;
  OR?: InputMaybe<Array<FilterCountMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountMessageOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterCountMessageDataInput>;
  dialog?: InputMaybe<Scalars['MongoID']['input']>;
  isMetaMessage?: InputMaybe<Scalars['Boolean']['input']>;
  isReadBySomeone?: InputMaybe<Scalars['Boolean']['input']>;
  messageUsers?: InputMaybe<Array<InputMaybe<FilterCountMessageMessageUsersInput>>>;
  repliedMessage?: InputMaybe<Scalars['MongoID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountMessageMessageUsersInput = {
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountMessageOperatorsInput = {
  _id?: InputMaybe<FilterCountMessage_IdOperatorsInput>;
  creator?: InputMaybe<FilterCountMessageCreatorOperatorsInput>;
  dialog?: InputMaybe<FilterCountMessageDialogOperatorsInput>;
};

export type FilterCountMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPostAliasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountPostCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPostInput = {
  AND?: InputMaybe<Array<FilterCountPostInput>>;
  OR?: InputMaybe<Array<FilterCountPostInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPostOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  countOfVotes?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<FilterCountFileInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  thumbnail?: InputMaybe<FilterCountFileInput>;
  timeForReading?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  voteRate?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPostOperatorsInput = {
  _id?: InputMaybe<FilterCountPost_IdOperatorsInput>;
  alias?: InputMaybe<FilterCountPostAliasOperatorsInput>;
  category?: InputMaybe<FilterCountPostCategoryOperatorsInput>;
  title?: InputMaybe<FilterCountPostTitleOperatorsInput>;
};

export type FilterCountPostTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountPost_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountSubscriptionInput = {
  AND?: InputMaybe<Array<FilterCountSubscriptionInput>>;
  OR?: InputMaybe<Array<FilterCountSubscriptionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountSubscriptionOperatorsInput>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  codeForUnsubscribe?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isUnsubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountSubscriptionOperatorsInput = {
  _id?: InputMaybe<FilterCountSubscription_IdOperatorsInput>;
};

export type FilterCountSubscription_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountTagInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountUserCodeForActivationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserCodeForResetPasswordOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserCompanyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountUserCoursesCompleteCourseCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountUserCoursesCourseCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountUserCoursesDataOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountUserCoursesInput = {
  completeCourseCategories?: InputMaybe<Array<InputMaybe<FilterCountUserCoursesCompleteCourseCategoriesInput>>>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  currentLesson?: InputMaybe<Scalars['MongoID']['input']>;
  currentLessonExercise?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Scalars['MongoID']['input']>;
  isFinishedCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isPurchasedCourse?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  manager?: InputMaybe<Scalars['MongoID']['input']>;
  paymentData?: InputMaybe<FilterCountUserCoursesPaymentDataInput>;
  teacher?: InputMaybe<Scalars['MongoID']['input']>;
  zeroLessonDateTime?: InputMaybe<Scalars['Date']['input']>;
  zeroLessonStatus?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountUserCoursesManagerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountUserCoursesOperatorsInput = {
  courseCategory?: InputMaybe<FilterCountUserCoursesCourseCategoryOperatorsInput>;
  data?: InputMaybe<FilterCountUserCoursesDataOperatorsInput>;
  manager?: InputMaybe<FilterCountUserCoursesManagerOperatorsInput>;
  teacher?: InputMaybe<FilterCountUserCoursesTeacherOperatorsInput>;
};

export type FilterCountUserCoursesPaymentDataInput = {
  acq_id?: InputMaybe<Scalars['Float']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_credit?: InputMaybe<Scalars['Float']['input']>;
  card_mask?: InputMaybe<Scalars['String']['input']>;
  create_date?: InputMaybe<Scalars['Date']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  liqpay_order_id?: InputMaybe<Scalars['String']['input']>;
  payment_id?: InputMaybe<Scalars['Float']['input']>;
  transaction_id?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountUserCoursesTeacherOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountUserDbIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserFacebookIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserFirstNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserGroupCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountUserGroupDataCompleteCourseCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountUserGroupDataInput = {
  completeCourseCategories?: InputMaybe<Array<InputMaybe<FilterCountUserGroupDataCompleteCourseCategoriesInput>>>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  teacher?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountUserGroupInput = {
  AND?: InputMaybe<Array<FilterCountUserGroupInput>>;
  OR?: InputMaybe<Array<FilterCountUserGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountUserGroupOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterCountUserGroupDataInput>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<FilterCountUserGroupUsersInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountUserGroupOperatorsInput = {
  _id?: InputMaybe<FilterCountUserGroup_IdOperatorsInput>;
  creator?: InputMaybe<FilterCountUserGroupCreatorOperatorsInput>;
};

export type FilterCountUserGroupUsersInput = {
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountUserGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountUserInput = {
  AND?: InputMaybe<Array<FilterCountUserInput>>;
  OR?: InputMaybe<Array<FilterCountUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountUserOperatorsInput>;
  age?: InputMaybe<Scalars['Float']['input']>;
  avatar?: InputMaybe<FilterCountFileInput>;
  codeForActivation?: InputMaybe<Scalars['String']['input']>;
  codeForResetPassword?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['MongoID']['input']>;
  countOfSentMessages?: InputMaybe<Scalars['Float']['input']>;
  countOfUnreadMessages?: InputMaybe<Scalars['Float']['input']>;
  courses?: InputMaybe<Array<InputMaybe<FilterCountUserCoursesInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dbId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  isSubscribedToPosts?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperTeacherMode?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  registeredBy?: InputMaybe<Scalars['MongoID']['input']>;
  role?: InputMaybe<EnumUserRole>;
  subscriptions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userOnboarding?: InputMaybe<FilterCountUserUserOnboardingInput>;
};

export type FilterCountUserIsActivatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterCountUserIsRemovedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterCountUserIsSubscribedToPostsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterCountUserLastNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserLoginOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountUserOperatorsInput = {
  _id?: InputMaybe<FilterCountUser_IdOperatorsInput>;
  codeForActivation?: InputMaybe<FilterCountUserCodeForActivationOperatorsInput>;
  codeForResetPassword?: InputMaybe<FilterCountUserCodeForResetPasswordOperatorsInput>;
  company?: InputMaybe<FilterCountUserCompanyOperatorsInput>;
  courses?: InputMaybe<FilterCountUserCoursesOperatorsInput>;
  dbId?: InputMaybe<FilterCountUserDbIdOperatorsInput>;
  email?: InputMaybe<FilterCountUserEmailOperatorsInput>;
  facebookId?: InputMaybe<FilterCountUserFacebookIdOperatorsInput>;
  firstName?: InputMaybe<FilterCountUserFirstNameOperatorsInput>;
  isActivated?: InputMaybe<FilterCountUserIsActivatedOperatorsInput>;
  isRemoved?: InputMaybe<FilterCountUserIsRemovedOperatorsInput>;
  isSubscribedToPosts?: InputMaybe<FilterCountUserIsSubscribedToPostsOperatorsInput>;
  lastName?: InputMaybe<FilterCountUserLastNameOperatorsInput>;
  login?: InputMaybe<FilterCountUserLoginOperatorsInput>;
  phone?: InputMaybe<FilterCountUserPhoneOperatorsInput>;
  provider?: InputMaybe<FilterCountUserProviderOperatorsInput>;
  registeredBy?: InputMaybe<FilterCountUserRegisteredByOperatorsInput>;
  role?: InputMaybe<FilterCountUserRoleOperatorsInput>;
};

export type FilterCountUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserProviderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserRegisteredByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountUserRoleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserRole>;
  gte?: InputMaybe<EnumUserRole>;
  in?: InputMaybe<Array<InputMaybe<EnumUserRole>>>;
  lt?: InputMaybe<EnumUserRole>;
  lte?: InputMaybe<EnumUserRole>;
  ne?: InputMaybe<EnumUserRole>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserRole>>>;
};

export type FilterCountUserUserOnboardingInput = {
  videoCourse?: InputMaybe<FilterCountUserUserOnboardingVideoCourseInput>;
};

export type FilterCountUserUserOnboardingVideoCourseInput = {
  modulePlayer?: InputMaybe<FilterCountUserUserOnboardingVideoCourseModulePlayerInput>;
};

export type FilterCountUserUserOnboardingVideoCourseModulePlayerInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  lastStep?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterCountUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountVoteCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountVoteInput = {
  AND?: InputMaybe<Array<FilterCountVoteInput>>;
  OR?: InputMaybe<Array<FilterCountVoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountVoteOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  voteRate?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountVoteOperatorsInput = {
  _id?: InputMaybe<FilterCountVote_IdOperatorsInput>;
  creator?: InputMaybe<FilterCountVoteCreatorOperatorsInput>;
};

export type FilterCountVote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCategoryAliasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyCategoryInput = {
  AND?: InputMaybe<Array<FilterFindManyCategoryInput>>;
  OR?: InputMaybe<Array<FilterFindManyCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCategoryOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<FilterFindManyFileInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<FilterFindManyFileInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCategoryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCategory_IdOperatorsInput>;
  alias?: InputMaybe<FilterFindManyCategoryAliasOperatorsInput>;
};

export type FilterFindManyCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCompanyCourseDirectionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  courseDirectionName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCompanyInput = {
  AND?: InputMaybe<Array<FilterFindManyCompanyInput>>;
  OR?: InputMaybe<Array<FilterFindManyCompanyInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCompanyOperatorsInput>;
  courseDirections?: InputMaybe<Array<InputMaybe<FilterFindManyCompanyCourseDirectionsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<FilterFindManyCompanySettingsInput>;
  thumbnail?: InputMaybe<FilterFindManyFileInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCompanyOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCompany_IdOperatorsInput>;
};

export type FilterFindManyCompanySettingsInput = {
  isShowCompanyLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyCompany_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyConsultationInput = {
  AND?: InputMaybe<Array<FilterFindManyConsultationInput>>;
  OR?: InputMaybe<Array<FilterFindManyConsultationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyConsultationOperatorsInput>;
  consultationStatus?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['MongoID']['input']>;
  isConsulted?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyConsultationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyConsultation_IdOperatorsInput>;
};

export type FilterFindManyConsultation_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCourseAliasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyCourseCategoryDataInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  isCommonCourseCategory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyCourseCategoryInput = {
  AND?: InputMaybe<Array<FilterFindManyCourseCategoryInput>>;
  OR?: InputMaybe<Array<FilterFindManyCourseCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCourseCategoryOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindManyCourseCategoryDataInput>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<FilterFindManyFileInput>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCourseCategoryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCourseCategory_IdOperatorsInput>;
};

export type FilterFindManyCourseCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCourseCourseDirectionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCourseCourseTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCourseCourseType>;
  gte?: InputMaybe<EnumCourseCourseType>;
  in?: InputMaybe<Array<InputMaybe<EnumCourseCourseType>>>;
  lt?: InputMaybe<EnumCourseCourseType>;
  lte?: InputMaybe<EnumCourseCourseType>;
  ne?: InputMaybe<EnumCourseCourseType>;
  nin?: InputMaybe<Array<InputMaybe<EnumCourseCourseType>>>;
};

export type FilterFindManyCourseCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCourseInput = {
  AND?: InputMaybe<Array<FilterFindManyCourseInput>>;
  OR?: InputMaybe<Array<FilterFindManyCourseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCourseOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  countOfVotes?: InputMaybe<Scalars['Float']['input']>;
  courseDirection?: InputMaybe<Scalars['MongoID']['input']>;
  courseType?: InputMaybe<EnumCourseCourseType>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<InputMaybe<FilterFindManyFileInput>>>;
  image?: InputMaybe<FilterFindManyFileInput>;
  isFreeCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialLessons?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<EnumCourseLanguage>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<FilterFindManyCourseSettingsInput>;
  tags?: InputMaybe<Array<InputMaybe<FilterFindManyTagInput>>>;
  thumbnail?: InputMaybe<FilterFindManyFileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalModules?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  videos?: InputMaybe<Array<InputMaybe<FilterFindManyFileInput>>>;
  voteRate?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCourseIsFreeCourseOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyCourseIsRemovedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyCourseLanguageOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCourseLanguage>;
  gte?: InputMaybe<EnumCourseLanguage>;
  in?: InputMaybe<Array<InputMaybe<EnumCourseLanguage>>>;
  lt?: InputMaybe<EnumCourseLanguage>;
  lte?: InputMaybe<EnumCourseLanguage>;
  ne?: InputMaybe<EnumCourseLanguage>;
  nin?: InputMaybe<Array<InputMaybe<EnumCourseLanguage>>>;
};

export type FilterFindManyCourseMetricDefinitionChartInput = {
  defaultType?: InputMaybe<EnumCourseMetricDefinitionChartDefaultType>;
};

export type FilterFindManyCourseMetricDefinitionCourseCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCourseMetricDefinitionCourseOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCourseMetricDefinitionInput = {
  AND?: InputMaybe<Array<FilterFindManyCourseMetricDefinitionInput>>;
  OR?: InputMaybe<Array<FilterFindManyCourseMetricDefinitionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCourseMetricDefinitionOperatorsInput>;
  chart?: InputMaybe<FilterFindManyCourseMetricDefinitionChartInput>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inputSettings?: InputMaybe<FilterFindManyCourseMetricDefinitionInputSettingsInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisibleToStudent?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindManyCourseMetricDefinitionOptionsInput>>>;
  order?: InputMaybe<Scalars['Float']['input']>;
  scope?: InputMaybe<EnumCourseMetricDefinitionScope>;
  translations?: InputMaybe<FilterFindManyCourseMetricDefinitionTranslationsInput>;
  uiType?: InputMaybe<EnumCourseMetricDefinitionUiType>;
  unit?: InputMaybe<FilterFindManyCourseMetricDefinitionUnitInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validation?: InputMaybe<FilterFindManyCourseMetricDefinitionValidationInput>;
  valueType?: InputMaybe<EnumCourseMetricDefinitionValueType>;
};

export type FilterFindManyCourseMetricDefinitionInputSettingsInput = {
  allowDecimals?: InputMaybe<Scalars['Boolean']['input']>;
  allowNegative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCourseMetricDefinitionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCourseMetricDefinition_IdOperatorsInput>;
  course?: InputMaybe<FilterFindManyCourseMetricDefinitionCourseOperatorsInput>;
  courseCategory?: InputMaybe<FilterFindManyCourseMetricDefinitionCourseCategoryOperatorsInput>;
};

export type FilterFindManyCourseMetricDefinitionOptionsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<FilterFindManyCourseMetricDefinitionTranslationsNameInput>;
};

export type FilterFindManyCourseMetricDefinitionTranslationsInput = {
  description?: InputMaybe<FilterFindManyCourseMetricDefinitionTranslationsNameInput>;
  helpText?: InputMaybe<FilterFindManyCourseMetricDefinitionTranslationsNameInput>;
  name?: InputMaybe<FilterFindManyCourseMetricDefinitionTranslationsNameInput>;
  placeholder?: InputMaybe<FilterFindManyCourseMetricDefinitionTranslationsNameInput>;
  unitName?: InputMaybe<FilterFindManyCourseMetricDefinitionTranslationsNameInput>;
};

export type FilterFindManyCourseMetricDefinitionTranslationsNameInput = {
  ua?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCourseMetricDefinitionUnitInput = {
  code?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCourseMetricDefinitionValidationInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyCourseMetricDefinition_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCourseOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCourse_IdOperatorsInput>;
  alias?: InputMaybe<FilterFindManyCourseAliasOperatorsInput>;
  courseDirection?: InputMaybe<FilterFindManyCourseCourseDirectionOperatorsInput>;
  courseType?: InputMaybe<FilterFindManyCourseCourseTypeOperatorsInput>;
  creator?: InputMaybe<FilterFindManyCourseCreatorOperatorsInput>;
  isFreeCourse?: InputMaybe<FilterFindManyCourseIsFreeCourseOperatorsInput>;
  isRemoved?: InputMaybe<FilterFindManyCourseIsRemovedOperatorsInput>;
  language?: InputMaybe<FilterFindManyCourseLanguageOperatorsInput>;
  title?: InputMaybe<FilterFindManyCourseTitleOperatorsInput>;
};

export type FilterFindManyCourseSettingsInput = {
  brandColor?: InputMaybe<Scalars['String']['input']>;
  isAutoSelectionOfFilesWhenDragging?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoShowingOfNextFileExercise?: InputMaybe<Scalars['Boolean']['input']>;
  isBlockBreadcrumbsNavigationInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabledCompleteLessonInfoForStudent?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableModuleForTeacher?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableAutomaticTransitionToExerciseFile?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableSurveyByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isExerciseSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesListOpenedInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesOpenedInModal?: InputMaybe<Scalars['Boolean']['input']>;
  isGoNextAfterCompletionFile?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenCameraWhenSharingScreen?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenLessonIsNotCompleteButton?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenSlidesRibbonInPresentation?: InputMaybe<Scalars['Boolean']['input']>;
  isHideShowingOfExercisesInLessonCardsForStudent?: InputMaybe<Scalars['Boolean']['input']>;
  isProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  isSelectionOfAnyLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentAbilityToDrawDuringTheLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentAbilityToRecordLesson?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyCourseTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyCourse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDialogCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDialogDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  isCommonDialog?: InputMaybe<Scalars['Boolean']['input']>;
  lesson?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyDialogDialogUsersInput = {
  countOfSentMessages?: InputMaybe<Scalars['Float']['input']>;
  countOfUnreadMessages?: InputMaybe<Scalars['Float']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyDialogInput = {
  AND?: InputMaybe<Array<FilterFindManyDialogInput>>;
  OR?: InputMaybe<Array<FilterFindManyDialogInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDialogOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindManyDialogDataInput>;
  dialogUsers?: InputMaybe<Array<InputMaybe<FilterFindManyDialogDialogUsersInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDialogOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDialog_IdOperatorsInput>;
  creator?: InputMaybe<FilterFindManyDialogCreatorOperatorsInput>;
};

export type FilterFindManyDialogWithUsersInput = {
  AND?: InputMaybe<Array<FilterFindManyDialogInput>>;
  OR?: InputMaybe<Array<FilterFindManyDialogInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDialogOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindManyDialogDataInput>;
  dialogUsers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDialog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyEventCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyEventDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  lesson?: InputMaybe<Scalars['MongoID']['input']>;
  studentsGroup?: InputMaybe<Scalars['MongoID']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyEventInput = {
  AND?: InputMaybe<Array<FilterFindManyEventInput>>;
  OR?: InputMaybe<Array<FilterFindManyEventInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyEventOperatorsInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindManyEventDataInput>;
  dateTime?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyEventOperatorsInput = {
  _id?: InputMaybe<FilterFindManyEvent_IdOperatorsInput>;
  creator?: InputMaybe<FilterFindManyEventCreatorOperatorsInput>;
};

export type FilterFindManyEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyFavoriteTopicCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyFavoriteTopicEntityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyFavoriteTopicInput = {
  AND?: InputMaybe<Array<FilterFindManyFavoriteTopicInput>>;
  OR?: InputMaybe<Array<FilterFindManyFavoriteTopicInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyFavoriteTopicOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  entity?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyFavoriteTopicOperatorsInput = {
  _id?: InputMaybe<FilterFindManyFavoriteTopic_IdOperatorsInput>;
  creator?: InputMaybe<FilterFindManyFavoriteTopicCreatorOperatorsInput>;
  entity?: InputMaybe<FilterFindManyFavoriteTopicEntityOperatorsInput>;
};

export type FilterFindManyFavoriteTopic_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyFileInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FileDataInput>;
  isFolder?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyFormTemplateDataFieldsFormFieldItemsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyFormTemplateDataFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  formFieldItems?: InputMaybe<Array<InputMaybe<FilterFindManyFormTemplateDataFieldsFormFieldItemsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyFormTemplateDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FilterFindManyFormTemplateDataFieldsInput>>>;
};

export type FilterFindManyFormTemplateInput = {
  AND?: InputMaybe<Array<FilterFindManyFormTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindManyFormTemplateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyFormTemplateOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindManyFormTemplateDataInput>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyFormTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyFormTemplate_IdOperatorsInput>;
};

export type FilterFindManyFormTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyHomeTaskDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyHomeTaskInput = {
  AND?: InputMaybe<Array<FilterFindManyHomeTaskInput>>;
  OR?: InputMaybe<Array<FilterFindManyHomeTaskInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyHomeTaskOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindManyHomeTaskDataInput>;
  files?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyHomeTaskOperatorsInput = {
  _id?: InputMaybe<FilterFindManyHomeTask_IdOperatorsInput>;
};

export type FilterFindManyHomeTask_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLessonDataFilesOfExercisesFilesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLessonDataFilesOfExercisesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  exerciseId?: InputMaybe<Scalars['MongoID']['input']>;
  files?: InputMaybe<Array<InputMaybe<FilterFindManyLessonDataFilesOfExercisesFilesInput>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLessonDataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  filesOfExercises?: InputMaybe<Array<InputMaybe<FilterFindManyLessonDataFilesOfExercisesInput>>>;
  homeTaskStatus?: InputMaybe<Scalars['String']['input']>;
  isZeroLesson?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyLessonExerciseDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  isTodo?: InputMaybe<Scalars['Boolean']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyLessonExerciseFilesStatusesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLessonExerciseInput = {
  AND?: InputMaybe<Array<FilterFindManyLessonExerciseInput>>;
  OR?: InputMaybe<Array<FilterFindManyLessonExerciseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLessonExerciseOperatorsInput>;
  attachments?: InputMaybe<Array<InputMaybe<FilterFindManyFileInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindManyLessonExerciseDataInput>;
  files?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  filesStatuses?: InputMaybe<Array<InputMaybe<FilterFindManyLessonExerciseFilesStatusesInput>>>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<FilterFindManyFileInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  originalLessonExercise?: InputMaybe<Scalars['MongoID']['input']>;
  slides?: InputMaybe<Array<InputMaybe<FilterFindManyLessonExerciseSlidesInput>>>;
  thumbnail?: InputMaybe<FilterFindManyFileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<FilterFindManyFileInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLessonExerciseOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLessonExercise_IdOperatorsInput>;
};

export type FilterFindManyLessonExerciseSlidesInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  slide?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyLessonExercise_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLessonHomeTaskOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLessonInput = {
  AND?: InputMaybe<Array<FilterFindManyLessonInput>>;
  OR?: InputMaybe<Array<FilterFindManyLessonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLessonOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<FilterFindManyFileInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindManyLessonDataInput>;
  files?: InputMaybe<Array<InputMaybe<FilterFindManyFileInput>>>;
  homeTask?: InputMaybe<Scalars['MongoID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<FilterFindManyFileInput>;
  lessonExercises?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesAboutStudent?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  studentMark?: InputMaybe<Scalars['Float']['input']>;
  studentSurvey?: InputMaybe<Array<InputMaybe<Array<InputMaybe<FilterFindManyLessonStudentSurveyInput>>>>>;
  thumbnail?: InputMaybe<FilterFindManyFileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoCallStatus?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<FilterFindManyFileInput>>>;
  workOnHomeTask?: InputMaybe<FilterFindManyLessonWorkOnHomeTaskInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLessonOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLesson_IdOperatorsInput>;
  homeTask?: InputMaybe<FilterFindManyLessonHomeTaskOperatorsInput>;
};

export type FilterFindManyLessonStudentSurveyInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLessonTemplateInput = {
  AND?: InputMaybe<Array<FilterFindManyLessonTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindManyLessonTemplateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLessonTemplateOperatorsInput>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isPersonalLessonTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherLessonTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLessonTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLessonTemplate_IdOperatorsInput>;
};

export type FilterFindManyLessonTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLessonWorkOnHomeTaskInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyLesson_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMessageCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMessageDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exerciseSerialNumber?: InputMaybe<Scalars['Float']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lessonSerialNumber?: InputMaybe<Scalars['Float']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyMessageDialogOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMessageInput = {
  AND?: InputMaybe<Array<FilterFindManyMessageInput>>;
  OR?: InputMaybe<Array<FilterFindManyMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyMessageOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindManyMessageDataInput>;
  dialog?: InputMaybe<Scalars['MongoID']['input']>;
  isMetaMessage?: InputMaybe<Scalars['Boolean']['input']>;
  isReadBySomeone?: InputMaybe<Scalars['Boolean']['input']>;
  messageUsers?: InputMaybe<Array<InputMaybe<FilterFindManyMessageMessageUsersInput>>>;
  repliedMessage?: InputMaybe<Scalars['MongoID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyMessageMessageUsersInput = {
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyMessageOperatorsInput = {
  _id?: InputMaybe<FilterFindManyMessage_IdOperatorsInput>;
  creator?: InputMaybe<FilterFindManyMessageCreatorOperatorsInput>;
  dialog?: InputMaybe<FilterFindManyMessageDialogOperatorsInput>;
};

export type FilterFindManyMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMetricValueContextInput = {
  exerciseSerialNumber?: InputMaybe<Scalars['Float']['input']>;
  lessonSerialNumber?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyMetricValueCourseCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMetricValueCourseOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMetricValueCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyMetricValueCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMetricValueInput = {
  AND?: InputMaybe<Array<FilterFindManyMetricValueInput>>;
  OR?: InputMaybe<Array<FilterFindManyMetricValueInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyMetricValueOperatorsInput>;
  context?: InputMaybe<FilterFindManyMetricValueContextInput>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  lesson?: InputMaybe<Scalars['MongoID']['input']>;
  lessonExercise?: InputMaybe<Scalars['MongoID']['input']>;
  metricDefinition?: InputMaybe<Scalars['MongoID']['input']>;
  metricKey?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<EnumMetricValueSource>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  valueJson?: InputMaybe<Scalars['JSON']['input']>;
  valueNumber?: InputMaybe<Scalars['Float']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyMetricValueLessonExerciseOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMetricValueLessonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMetricValueMetricDefinitionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMetricValueMetricKeyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyMetricValueOperatorsInput = {
  _id?: InputMaybe<FilterFindManyMetricValue_IdOperatorsInput>;
  course?: InputMaybe<FilterFindManyMetricValueCourseOperatorsInput>;
  courseCategory?: InputMaybe<FilterFindManyMetricValueCourseCategoryOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyMetricValueCreatedAtOperatorsInput>;
  creator?: InputMaybe<FilterFindManyMetricValueCreatorOperatorsInput>;
  lesson?: InputMaybe<FilterFindManyMetricValueLessonOperatorsInput>;
  lessonExercise?: InputMaybe<FilterFindManyMetricValueLessonExerciseOperatorsInput>;
  metricDefinition?: InputMaybe<FilterFindManyMetricValueMetricDefinitionOperatorsInput>;
  metricKey?: InputMaybe<FilterFindManyMetricValueMetricKeyOperatorsInput>;
  student?: InputMaybe<FilterFindManyMetricValueStudentOperatorsInput>;
};

export type FilterFindManyMetricValueStudentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMetricValue_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPostAliasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPostCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPostInput = {
  AND?: InputMaybe<Array<FilterFindManyPostInput>>;
  OR?: InputMaybe<Array<FilterFindManyPostInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPostOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['MongoID']['input']>;
  categoryAlias?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  countOfVotes?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<FilterFindManyFileInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  tagAlias?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  thumbnail?: InputMaybe<FilterFindManyFileInput>;
  timeForReading?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** Search by regExp */
  titleRegexp?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  voteRate?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPostOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPost_IdOperatorsInput>;
  alias?: InputMaybe<FilterFindManyPostAliasOperatorsInput>;
  category?: InputMaybe<FilterFindManyPostCategoryOperatorsInput>;
  title?: InputMaybe<FilterFindManyPostTitleOperatorsInput>;
};

export type FilterFindManyPostTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPost_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySubscriptionInput = {
  AND?: InputMaybe<Array<FilterFindManySubscriptionInput>>;
  OR?: InputMaybe<Array<FilterFindManySubscriptionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySubscriptionOperatorsInput>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  codeForUnsubscribe?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isUnsubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySubscriptionOperatorsInput = {
  _id?: InputMaybe<FilterFindManySubscription_IdOperatorsInput>;
};

export type FilterFindManySubscription_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTagInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyUserCodeForActivationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserCodeForResetPasswordOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserCompanyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserCoursesCompleteCourseCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyUserCoursesCourseCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserCoursesDataOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserCoursesInput = {
  completeCourseCategories?: InputMaybe<Array<InputMaybe<FilterFindManyUserCoursesCompleteCourseCategoriesInput>>>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  currentLesson?: InputMaybe<Scalars['MongoID']['input']>;
  currentLessonExercise?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Scalars['MongoID']['input']>;
  isFinishedCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isPurchasedCourse?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  manager?: InputMaybe<Scalars['MongoID']['input']>;
  paymentData?: InputMaybe<FilterFindManyUserCoursesPaymentDataInput>;
  teacher?: InputMaybe<Scalars['MongoID']['input']>;
  zeroLessonDateTime?: InputMaybe<Scalars['Date']['input']>;
  zeroLessonStatus?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyUserCoursesManagerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserCoursesOperatorsInput = {
  courseCategory?: InputMaybe<FilterFindManyUserCoursesCourseCategoryOperatorsInput>;
  data?: InputMaybe<FilterFindManyUserCoursesDataOperatorsInput>;
  manager?: InputMaybe<FilterFindManyUserCoursesManagerOperatorsInput>;
  teacher?: InputMaybe<FilterFindManyUserCoursesTeacherOperatorsInput>;
};

export type FilterFindManyUserCoursesPaymentDataInput = {
  acq_id?: InputMaybe<Scalars['Float']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_credit?: InputMaybe<Scalars['Float']['input']>;
  card_mask?: InputMaybe<Scalars['String']['input']>;
  create_date?: InputMaybe<Scalars['Date']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  liqpay_order_id?: InputMaybe<Scalars['String']['input']>;
  payment_id?: InputMaybe<Scalars['Float']['input']>;
  transaction_id?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyUserCoursesTeacherOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserDbIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserFacebookIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserFirstNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserGroupCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserGroupDataCompleteCourseCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyUserGroupDataInput = {
  completeCourseCategories?: InputMaybe<Array<InputMaybe<FilterFindManyUserGroupDataCompleteCourseCategoriesInput>>>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  teacher?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyUserGroupInput = {
  AND?: InputMaybe<Array<FilterFindManyUserGroupInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserGroupOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindManyUserGroupDataInput>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<FilterFindManyUserGroupUsersInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUserGroup_IdOperatorsInput>;
  creator?: InputMaybe<FilterFindManyUserGroupCreatorOperatorsInput>;
};

export type FilterFindManyUserGroupUsersInput = {
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyUserGroupWithUsersInput = {
  AND?: InputMaybe<Array<FilterFindManyUserGroupInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserGroupOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindManyUserGroupDataInput>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  manager?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserInput = {
  AND?: InputMaybe<Array<FilterFindManyUserInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserOperatorsInput>;
  age?: InputMaybe<Scalars['Float']['input']>;
  avatar?: InputMaybe<FilterFindManyFileInput>;
  codeForActivation?: InputMaybe<Scalars['String']['input']>;
  codeForResetPassword?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['MongoID']['input']>;
  countOfSentMessages?: InputMaybe<Scalars['Float']['input']>;
  countOfUnreadMessages?: InputMaybe<Scalars['Float']['input']>;
  courses?: InputMaybe<Array<InputMaybe<FilterFindManyUserCoursesInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dbId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  isSubscribedToPosts?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperTeacherMode?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['MongoID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  registeredBy?: InputMaybe<Scalars['MongoID']['input']>;
  role?: InputMaybe<EnumUserRole>;
  subscriptions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  teacher?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userOnboarding?: InputMaybe<FilterFindManyUserUserOnboardingInput>;
};

export type FilterFindManyUserIsActivatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyUserIsRemovedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyUserIsSubscribedToPostsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyUserLastNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserLoginOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUser_IdOperatorsInput>;
  codeForActivation?: InputMaybe<FilterFindManyUserCodeForActivationOperatorsInput>;
  codeForResetPassword?: InputMaybe<FilterFindManyUserCodeForResetPasswordOperatorsInput>;
  company?: InputMaybe<FilterFindManyUserCompanyOperatorsInput>;
  courses?: InputMaybe<FilterFindManyUserCoursesOperatorsInput>;
  dbId?: InputMaybe<FilterFindManyUserDbIdOperatorsInput>;
  email?: InputMaybe<FilterFindManyUserEmailOperatorsInput>;
  facebookId?: InputMaybe<FilterFindManyUserFacebookIdOperatorsInput>;
  firstName?: InputMaybe<FilterFindManyUserFirstNameOperatorsInput>;
  isActivated?: InputMaybe<FilterFindManyUserIsActivatedOperatorsInput>;
  isRemoved?: InputMaybe<FilterFindManyUserIsRemovedOperatorsInput>;
  isSubscribedToPosts?: InputMaybe<FilterFindManyUserIsSubscribedToPostsOperatorsInput>;
  lastName?: InputMaybe<FilterFindManyUserLastNameOperatorsInput>;
  login?: InputMaybe<FilterFindManyUserLoginOperatorsInput>;
  phone?: InputMaybe<FilterFindManyUserPhoneOperatorsInput>;
  provider?: InputMaybe<FilterFindManyUserProviderOperatorsInput>;
  registeredBy?: InputMaybe<FilterFindManyUserRegisteredByOperatorsInput>;
  role?: InputMaybe<FilterFindManyUserRoleOperatorsInput>;
};

export type FilterFindManyUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserProviderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserRegisteredByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserRoleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserRole>;
  gte?: InputMaybe<EnumUserRole>;
  in?: InputMaybe<Array<InputMaybe<EnumUserRole>>>;
  lt?: InputMaybe<EnumUserRole>;
  lte?: InputMaybe<EnumUserRole>;
  ne?: InputMaybe<EnumUserRole>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserRole>>>;
};

export type FilterFindManyUserUserOnboardingInput = {
  videoCourse?: InputMaybe<FilterFindManyUserUserOnboardingVideoCourseInput>;
};

export type FilterFindManyUserUserOnboardingVideoCourseInput = {
  modulePlayer?: InputMaybe<FilterFindManyUserUserOnboardingVideoCourseModulePlayerInput>;
};

export type FilterFindManyUserUserOnboardingVideoCourseModulePlayerInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  lastStep?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyVoteCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyVoteInput = {
  AND?: InputMaybe<Array<FilterFindManyVoteInput>>;
  OR?: InputMaybe<Array<FilterFindManyVoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVoteOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  voteRate?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVoteOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVote_IdOperatorsInput>;
  creator?: InputMaybe<FilterFindManyVoteCreatorOperatorsInput>;
};

export type FilterFindManyVote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCategoryAliasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneCategoryInput = {
  AND?: InputMaybe<Array<FilterFindOneCategoryInput>>;
  OR?: InputMaybe<Array<FilterFindOneCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCategoryOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<FilterFindOneFileInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<FilterFindOneFileInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCategoryOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCategory_IdOperatorsInput>;
  alias?: InputMaybe<FilterFindOneCategoryAliasOperatorsInput>;
};

export type FilterFindOneCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCompanyCourseDirectionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  courseDirectionName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneCompanyInput = {
  AND?: InputMaybe<Array<FilterFindOneCompanyInput>>;
  OR?: InputMaybe<Array<FilterFindOneCompanyInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCompanyOperatorsInput>;
  courseDirections?: InputMaybe<Array<InputMaybe<FilterFindOneCompanyCourseDirectionsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<FilterFindOneCompanySettingsInput>;
  thumbnail?: InputMaybe<FilterFindOneFileInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCompanyOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCompany_IdOperatorsInput>;
};

export type FilterFindOneCompanySettingsInput = {
  isShowCompanyLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneCompany_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneConsultationInput = {
  AND?: InputMaybe<Array<FilterFindOneConsultationInput>>;
  OR?: InputMaybe<Array<FilterFindOneConsultationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneConsultationOperatorsInput>;
  consultationStatus?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['MongoID']['input']>;
  isConsulted?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneConsultationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneConsultation_IdOperatorsInput>;
};

export type FilterFindOneConsultation_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCourseAliasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneCourseCategoryDataInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  isCommonCourseCategory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneCourseCategoryInput = {
  AND?: InputMaybe<Array<FilterFindOneCourseCategoryInput>>;
  OR?: InputMaybe<Array<FilterFindOneCourseCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCourseCategoryOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindOneCourseCategoryDataInput>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<FilterFindOneFileInput>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCourseCategoryOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCourseCategory_IdOperatorsInput>;
};

export type FilterFindOneCourseCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCourseCourseDirectionOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCourseCourseTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCourseCourseType>;
  gte?: InputMaybe<EnumCourseCourseType>;
  in?: InputMaybe<Array<InputMaybe<EnumCourseCourseType>>>;
  lt?: InputMaybe<EnumCourseCourseType>;
  lte?: InputMaybe<EnumCourseCourseType>;
  ne?: InputMaybe<EnumCourseCourseType>;
  nin?: InputMaybe<Array<InputMaybe<EnumCourseCourseType>>>;
};

export type FilterFindOneCourseCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCourseInput = {
  AND?: InputMaybe<Array<FilterFindOneCourseInput>>;
  OR?: InputMaybe<Array<FilterFindOneCourseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCourseOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  countOfVotes?: InputMaybe<Scalars['Float']['input']>;
  courseDirection?: InputMaybe<Scalars['MongoID']['input']>;
  courseType?: InputMaybe<EnumCourseCourseType>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<InputMaybe<FilterFindOneFileInput>>>;
  image?: InputMaybe<FilterFindOneFileInput>;
  isFreeCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialLessons?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<EnumCourseLanguage>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<FilterFindOneCourseSettingsInput>;
  tags?: InputMaybe<Array<InputMaybe<FilterFindOneTagInput>>>;
  thumbnail?: InputMaybe<FilterFindOneFileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalModules?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  videos?: InputMaybe<Array<InputMaybe<FilterFindOneFileInput>>>;
  voteRate?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneCourseIsFreeCourseOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindOneCourseIsRemovedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindOneCourseLanguageOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumCourseLanguage>;
  gte?: InputMaybe<EnumCourseLanguage>;
  in?: InputMaybe<Array<InputMaybe<EnumCourseLanguage>>>;
  lt?: InputMaybe<EnumCourseLanguage>;
  lte?: InputMaybe<EnumCourseLanguage>;
  ne?: InputMaybe<EnumCourseLanguage>;
  nin?: InputMaybe<Array<InputMaybe<EnumCourseLanguage>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCourseOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCourse_IdOperatorsInput>;
  alias?: InputMaybe<FilterFindOneCourseAliasOperatorsInput>;
  courseDirection?: InputMaybe<FilterFindOneCourseCourseDirectionOperatorsInput>;
  courseType?: InputMaybe<FilterFindOneCourseCourseTypeOperatorsInput>;
  creator?: InputMaybe<FilterFindOneCourseCreatorOperatorsInput>;
  isFreeCourse?: InputMaybe<FilterFindOneCourseIsFreeCourseOperatorsInput>;
  isRemoved?: InputMaybe<FilterFindOneCourseIsRemovedOperatorsInput>;
  language?: InputMaybe<FilterFindOneCourseLanguageOperatorsInput>;
  title?: InputMaybe<FilterFindOneCourseTitleOperatorsInput>;
};

export type FilterFindOneCourseSettingsInput = {
  brandColor?: InputMaybe<Scalars['String']['input']>;
  isAutoSelectionOfFilesWhenDragging?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoShowingOfNextFileExercise?: InputMaybe<Scalars['Boolean']['input']>;
  isBlockBreadcrumbsNavigationInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabledCompleteLessonInfoForStudent?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableModuleForTeacher?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableAutomaticTransitionToExerciseFile?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableSurveyByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isExerciseSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesListOpenedInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesOpenedInModal?: InputMaybe<Scalars['Boolean']['input']>;
  isGoNextAfterCompletionFile?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenCameraWhenSharingScreen?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenLessonIsNotCompleteButton?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenSlidesRibbonInPresentation?: InputMaybe<Scalars['Boolean']['input']>;
  isHideShowingOfExercisesInLessonCardsForStudent?: InputMaybe<Scalars['Boolean']['input']>;
  isProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  isSelectionOfAnyLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentAbilityToDrawDuringTheLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentAbilityToRecordLesson?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneCourseTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneCourse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDialogCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDialogDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  isCommonDialog?: InputMaybe<Scalars['Boolean']['input']>;
  lesson?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneDialogDialogUsersInput = {
  countOfSentMessages?: InputMaybe<Scalars['Float']['input']>;
  countOfUnreadMessages?: InputMaybe<Scalars['Float']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneDialogInput = {
  AND?: InputMaybe<Array<FilterFindOneDialogInput>>;
  OR?: InputMaybe<Array<FilterFindOneDialogInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDialogOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindOneDialogDataInput>;
  dialogUsers?: InputMaybe<Array<InputMaybe<FilterFindOneDialogDialogUsersInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneDialogOperatorsInput = {
  _id?: InputMaybe<FilterFindOneDialog_IdOperatorsInput>;
  creator?: InputMaybe<FilterFindOneDialogCreatorOperatorsInput>;
};

export type FilterFindOneDialog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneEventCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneEventDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  lesson?: InputMaybe<Scalars['MongoID']['input']>;
  studentsGroup?: InputMaybe<Scalars['MongoID']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneEventInput = {
  AND?: InputMaybe<Array<FilterFindOneEventInput>>;
  OR?: InputMaybe<Array<FilterFindOneEventInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneEventOperatorsInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindOneEventDataInput>;
  dateTime?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneEventOperatorsInput = {
  _id?: InputMaybe<FilterFindOneEvent_IdOperatorsInput>;
  creator?: InputMaybe<FilterFindOneEventCreatorOperatorsInput>;
};

export type FilterFindOneEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneFavoriteTopicCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneFavoriteTopicEntityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneFavoriteTopicInput = {
  AND?: InputMaybe<Array<FilterFindOneFavoriteTopicInput>>;
  OR?: InputMaybe<Array<FilterFindOneFavoriteTopicInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneFavoriteTopicOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  entity?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneFavoriteTopicOperatorsInput = {
  _id?: InputMaybe<FilterFindOneFavoriteTopic_IdOperatorsInput>;
  creator?: InputMaybe<FilterFindOneFavoriteTopicCreatorOperatorsInput>;
  entity?: InputMaybe<FilterFindOneFavoriteTopicEntityOperatorsInput>;
};

export type FilterFindOneFavoriteTopic_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneFileInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FileDataInput>;
  isFolder?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindOneFormTemplateDataFieldsFormFieldItemsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneFormTemplateDataFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  formFieldItems?: InputMaybe<Array<InputMaybe<FilterFindOneFormTemplateDataFieldsFormFieldItemsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneFormTemplateDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FilterFindOneFormTemplateDataFieldsInput>>>;
};

export type FilterFindOneFormTemplateInput = {
  AND?: InputMaybe<Array<FilterFindOneFormTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindOneFormTemplateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneFormTemplateOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindOneFormTemplateDataInput>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneFormTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindOneFormTemplate_IdOperatorsInput>;
};

export type FilterFindOneFormTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneHomeTaskDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneHomeTaskInput = {
  AND?: InputMaybe<Array<FilterFindOneHomeTaskInput>>;
  OR?: InputMaybe<Array<FilterFindOneHomeTaskInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneHomeTaskOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindOneHomeTaskDataInput>;
  files?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneHomeTaskOperatorsInput = {
  _id?: InputMaybe<FilterFindOneHomeTask_IdOperatorsInput>;
};

export type FilterFindOneHomeTask_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneLessonDataFilesOfExercisesFilesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneLessonDataFilesOfExercisesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  exerciseId?: InputMaybe<Scalars['MongoID']['input']>;
  files?: InputMaybe<Array<InputMaybe<FilterFindOneLessonDataFilesOfExercisesFilesInput>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneLessonDataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  filesOfExercises?: InputMaybe<Array<InputMaybe<FilterFindOneLessonDataFilesOfExercisesInput>>>;
  homeTaskStatus?: InputMaybe<Scalars['String']['input']>;
  isZeroLesson?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneLessonExerciseDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  isTodo?: InputMaybe<Scalars['Boolean']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneLessonExerciseFilesStatusesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneLessonExerciseInput = {
  AND?: InputMaybe<Array<FilterFindOneLessonExerciseInput>>;
  OR?: InputMaybe<Array<FilterFindOneLessonExerciseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneLessonExerciseOperatorsInput>;
  attachments?: InputMaybe<Array<InputMaybe<FilterFindOneFileInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindOneLessonExerciseDataInput>;
  files?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  filesStatuses?: InputMaybe<Array<InputMaybe<FilterFindOneLessonExerciseFilesStatusesInput>>>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<FilterFindOneFileInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  originalLessonExercise?: InputMaybe<Scalars['MongoID']['input']>;
  slides?: InputMaybe<Array<InputMaybe<FilterFindOneLessonExerciseSlidesInput>>>;
  thumbnail?: InputMaybe<FilterFindOneFileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<FilterFindOneFileInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneLessonExerciseOperatorsInput = {
  _id?: InputMaybe<FilterFindOneLessonExercise_IdOperatorsInput>;
};

export type FilterFindOneLessonExerciseSlidesInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  slide?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneLessonExercise_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneLessonHomeTaskOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneLessonInput = {
  AND?: InputMaybe<Array<FilterFindOneLessonInput>>;
  OR?: InputMaybe<Array<FilterFindOneLessonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneLessonOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<FilterFindOneFileInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindOneLessonDataInput>;
  files?: InputMaybe<Array<InputMaybe<FilterFindOneFileInput>>>;
  homeTask?: InputMaybe<Scalars['MongoID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<FilterFindOneFileInput>;
  lessonExercises?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesAboutStudent?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  studentMark?: InputMaybe<Scalars['Float']['input']>;
  studentSurvey?: InputMaybe<Array<InputMaybe<Array<InputMaybe<FilterFindOneLessonStudentSurveyInput>>>>>;
  thumbnail?: InputMaybe<FilterFindOneFileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoCallStatus?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<FilterFindOneFileInput>>>;
  workOnHomeTask?: InputMaybe<FilterFindOneLessonWorkOnHomeTaskInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneLessonOperatorsInput = {
  _id?: InputMaybe<FilterFindOneLesson_IdOperatorsInput>;
  homeTask?: InputMaybe<FilterFindOneLessonHomeTaskOperatorsInput>;
};

export type FilterFindOneLessonStudentSurveyInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneLessonTemplateInput = {
  AND?: InputMaybe<Array<FilterFindOneLessonTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindOneLessonTemplateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneLessonTemplateOperatorsInput>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isPersonalLessonTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherLessonTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneLessonTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindOneLessonTemplate_IdOperatorsInput>;
};

export type FilterFindOneLessonTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneLessonWorkOnHomeTaskInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneLesson_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneMessageCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneMessageDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exerciseSerialNumber?: InputMaybe<Scalars['Float']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lessonSerialNumber?: InputMaybe<Scalars['Float']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneMessageDialogOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneMessageInput = {
  AND?: InputMaybe<Array<FilterFindOneMessageInput>>;
  OR?: InputMaybe<Array<FilterFindOneMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneMessageOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindOneMessageDataInput>;
  dialog?: InputMaybe<Scalars['MongoID']['input']>;
  isMetaMessage?: InputMaybe<Scalars['Boolean']['input']>;
  isReadBySomeone?: InputMaybe<Scalars['Boolean']['input']>;
  messageUsers?: InputMaybe<Array<InputMaybe<FilterFindOneMessageMessageUsersInput>>>;
  repliedMessage?: InputMaybe<Scalars['MongoID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneMessageMessageUsersInput = {
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneMessageOperatorsInput = {
  _id?: InputMaybe<FilterFindOneMessage_IdOperatorsInput>;
  creator?: InputMaybe<FilterFindOneMessageCreatorOperatorsInput>;
  dialog?: InputMaybe<FilterFindOneMessageDialogOperatorsInput>;
};

export type FilterFindOneMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePostAliasOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOnePostCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePostInput = {
  AND?: InputMaybe<Array<FilterFindOnePostInput>>;
  OR?: InputMaybe<Array<FilterFindOnePostInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePostOperatorsInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  countOfVotes?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<FilterFindOneFileInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  thumbnail?: InputMaybe<FilterFindOneFileInput>;
  timeForReading?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  voteRate?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePostOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePost_IdOperatorsInput>;
  alias?: InputMaybe<FilterFindOnePostAliasOperatorsInput>;
  category?: InputMaybe<FilterFindOnePostCategoryOperatorsInput>;
  title?: InputMaybe<FilterFindOnePostTitleOperatorsInput>;
};

export type FilterFindOnePostTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOnePost_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSubscriptionInput = {
  AND?: InputMaybe<Array<FilterFindOneSubscriptionInput>>;
  OR?: InputMaybe<Array<FilterFindOneSubscriptionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSubscriptionOperatorsInput>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  codeForUnsubscribe?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isUnsubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneSubscriptionOperatorsInput = {
  _id?: InputMaybe<FilterFindOneSubscription_IdOperatorsInput>;
};

export type FilterFindOneSubscription_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneTagInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneUserCodeForActivationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserCodeForResetPasswordOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserCompanyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserCoursesCompleteCourseCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneUserCoursesCourseCategoryOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserCoursesDataOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserCoursesInput = {
  completeCourseCategories?: InputMaybe<Array<InputMaybe<FilterFindOneUserCoursesCompleteCourseCategoriesInput>>>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  currentLesson?: InputMaybe<Scalars['MongoID']['input']>;
  currentLessonExercise?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Scalars['MongoID']['input']>;
  isFinishedCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isPurchasedCourse?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  manager?: InputMaybe<Scalars['MongoID']['input']>;
  paymentData?: InputMaybe<FilterFindOneUserCoursesPaymentDataInput>;
  teacher?: InputMaybe<Scalars['MongoID']['input']>;
  zeroLessonDateTime?: InputMaybe<Scalars['Date']['input']>;
  zeroLessonStatus?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneUserCoursesManagerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserCoursesOperatorsInput = {
  courseCategory?: InputMaybe<FilterFindOneUserCoursesCourseCategoryOperatorsInput>;
  data?: InputMaybe<FilterFindOneUserCoursesDataOperatorsInput>;
  manager?: InputMaybe<FilterFindOneUserCoursesManagerOperatorsInput>;
  teacher?: InputMaybe<FilterFindOneUserCoursesTeacherOperatorsInput>;
};

export type FilterFindOneUserCoursesPaymentDataInput = {
  acq_id?: InputMaybe<Scalars['Float']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_credit?: InputMaybe<Scalars['Float']['input']>;
  card_mask?: InputMaybe<Scalars['String']['input']>;
  create_date?: InputMaybe<Scalars['Date']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  liqpay_order_id?: InputMaybe<Scalars['String']['input']>;
  payment_id?: InputMaybe<Scalars['Float']['input']>;
  transaction_id?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneUserCoursesTeacherOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserDbIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserFacebookIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserFirstNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserGroupCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserGroupDataCompleteCourseCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneUserGroupDataInput = {
  completeCourseCategories?: InputMaybe<Array<InputMaybe<FilterFindOneUserGroupDataCompleteCourseCategoriesInput>>>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  teacher?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneUserGroupInput = {
  AND?: InputMaybe<Array<FilterFindOneUserGroupInput>>;
  OR?: InputMaybe<Array<FilterFindOneUserGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneUserGroupOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FilterFindOneUserGroupDataInput>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<FilterFindOneUserGroupUsersInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUserGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindOneUserGroup_IdOperatorsInput>;
  creator?: InputMaybe<FilterFindOneUserGroupCreatorOperatorsInput>;
};

export type FilterFindOneUserGroupUsersInput = {
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneUserGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserInput = {
  AND?: InputMaybe<Array<FilterFindOneUserInput>>;
  OR?: InputMaybe<Array<FilterFindOneUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneUserOperatorsInput>;
  age?: InputMaybe<Scalars['Float']['input']>;
  avatar?: InputMaybe<FilterFindOneFileInput>;
  codeForActivation?: InputMaybe<Scalars['String']['input']>;
  codeForResetPassword?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['MongoID']['input']>;
  countOfSentMessages?: InputMaybe<Scalars['Float']['input']>;
  countOfUnreadMessages?: InputMaybe<Scalars['Float']['input']>;
  courses?: InputMaybe<Array<InputMaybe<FilterFindOneUserCoursesInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dbId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  isSubscribedToPosts?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperTeacherMode?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  registeredBy?: InputMaybe<Scalars['MongoID']['input']>;
  role?: InputMaybe<EnumUserRole>;
  subscriptions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userOnboarding?: InputMaybe<FilterFindOneUserUserOnboardingInput>;
};

export type FilterFindOneUserIsActivatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindOneUserIsRemovedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindOneUserIsSubscribedToPostsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindOneUserLastNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserLoginOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUserOperatorsInput = {
  _id?: InputMaybe<FilterFindOneUser_IdOperatorsInput>;
  codeForActivation?: InputMaybe<FilterFindOneUserCodeForActivationOperatorsInput>;
  codeForResetPassword?: InputMaybe<FilterFindOneUserCodeForResetPasswordOperatorsInput>;
  company?: InputMaybe<FilterFindOneUserCompanyOperatorsInput>;
  courses?: InputMaybe<FilterFindOneUserCoursesOperatorsInput>;
  dbId?: InputMaybe<FilterFindOneUserDbIdOperatorsInput>;
  email?: InputMaybe<FilterFindOneUserEmailOperatorsInput>;
  facebookId?: InputMaybe<FilterFindOneUserFacebookIdOperatorsInput>;
  firstName?: InputMaybe<FilterFindOneUserFirstNameOperatorsInput>;
  isActivated?: InputMaybe<FilterFindOneUserIsActivatedOperatorsInput>;
  isRemoved?: InputMaybe<FilterFindOneUserIsRemovedOperatorsInput>;
  isSubscribedToPosts?: InputMaybe<FilterFindOneUserIsSubscribedToPostsOperatorsInput>;
  lastName?: InputMaybe<FilterFindOneUserLastNameOperatorsInput>;
  login?: InputMaybe<FilterFindOneUserLoginOperatorsInput>;
  phone?: InputMaybe<FilterFindOneUserPhoneOperatorsInput>;
  provider?: InputMaybe<FilterFindOneUserProviderOperatorsInput>;
  registeredBy?: InputMaybe<FilterFindOneUserRegisteredByOperatorsInput>;
  role?: InputMaybe<FilterFindOneUserRoleOperatorsInput>;
};

export type FilterFindOneUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserProviderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserRegisteredByOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserRoleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumUserRole>;
  gte?: InputMaybe<EnumUserRole>;
  in?: InputMaybe<Array<InputMaybe<EnumUserRole>>>;
  lt?: InputMaybe<EnumUserRole>;
  lte?: InputMaybe<EnumUserRole>;
  ne?: InputMaybe<EnumUserRole>;
  nin?: InputMaybe<Array<InputMaybe<EnumUserRole>>>;
};

export type FilterFindOneUserUserOnboardingInput = {
  videoCourse?: InputMaybe<FilterFindOneUserUserOnboardingVideoCourseInput>;
};

export type FilterFindOneUserUserOnboardingVideoCourseInput = {
  modulePlayer?: InputMaybe<FilterFindOneUserUserOnboardingVideoCourseModulePlayerInput>;
};

export type FilterFindOneUserUserOnboardingVideoCourseModulePlayerInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  lastStep?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindOneUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneVoteCreatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneVoteInput = {
  AND?: InputMaybe<Array<FilterFindOneVoteInput>>;
  OR?: InputMaybe<Array<FilterFindOneVoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneVoteOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  voteRate?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneVoteOperatorsInput = {
  _id?: InputMaybe<FilterFindOneVote_IdOperatorsInput>;
  creator?: InputMaybe<FilterFindOneVoteCreatorOperatorsInput>;
};

export type FilterFindOneVote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterPaginationByCourseAndCategoryAliasLessonInput = {
  alias: Scalars['String']['input'];
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplateId?: InputMaybe<Scalars['MongoID']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterPaginationCategoryInput = {
  isPublishedUnpublishedCategories?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export type FilterPaginationCourseCategoryInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
  teacher?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterPaginationEventInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategories?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterPaginationFileInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  folder?: InputMaybe<Scalars['MongoID']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterPaginationFormTemplateInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterPaginationLessonExerciseInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  isTodo?: InputMaybe<Scalars['Boolean']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterPaginationLessonInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterPaginationLessonTemplateInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
  superTeacher?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterPaginationPostInput = {
  categoryAlias?: InputMaybe<Scalars['String']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  isPublishedUnpublishedPosts?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  tagAlias?: InputMaybe<Scalars['String']['input']>;
  titleRegexp?: InputMaybe<Scalars['String']['input']>;
};

export type FilterPaginationUserInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  courses?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  isPaidOnPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  manager?: InputMaybe<Scalars['MongoID']['input']>;
  registeredBy?: InputMaybe<Scalars['MongoID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  teacher?: InputMaybe<Scalars['MongoID']['input']>;
  withDialogs?: InputMaybe<Scalars['Boolean']['input']>;
  withGroupUser?: InputMaybe<Scalars['Boolean']['input']>;
  withNoCourseCategory?: InputMaybe<Scalars['Boolean']['input']>;
  withZeroLessonStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FindByAliasCourseQueryType = {
  __typename?: 'FindByAliasCourseQueryType';
  _id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FileTypeTc>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Folder = {
  __typename?: 'Folder';
  id: Scalars['ID']['output'];
  isFolder: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  path: Scalars['String']['output'];
};

export type FormTemplate = {
  __typename?: 'FormTemplate';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  data?: Maybe<FormTemplateData>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type FormTemplateConnection = {
  __typename?: 'FormTemplateConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<FormTemplateEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormTemplateData = {
  __typename?: 'FormTemplateData';
  course?: Maybe<Course>;
  courseCategory?: Maybe<CourseCategory>;
  fields?: Maybe<Array<Maybe<FormTemplateDataFields>>>;
};

export type FormTemplateDataFields = {
  __typename?: 'FormTemplateDataFields';
  _id?: Maybe<Scalars['MongoID']['output']>;
  formFieldItems?: Maybe<Array<Maybe<FormTemplateDataFieldsFormFieldItems>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FormTemplateDataFieldsFormFieldItems = {
  __typename?: 'FormTemplateDataFieldsFormFieldItems';
  _id?: Maybe<Scalars['MongoID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FormTemplateDataFieldsFormFieldItemsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FormTemplateDataFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  formFieldItems?: InputMaybe<Array<InputMaybe<FormTemplateDataFieldsFormFieldItemsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FormTemplateDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FormTemplateDataFieldsInput>>>;
};

/** An edge in a connection. */
export type FormTemplateEdge = {
  __typename?: 'FormTemplateEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: FormTemplate;
};

export type FormTemplatePaginationType = {
  __typename?: 'FormTemplatePaginationType';
  items?: Maybe<Array<Maybe<FormTemplate>>>;
  pageInfo?: Maybe<PageInfoType>;
};

export type HomeTask = {
  __typename?: 'HomeTask';
  _id: Scalars['MongoID']['output'];
  course?: Maybe<Course>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  data?: Maybe<HomeTaskData>;
  files?: Maybe<Array<Maybe<File>>>;
  notes?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type HomeTaskConnection = {
  __typename?: 'HomeTaskConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<HomeTaskEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HomeTaskData = {
  __typename?: 'HomeTaskData';
  course?: Maybe<Scalars['MongoID']['output']>;
  courseCategory?: Maybe<Scalars['MongoID']['output']>;
};

/** An edge in a connection. */
export type HomeTaskEdge = {
  __typename?: 'HomeTaskEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: HomeTask;
};

/** List of items with pagination. */
export type HomeTaskPagination = {
  __typename?: 'HomeTaskPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<HomeTask>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type InitUploadFileTc = {
  __typename?: 'InitUploadFileTC';
  contentType?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
};

export type Lesson = {
  __typename?: 'Lesson';
  _id: Scalars['MongoID']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<File>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  data?: Maybe<LessonData>;
  files?: Maybe<Array<Maybe<File>>>;
  homeTask?: Maybe<HomeTask>;
  id?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<File>;
  lessonExercises?: Maybe<Array<Maybe<LessonExercise>>>;
  notes?: Maybe<Scalars['String']['output']>;
  notesAboutStudent?: Maybe<Scalars['String']['output']>;
  onlineCourse?: Maybe<Course>;
  status?: Maybe<Scalars['String']['output']>;
  student?: Maybe<User>;
  studentMark?: Maybe<Scalars['Float']['output']>;
  studentSurvey?: Maybe<Array<Maybe<StudentSurveyField>>>;
  thumbnail?: Maybe<File>;
  title?: Maybe<Scalars['String']['output']>;
  videoCallStatus?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<Maybe<File>>>;
  vote?: Maybe<Vote>;
  workOnHomeTask?: Maybe<LessonWorkOnHomeTask>;
};

export type LessonVoteArgs = {
  filter?: InputMaybe<FilterFindOneVoteInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneVoteInput>;
};

/** A connection to a list of items. */
export type LessonConnection = {
  __typename?: 'LessonConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<LessonEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LessonData = {
  __typename?: 'LessonData';
  _id?: Maybe<Scalars['MongoID']['output']>;
  course?: Maybe<Scalars['MongoID']['output']>;
  courseCategory?: Maybe<Scalars['MongoID']['output']>;
  filesOfExercises?: Maybe<Array<Maybe<LessonDataFilesOfExercises>>>;
  homeTaskStatus?: Maybe<Scalars['String']['output']>;
  isZeroLesson?: Maybe<Scalars['Boolean']['output']>;
  lessonTemplate?: Maybe<Scalars['MongoID']['output']>;
  student?: Maybe<Scalars['MongoID']['output']>;
};

export type LessonDataFilesOfExercises = {
  __typename?: 'LessonDataFilesOfExercises';
  _id?: Maybe<Scalars['MongoID']['output']>;
  exerciseId?: Maybe<Scalars['MongoID']['output']>;
  files?: Maybe<Array<Maybe<LessonDataFilesOfExercisesFiles>>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LessonDataFilesOfExercisesFiles = {
  __typename?: 'LessonDataFilesOfExercisesFiles';
  _id?: Maybe<Scalars['MongoID']['output']>;
  id?: Maybe<Scalars['MongoID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type LessonEdge = {
  __typename?: 'LessonEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Lesson;
};

export type LessonExercise = {
  __typename?: 'LessonExercise';
  _id: Scalars['MongoID']['output'];
  attachments?: Maybe<Array<Maybe<File>>>;
  course?: Maybe<Course>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  data?: Maybe<LessonExerciseData>;
  files?: Maybe<Array<Maybe<File>>>;
  filesStatuses?: Maybe<Array<Maybe<LessonExerciseFilesStatuses>>>;
  id?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<File>;
  notes?: Maybe<Scalars['String']['output']>;
  originalLessonExercise?: Maybe<LessonExercise>;
  slides?: Maybe<Array<Maybe<LessonExerciseSlides>>>;
  student?: Maybe<User>;
  thumbnail?: Maybe<File>;
  title?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<Maybe<File>>>;
};

export type LessonExerciseCourseArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCourseInput>;
};

export type LessonExerciseCreatorArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

export type LessonExerciseStudentArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

/** A connection to a list of items. */
export type LessonExerciseConnection = {
  __typename?: 'LessonExerciseConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<LessonExerciseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LessonExerciseData = {
  __typename?: 'LessonExerciseData';
  course?: Maybe<Scalars['MongoID']['output']>;
  courseCategory?: Maybe<Scalars['MongoID']['output']>;
  isShared?: Maybe<Scalars['Boolean']['output']>;
  isTodo?: Maybe<Scalars['Boolean']['output']>;
  student?: Maybe<Scalars['MongoID']['output']>;
};

export type LessonExerciseDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  isTodo?: InputMaybe<Scalars['Boolean']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

/** An edge in a connection. */
export type LessonExerciseEdge = {
  __typename?: 'LessonExerciseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: LessonExercise;
};

export type LessonExerciseFilesStatuses = {
  __typename?: 'LessonExerciseFilesStatuses';
  _id: Scalars['MongoID']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type LessonExerciseFilesStatusesInput = {
  _id: Scalars['MongoID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type LessonExercisePaginationType = {
  __typename?: 'LessonExercisePaginationType';
  items?: Maybe<Array<Maybe<LessonExercise>>>;
  pageInfo?: Maybe<PageInfoType>;
};

export type LessonExerciseSlides = {
  __typename?: 'LessonExerciseSlides';
  _id?: Maybe<Scalars['String']['output']>;
  slide?: Maybe<Scalars['Float']['output']>;
};

export type LessonExerciseSlidesInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  slide?: InputMaybe<Scalars['Float']['input']>;
};

export type LessonPaginationType = {
  __typename?: 'LessonPaginationType';
  items?: Maybe<Array<Maybe<Lesson>>>;
  pageInfo?: Maybe<PageInfoType>;
};

export type LessonTemplate = {
  __typename?: 'LessonTemplate';
  _id: Scalars['MongoID']['output'];
  course?: Maybe<Course>;
  courseCategory?: Maybe<CourseCategory>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  id?: Maybe<Scalars['Float']['output']>;
  isPersonalLessonTemplate?: Maybe<Scalars['Boolean']['output']>;
  isTeacherLessonTemplate?: Maybe<Scalars['Boolean']['output']>;
  student?: Maybe<User>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LessonTemplateStudentArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

export type LessonTemplatePaginationType = {
  __typename?: 'LessonTemplatePaginationType';
  items?: Maybe<Array<Maybe<LessonTemplate>>>;
  pageInfo?: Maybe<PageInfoType>;
};

export type LessonWorkOnHomeTask = {
  __typename?: 'LessonWorkOnHomeTask';
  notes?: Maybe<Scalars['String']['output']>;
};

export type Message = {
  __typename?: 'Message';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  data?: Maybe<MessageData>;
  dialog?: Maybe<Scalars['MongoID']['output']>;
  isMetaMessage?: Maybe<Scalars['Boolean']['output']>;
  isReadBySomeone?: Maybe<Scalars['Boolean']['output']>;
  messageUsers?: Maybe<Array<Maybe<MessageMessageUsers>>>;
  repliedMessage?: Maybe<Message>;
  text?: Maybe<Scalars['String']['output']>;
};

export type MessageCreatorArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

export type MessageRepliedMessageArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneMessageInput>;
};

/** A connection to a list of items. */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<MessageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MessageData = {
  __typename?: 'MessageData';
  course?: Maybe<Scalars['MongoID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  exerciseSerialNumber?: Maybe<Scalars['Float']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lessonSerialNumber?: Maybe<Scalars['Float']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type MessageDataInputTc = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  dialog?: InputMaybe<Scalars['MongoID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exerciseSerialNumber?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lessonSerialNumber?: InputMaybe<Scalars['Int']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Message;
};

export type MessageMessageUsers = {
  __typename?: 'MessageMessageUsers';
  isRead?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<Scalars['MongoID']['output']>;
};

export type MessagePaginationType = {
  __typename?: 'MessagePaginationType';
  items?: Maybe<Array<Maybe<Message>>>;
  pageInfo?: Maybe<PaginationType>;
};

export type MetricValue = {
  __typename?: 'MetricValue';
  _id: Scalars['MongoID']['output'];
  context?: Maybe<MetricValueContext>;
  course?: Maybe<Course>;
  courseCategory?: Maybe<Scalars['MongoID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  lesson?: Maybe<Scalars['MongoID']['output']>;
  lessonExercise?: Maybe<Scalars['MongoID']['output']>;
  metricDefinition?: Maybe<CourseMetricDefinition>;
  metricKey: Scalars['String']['output'];
  source?: Maybe<EnumMetricValueSource>;
  student?: Maybe<User>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueJson?: Maybe<Scalars['JSON']['output']>;
  valueNumber?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type MetricValueCourseArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCourseInput>;
};

export type MetricValueCreatorArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

export type MetricValueMetricDefinitionArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCourseMetricDefinitionInput>;
};

export type MetricValueStudentArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

export type MetricValueContext = {
  __typename?: 'MetricValueContext';
  exerciseSerialNumber?: Maybe<Scalars['Float']['output']>;
  lessonSerialNumber?: Maybe<Scalars['Float']['output']>;
};

export type MetricValueContextInput = {
  exerciseSerialNumber?: InputMaybe<Scalars['Int']['input']>;
  lessonSerialNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type MetricValueCreateItemInput = {
  metricDefinition: Scalars['MongoID']['input'];
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  valueJson?: InputMaybe<Scalars['JSON']['input']>;
  valueNumber?: InputMaybe<Scalars['Float']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type MongoError = ErrorInterface & {
  __typename?: 'MongoError';
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']['output']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type MoveFilesResult = {
  __typename?: 'MoveFilesResult';
  conflicts?: Maybe<Array<Scalars['String']['output']>>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  movedCount: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type MoveItemInput = {
  id: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  Upload?: Maybe<Scalars['Upload']['output']>;
  activateUserMutation?: Maybe<UpdateByIdUserPayload>;
  applyOneLessonTemplateMutation?: Maybe<ResponseStatus>;
  changePasswordUserMutation?: Maybe<UpdateByIdUserPayload>;
  completeUploadFileMutation?: Maybe<FilePartInfoDataTc>;
  copyFilesToFolderFileMutation?: Maybe<CopyFilesResult>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  createManyFileMutation?: Maybe<CreateManyFilePayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  createManyTagMutation?: Maybe<CreateManyTagPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOneCategoryMutation?: Maybe<CreateOneCategoryPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOneCompanyMutation?: Maybe<CreateOneCompanyPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOneConsultationMutation?: Maybe<CreateOneConsultationPayload>;
  createOneCopyLessonMutation?: Maybe<CreateOneLessonPayload>;
  createOneCourseCategoryMutation?: Maybe<CreateOneCourseCategoryPayload>;
  createOneCourseMetricDefinition?: Maybe<CreateOneCourseMetricDefinitionPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOneCourseMutation?: Maybe<CreateOneCoursePayload>;
  createOneDialogMutation?: Maybe<CreateOneDialogPayload>;
  createOneEventMutation?: Maybe<CreateOneEventPayload>;
  createOneFavoriteTopicMutation?: Maybe<CreateOneFavoriteTopicPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOneFileMutation?: Maybe<CreateOneFilePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOneFormTemplateMutation?: Maybe<CreateOneFormTemplatePayload>;
  createOneHomeTaskMutation?: Maybe<CreateOneHomeTaskPayload>;
  createOneLessonExerciseMutation?: Maybe<CreateOneLessonExercisePayload>;
  createOneLessonMutation?: Maybe<CreateOneLessonPayload>;
  createOneLessonTemplateMutation?: Maybe<CreateOneLessonTemplatePayload>;
  createOneMessageMutation?: Maybe<CreateOneMessagePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createOnePostMutation?: Maybe<CreateOnePostPayload>;
  createOneSubscriptionMutation?: Maybe<CreateOneSubscriptionPayload>;
  createOneUserGroupMutation?: Maybe<CreateOneUserGroupPayload>;
  createOneVoteMutation?: Maybe<CreateOneVotePayload>;
  findCreateManyTagMutation?: Maybe<FindCreateManyTagMutation>;
  generateContentLessonMutation?: Maybe<CreateContentDataTc>;
  initUploadFileMutation?: Maybe<InitUploadFileTc>;
  moveFilesAndFoldersMutation?: Maybe<MoveFilesResult>;
  navigationOnBehalfUserMutation?: Maybe<NavigationOnBehalfPayload>;
  registerUserMutation?: Maybe<CreateOneUserPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdCategoryMutation?: Maybe<RemoveByIdCategoryPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdCompanyMutation?: Maybe<RemoveByIdCompanyPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdConsultationMutation?: Maybe<RemoveByIdConsultationPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdCourseCategoryMutation?: Maybe<RemoveByIdCourseCategoryPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdCourseMetricDefinition?: Maybe<RemoveByIdCourseMetricDefinitionPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdCourseMutation?: Maybe<RemoveByIdCoursePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdDialogMutation?: Maybe<RemoveByIdDialogPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdEventMutation?: Maybe<RemoveByIdEventPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdFormTemplateMutation?: Maybe<RemoveByIdFormTemplatePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdHomeTaskMutation?: Maybe<RemoveByIdHomeTaskPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdLessonExerciseMutation?: Maybe<RemoveByIdLessonExercisePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdLessonMutation?: Maybe<RemoveByIdLessonPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdLessonTemplateMutation?: Maybe<RemoveByIdLessonTemplatePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdPostMutation?: Maybe<RemoveByIdPostPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdUserGroupMutation?: Maybe<RemoveByIdUserGroupPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  removeByIdUserMutation?: Maybe<RemoveByIdUserPayload>;
  removeByPathFileMutation?: Maybe<RemoveByPathFilesFolderFileDataTc>;
  removeManyFileMutation?: Maybe<RemoveManyFileResult>;
  removeManyLessonExerciseMutation?: Maybe<RemoveManyLessonExerciseTc>;
  resetPasswordRequestUserMutation?: Maybe<UpdateByIdUserPayload>;
  resetPasswordUserMutation?: Maybe<UpdateByIdUserPayload>;
  saveManyMetricValues?: Maybe<Array<Maybe<MetricValue>>>;
  signInUserMutation?: Maybe<UpdateByIdUserPayload>;
  signOutUserMutation?: Maybe<EmptyType>;
  signUpForPaymentUserMutation?: Maybe<CreateOneUserPayload>;
  signUpUserMutation?: Maybe<UpdateResponseType>;
  startCourseUserMutation?: Maybe<UpdateByIdUserPayload>;
  unsubscribeSubscriptionMutation?: Maybe<RemoveOneSubscriptionPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdCategoryMutation?: Maybe<UpdateByIdCategoryPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdCompanyMutation?: Maybe<UpdateByIdCompanyPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdConsultationMutation?: Maybe<UpdateByIdConsultationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdCourseCategoryMutation?: Maybe<UpdateByIdCourseCategoryPayload>;
  updateByIdCourseMetricDefinition?: Maybe<UpdateByIdCourseMetricDefinitionPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdCourseMutation?: Maybe<UpdateByIdCoursePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdEventMutation?: Maybe<UpdateByIdEventPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdFileMutation?: Maybe<UpdateByIdFilePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdFormTemplateMutation?: Maybe<UpdateByIdFormTemplatePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdHomeTaskMutation?: Maybe<UpdateByIdHomeTaskPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdLessonExerciseMutation?: Maybe<UpdateByIdLessonExercisePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdLessonMutation?: Maybe<UpdateByIdLessonPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdLessonTemplateMutation?: Maybe<UpdateByIdLessonTemplatePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdPostMutation?: Maybe<UpdateByIdPostPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdUserGroupMutation?: Maybe<UpdateByIdUserGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  updateByIdUserMutation?: Maybe<UpdateByIdUserPayload>;
  updateCourseIntroStatusUserMutation?: Maybe<EmptyType>;
  updateCurrentLessonAndLessonExerciseOfModuleUserMutation?: Maybe<EmptyType>;
  updateFilesFolderFileMutation?: Maybe<UpdateFilesFolderFileDataTc>;
  updateOneLessonTemplateMutation?: Maybe<UpdateOneLessonTemplatePayload>;
  updateOrderCourseCategoryMutation?: Maybe<CourseCategoryType>;
  updateOrderExerciseLessonMutation?: Maybe<CreateOneLessonPayload>;
  updateOrderLessonMutation?: Maybe<CreateOneLessonPayload>;
  updateStudentLevelUserGroupMutation?: Maybe<UpdateStudentLevelUserGroupType>;
  updateStudentLevelUserMutation?: Maybe<UpdateStudentLevelCourseUserType>;
  uploadFileMutation?: Maybe<UploadFileMutationTc>;
};

export type MutationActivateUserMutationArgs = {
  codeForActivation?: InputMaybe<Scalars['String']['input']>;
};

export type MutationApplyOneLessonTemplateMutationArgs = {
  course: Scalars['MongoID']['input'];
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  isCopyLessonsToTheEndOfBoard?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTemplate: Scalars['MongoID']['input'];
  mainTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type MutationChangePasswordUserMutationArgs = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCompleteUploadFileMutationArgs = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<FilePartInfoDataTcInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCopyFilesToFolderFileMutationArgs = {
  items: Array<CopyItemInput>;
  targetFolderId: Scalars['ID']['input'];
};

export type MutationCreateManyFileMutationArgs = {
  records: Array<CreateManyFileInput>;
};

export type MutationCreateManyTagMutationArgs = {
  records: Array<CreateManyTagInput>;
};

export type MutationCreateOneCategoryMutationArgs = {
  record: CreateOneCategoryInput;
};

export type MutationCreateOneCompanyMutationArgs = {
  record: CreateOneCompanyInput;
};

export type MutationCreateOneConsultationMutationArgs = {
  record: CreateOneConsultationInput;
};

export type MutationCreateOneCopyLessonMutationArgs = {
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  courseId?: InputMaybe<Scalars['MongoID']['input']>;
  isZeroLesson?: InputMaybe<Scalars['Boolean']['input']>;
  lessonId: Scalars['MongoID']['input'];
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
  videoCallStatus?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateOneCourseCategoryMutationArgs = {
  course: Scalars['MongoID']['input'];
};

export type MutationCreateOneCourseMetricDefinitionArgs = {
  record: CourseMetricDefinitionInput;
};

export type MutationCreateOneCourseMutationArgs = {
  record: CreateOneCourseInput;
};

export type MutationCreateOneDialogMutationArgs = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  dialogUsers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isCommonDialog?: InputMaybe<Scalars['Boolean']['input']>;
  lesson?: InputMaybe<Scalars['MongoID']['input']>;
  type: Scalars['String']['input'];
};

export type MutationCreateOneEventMutationArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  course: Scalars['MongoID']['input'];
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  dateTime?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lesson?: InputMaybe<Scalars['MongoID']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
  studentsGroup?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateOneFavoriteTopicMutationArgs = {
  entity?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateOneFileMutationArgs = {
  record: CreateOneFileInput;
};

export type MutationCreateOneFormTemplateMutationArgs = {
  record: CreateOneFormTemplateInput;
};

export type MutationCreateOneHomeTaskMutationArgs = {
  course: Scalars['MongoID']['input'];
  courseCategory: Scalars['MongoID']['input'];
  files?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type MutationCreateOneLessonExerciseMutationArgs = {
  record: CreateOneLessonExerciseInput;
};

export type MutationCreateOneLessonMutationArgs = {
  course: Scalars['MongoID']['input'];
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  isZeroLesson?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type MutationCreateOneLessonTemplateMutationArgs = {
  course: Scalars['MongoID']['input'];
  courseCategory: Scalars['MongoID']['input'];
  isNewTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonalLessonTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherLessonTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
  title: Scalars['String']['input'];
};

export type MutationCreateOneMessageMutationArgs = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<MessageDataInputTc>;
  isMetaMessage?: InputMaybe<Scalars['Boolean']['input']>;
  repliedMessage?: InputMaybe<Scalars['MongoID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateOnePostMutationArgs = {
  record: CreateOnePostInput;
};

export type MutationCreateOneSubscriptionMutationArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateOneUserGroupMutationArgs = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
  teacher: Scalars['MongoID']['input'];
  type: Scalars['String']['input'];
  users?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type MutationCreateOneVoteMutationArgs = {
  entity?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  voteRate?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationFindCreateManyTagMutationArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MutationGenerateContentLessonMutationArgs = {
  lng: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

export type MutationInitUploadFileMutationArgs = {
  destination?: InputMaybe<Scalars['String']['input']>;
  fileFormat?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMoveFilesAndFoldersMutationArgs = {
  items: Array<MoveItemInput>;
  targetFolderId: Scalars['ID']['input'];
};

export type MutationNavigationOnBehalfUserMutationArgs = {
  _id: Scalars['MongoID']['input'];
  course: Scalars['MongoID']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRegisterUserMutationArgs = {
  age?: InputMaybe<Scalars['Int']['input']>;
  company?: InputMaybe<Scalars['MongoID']['input']>;
  courses?: InputMaybe<Array<InputMaybe<CoursesDataInputTc>>>;
  dbId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['MongoID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRemoveByIdCategoryMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdCompanyMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdConsultationMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdCourseCategoryMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdCourseMetricDefinitionArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdCourseMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdDialogMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdEventMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdFormTemplateMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdHomeTaskMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdLessonExerciseMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdLessonMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdLessonTemplateMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdPostMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdUserGroupMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByIdUserMutationArgs = {
  _id: Scalars['MongoID']['input'];
};

export type MutationRemoveByPathFileMutationArgs = {
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MutationRemoveManyFileMutationArgs = {
  ids: Array<InputMaybe<Scalars['MongoID']['input']>>;
};

export type MutationRemoveManyLessonExerciseMutationArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type MutationResetPasswordRequestUserMutationArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type MutationResetPasswordUserMutationArgs = {
  codeForResetPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSaveManyMetricValuesArgs = {
  record: SaveManyMetricValuesInput;
};

export type MutationSignInUserMutationArgs = {
  login?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSignUpForPaymentUserMutationArgs = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSignUpUserMutationArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartCourseUserMutationArgs = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  paymentData?: InputMaybe<PaymentDataInputTc>;
};

export type MutationUnsubscribeSubscriptionMutationArgs = {
  codeForUnsubscribe?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateByIdCategoryMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCategoryInput;
};

export type MutationUpdateByIdCompanyMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCompanyInput;
};

export type MutationUpdateByIdConsultationMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdConsultationInput;
};

export type MutationUpdateByIdCourseCategoryMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCourseCategoryInput;
};

export type MutationUpdateByIdCourseMetricDefinitionArgs = {
  _id: Scalars['MongoID']['input'];
  record: CourseMetricDefinitionInput;
};

export type MutationUpdateByIdCourseMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCourseInput;
};

export type MutationUpdateByIdEventMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdEventInput;
};

export type MutationUpdateByIdFileMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdFileInput;
};

export type MutationUpdateByIdFormTemplateMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdFormTemplateInput;
};

export type MutationUpdateByIdHomeTaskMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdHomeTaskInput;
};

export type MutationUpdateByIdLessonExerciseMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLessonExerciseInput;
};

export type MutationUpdateByIdLessonMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLessonInput;
};

export type MutationUpdateByIdLessonTemplateMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLessonTemplateInput;
};

export type MutationUpdateByIdPostMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPostInput;
};

export type MutationUpdateByIdUserGroupMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdUserGroupInput;
};

export type MutationUpdateByIdUserMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdUserInput;
};

export type MutationUpdateCourseIntroStatusUserMutationArgs = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  lastStep?: InputMaybe<Scalars['Int']['input']>;
  scope: Scalars['String']['input'];
};

export type MutationUpdateCurrentLessonAndLessonExerciseOfModuleUserMutationArgs = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lessonExerciseId?: InputMaybe<Scalars['MongoID']['input']>;
  lessonId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type MutationUpdateFilesFolderFileMutationArgs = {
  files?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  folder?: InputMaybe<Scalars['MongoID']['input']>;
};

export type MutationUpdateOneLessonTemplateMutationArgs = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  course: Scalars['MongoID']['input'];
  courseCategory: Scalars['MongoID']['input'];
  isSuperTeacherTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherLessonTemplate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationUpdateOrderCourseCategoryMutationArgs = {
  courseCategories?: InputMaybe<Array<InputMaybe<UpdateOrderCourseCategoryInput>>>;
};

export type MutationUpdateOrderExerciseLessonMutationArgs = {
  _id: Scalars['MongoID']['input'];
  record?: InputMaybe<UpdateOrderExerciseLessonInput>;
};

export type MutationUpdateOrderLessonMutationArgs = {
  lessons?: InputMaybe<Array<InputMaybe<UpdateOrderLessonInput>>>;
};

export type MutationUpdateStudentLevelUserGroupMutationArgs = {
  courseCategoryId: Scalars['MongoID']['input'];
  groupId: Scalars['MongoID']['input'];
};

export type MutationUpdateStudentLevelUserMutationArgs = {
  courseCategoryId: Scalars['MongoID']['input'];
  records?: InputMaybe<Array<InputMaybe<UpdateStudentLevelUserInput>>>;
};

export type MutationUploadFileMutationArgs = {
  files?: InputMaybe<FilesTc>;
  filesMetaInfo?: InputMaybe<Array<InputMaybe<FilesMetaInfoDataTc>>>;
};

export type NavigationOnBehalfPayload = {
  __typename?: 'NavigationOnBehalfPayload';
  message?: Maybe<Scalars['String']['output']>;
  sessionKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageInfoType = {
  __typename?: 'PageInfoType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  perPage?: Maybe<Scalars['Int']['output']>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
};

export type PaginationType = {
  __typename?: 'PaginationType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  perPage?: Maybe<Scalars['Int']['output']>;
};

export type PaymentDataInputTc = {
  acq_id?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amount_credit?: InputMaybe<Scalars['Int']['input']>;
  card_mask?: InputMaybe<Scalars['String']['input']>;
  create_date?: InputMaybe<Scalars['Date']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  liqpay_order_id?: InputMaybe<Scalars['String']['input']>;
  payment_id?: InputMaybe<Scalars['Int']['input']>;
  transaction_id?: InputMaybe<Scalars['Int']['input']>;
};

export type Post = {
  __typename?: 'Post';
  _id: Scalars['MongoID']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Category>;
  content?: Maybe<Scalars['String']['output']>;
  countOfVotes?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<File>;
  isAddedToFavorite?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  isVoted?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeyWords?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  tags: Array<Tag>;
  thumbnail?: Maybe<File>;
  timeForReading?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  voteRate?: Maybe<Scalars['Float']['output']>;
};

export type PostCreatorArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

export type PostTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsTagInput>;
};

/** A connection to a list of items. */
export type PostConnection = {
  __typename?: 'PostConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<PostEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PostEdge = {
  __typename?: 'PostEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Post;
};

export type PostPaginationType = {
  __typename?: 'PostPaginationType';
  items?: Maybe<Array<Maybe<Post>>>;
  pageInfo?: Maybe<PageInfoType>;
};

export type Query = {
  __typename?: 'Query';
  childFoldersFileQuery?: Maybe<Array<Maybe<Folder>>>;
  connectionCategoryQuery?: Maybe<CategoryConnection>;
  connectionCompanyQuery?: Maybe<CompanyConnection>;
  connectionConsultationQuery?: Maybe<ConsultationConnection>;
  connectionCourseCategoryQuery?: Maybe<CourseCategoryConnection>;
  connectionCourseQuery?: Maybe<CourseConnection>;
  connectionDialogQuery?: Maybe<DialogConnection>;
  connectionEventQuery?: Maybe<EventConnection>;
  connectionFavoriteTopicQuery?: Maybe<FavoriteTopicConnection>;
  connectionFormTemplateQuery?: Maybe<FormTemplateConnection>;
  connectionHomeTaskQuery?: Maybe<HomeTaskConnection>;
  connectionLessonExerciseQuery?: Maybe<LessonExerciseConnection>;
  connectionLessonQuery?: Maybe<LessonConnection>;
  connectionMessageQuery?: Maybe<MessageConnection>;
  connectionPostQuery?: Maybe<PostConnection>;
  connectionSubscriptionQuery?: Maybe<SubscriptionConnection>;
  connectionTagQuery?: Maybe<TagConnection>;
  connectionUserGroupQuery?: Maybe<UserGroupConnection>;
  connectionUserQuery?: Maybe<UserConnection>;
  connectionVoteQuery?: Maybe<VoteConnection>;
  countCategoryQuery?: Maybe<Scalars['Int']['output']>;
  countCompanyQuery?: Maybe<Scalars['Int']['output']>;
  countConsultationQuery?: Maybe<Scalars['Int']['output']>;
  countCourseCategoryQuery?: Maybe<Scalars['Int']['output']>;
  countCourseQuery?: Maybe<Scalars['Int']['output']>;
  countDialogQuery?: Maybe<Scalars['Int']['output']>;
  countEventQuery?: Maybe<Scalars['Int']['output']>;
  countFavoriteTopicQuery?: Maybe<Scalars['Int']['output']>;
  countFormTemplateQuery?: Maybe<Scalars['Int']['output']>;
  countHomeTaskQuery?: Maybe<Scalars['Int']['output']>;
  countLessonExerciseQuery?: Maybe<Scalars['Int']['output']>;
  countLessonQuery?: Maybe<Scalars['Int']['output']>;
  countMessageQuery?: Maybe<Scalars['Int']['output']>;
  countPostQuery?: Maybe<Scalars['Int']['output']>;
  countSubscriptionQuery?: Maybe<Scalars['Int']['output']>;
  countTagQuery?: Maybe<Scalars['Int']['output']>;
  countUserGroupQuery?: Maybe<Scalars['Int']['output']>;
  countUserQuery?: Maybe<Scalars['Int']['output']>;
  countVoteQuery?: Maybe<Scalars['Int']['output']>;
  filesForExercise?: Maybe<Array<Maybe<FileWithStatus>>>;
  findByAliasCourseQuery?: Maybe<FindByAliasCourseQueryType>;
  findByAliasesLessonQuery?: Maybe<Lesson>;
  findByCodeForActivationUserQuery?: Maybe<User>;
  findByCourseAndIndexCourseCategoryQuery?: Maybe<CourseCategory>;
  findByIdCategoryQuery?: Maybe<Category>;
  findByIdCompanyQuery?: Maybe<Company>;
  findByIdConsultationQuery?: Maybe<Consultation>;
  findByIdCourseCategoryQuery?: Maybe<CourseCategory>;
  findByIdCourseMetricDefinition?: Maybe<CourseMetricDefinition>;
  findByIdCourseQuery?: Maybe<Course>;
  findByIdDialogQuery?: Maybe<Dialog>;
  findByIdEventQuery?: Maybe<Event>;
  findByIdFavoriteTopicQuery?: Maybe<FavoriteTopic>;
  findByIdFormTemplateQuery?: Maybe<FormTemplate>;
  findByIdHomeTaskQuery?: Maybe<HomeTask>;
  findByIdLessonExerciseQuery?: Maybe<LessonExercise>;
  findByIdLessonQuery?: Maybe<Lesson>;
  findByIdLessonTemplateQuery?: Maybe<LessonTemplate>;
  findByIdMessageQuery?: Maybe<Message>;
  findByIdPostQuery?: Maybe<Post>;
  findByIdSubscriptionQuery?: Maybe<Subscription>;
  findByIdTagQuery?: Maybe<Tag>;
  findByIdUserGroupQuery?: Maybe<UserGroup>;
  findByIdUserQuery?: Maybe<User>;
  findByIdVoteQuery?: Maybe<Vote>;
  findByIdsCategoryQuery: Array<Category>;
  findByIdsCompanyQuery: Array<Company>;
  findByIdsConsultationQuery: Array<Consultation>;
  findByIdsCourseCategoryQuery: Array<CourseCategory>;
  findByIdsCourseQuery: Array<Course>;
  findByIdsDialogQuery: Array<Dialog>;
  findByIdsEventQuery: Array<Event>;
  findByIdsFavoriteTopicQuery: Array<FavoriteTopic>;
  findByIdsFormTemplateQuery: Array<FormTemplate>;
  findByIdsHomeTaskQuery: Array<HomeTask>;
  findByIdsLessonExerciseQuery: Array<LessonExercise>;
  findByIdsLessonQuery: Array<Lesson>;
  findByIdsMessageQuery: Array<Message>;
  findByIdsPostQuery: Array<Post>;
  findByIdsSubscriptionQuery: Array<Subscription>;
  findByIdsTagQuery: Array<Tag>;
  findByIdsUserGroupQuery: Array<UserGroup>;
  findByIdsUserQuery: Array<User>;
  findByIdsVoteQuery: Array<Vote>;
  findByStudentIdLessonTemplateQuery?: Maybe<LessonTemplate>;
  findCourseInfoByIdsQuery?: Maybe<Array<Maybe<CourseInfoById>>>;
  findCurrentUnfinishedLessonQuery?: Maybe<Lesson>;
  findManyCategoryQuery: Array<Category>;
  findManyCompanyQuery: Array<Company>;
  findManyConsultationQuery: Array<Consultation>;
  findManyCourseCategoryQuery: Array<CourseCategory>;
  findManyCourseMetricDefinitions: Array<CourseMetricDefinition>;
  findManyCourseQuery: Array<Course>;
  findManyDialogQuery: Array<Dialog>;
  findManyEventQuery: Array<Event>;
  findManyFavoriteTopicQuery: Array<FavoriteTopic>;
  findManyFormTemplateQuery: Array<FormTemplate>;
  findManyHomeTaskQuery: Array<HomeTask>;
  findManyLessonExerciseQuery: Array<LessonExercise>;
  findManyLessonQuery: Array<Lesson>;
  findManyLessonTemplateQuery: Array<LessonTemplate>;
  findManyLightCourseCategoryQuery?: Maybe<Array<Maybe<CourseCategory>>>;
  findManyMessageQuery: Array<Message>;
  findManyMetricValues: Array<MetricValue>;
  findManyPostQuery: Array<Post>;
  findManySubscriptionQuery: Array<Subscription>;
  findManyTagQuery: Array<Tag>;
  findManyUserGroupQuery: Array<UserGroup>;
  findManyUserQuery: Array<User>;
  findManyVoteQuery: Array<Vote>;
  findOneCategoryQuery?: Maybe<Category>;
  findOneCompanyQuery?: Maybe<Company>;
  findOneConsultationQuery?: Maybe<Consultation>;
  findOneCourseCategoryQuery?: Maybe<CourseCategory>;
  findOneCourseQuery?: Maybe<Course>;
  findOneDialogQuery?: Maybe<Dialog>;
  findOneEventQuery?: Maybe<Event>;
  findOneFavoriteTopicQuery?: Maybe<FavoriteTopic>;
  findOneFormTemplateQuery?: Maybe<FormTemplate>;
  findOneHomeTaskQuery?: Maybe<HomeTask>;
  findOneLessonExerciseQuery?: Maybe<LessonExercise>;
  findOneLessonQuery?: Maybe<Lesson>;
  findOneLessonTemplateQuery?: Maybe<LessonTemplate>;
  findOneMessageQuery?: Maybe<Message>;
  findOnePostQuery?: Maybe<Post>;
  findOneSubscriptionQuery?: Maybe<Subscription>;
  findOneTagQuery?: Maybe<Tag>;
  findOneUserGroupQuery?: Maybe<UserGroup>;
  findOneUserQuery?: Maybe<User>;
  findOneVoteQuery?: Maybe<Vote>;
  getAuthInfoUserQuery?: Maybe<User>;
  getIdsByFilterFileQuery: Array<Scalars['MongoID']['output']>;
  getIdsByFilterLessonQuery: Array<Scalars['MongoID']['output']>;
  getMetricSeriesByCourse?: Maybe<Scalars['JSON']['output']>;
  getSurveyAnalyticsByCourse?: Maybe<Scalars['JSON']['output']>;
  isLastLessonInModule: Scalars['Boolean']['output'];
  paginationByCourseAndCategoryAliasLessonQuery?: Maybe<LessonPaginationType>;
  paginationCategoryQuery?: Maybe<CategoryPaginationType>;
  paginationCompanyQuery?: Maybe<CompanyPagination>;
  paginationConsultationQuery?: Maybe<ConsultationPagination>;
  paginationCourseCategoryQuery?: Maybe<CourseCategoryPaginationType>;
  paginationCourseQuery?: Maybe<CoursePaginationType>;
  paginationDialogQuery?: Maybe<DialogsPaginationType>;
  paginationEventQuery?: Maybe<EventPaginationType>;
  paginationFavoriteTopicQuery?: Maybe<FavoriteTopicPagination>;
  paginationFileQuery?: Maybe<FilePaginationType>;
  paginationFormTemplateQuery?: Maybe<FormTemplatePaginationType>;
  paginationHomeTaskQuery?: Maybe<HomeTaskPagination>;
  paginationLessonExerciseQuery?: Maybe<LessonExercisePaginationType>;
  paginationLessonQuery?: Maybe<LessonPaginationType>;
  paginationLessonTemplateQuery?: Maybe<LessonTemplatePaginationType>;
  paginationMessageQuery?: Maybe<MessagePaginationType>;
  paginationPostQuery?: Maybe<PostPaginationType>;
  paginationSubscriptionQuery?: Maybe<SubscriptionPagination>;
  paginationTagQuery?: Maybe<TagPagination>;
  paginationUserGroupQuery?: Maybe<UserGroupsPaginationType>;
  paginationUserQuery?: Maybe<UserPaginationType>;
  paginationUsersDialogQuery?: Maybe<DialogUsersPaginationType>;
  paginationVoteQuery?: Maybe<VotePagination>;
};

export type QueryChildFoldersFileQueryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryConnectionCategoryQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyCategoryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionCategoryEnum>;
};

export type QueryConnectionCompanyQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyCompanyInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionCompanyEnum>;
};

export type QueryConnectionConsultationQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyConsultationInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionConsultationEnum>;
};

export type QueryConnectionCourseCategoryQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyCourseCategoryInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionCourseCategoryEnum>;
};

export type QueryConnectionCourseQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyCourseInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionCourseEnum>;
};

export type QueryConnectionDialogQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyDialogInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionDialogEnum>;
};

export type QueryConnectionEventQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyEventInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionEventEnum>;
};

export type QueryConnectionFavoriteTopicQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyFavoriteTopicInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionFavoriteTopicEnum>;
};

export type QueryConnectionFormTemplateQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyFormTemplateInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionFormTemplateEnum>;
};

export type QueryConnectionHomeTaskQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyHomeTaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionHomeTaskEnum>;
};

export type QueryConnectionLessonExerciseQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyLessonExerciseInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionLessonExerciseEnum>;
};

export type QueryConnectionLessonQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyLessonInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionLessonEnum>;
};

export type QueryConnectionMessageQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyMessageInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionMessageEnum>;
};

export type QueryConnectionPostQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyPostInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionPostEnum>;
};

export type QueryConnectionSubscriptionQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManySubscriptionInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionSubscriptionEnum>;
};

export type QueryConnectionTagQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyTagInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionTagEnum>;
};

export type QueryConnectionUserGroupQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyUserGroupInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionUserGroupEnum>;
};

export type QueryConnectionUserQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyUserInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionUserEnum>;
};

export type QueryConnectionVoteQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFindManyVoteInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortConnectionVoteEnum>;
};

export type QueryCountCategoryQueryArgs = {
  filter?: InputMaybe<FilterCountCategoryInput>;
};

export type QueryCountCompanyQueryArgs = {
  filter?: InputMaybe<FilterCountCompanyInput>;
};

export type QueryCountConsultationQueryArgs = {
  filter?: InputMaybe<FilterCountConsultationInput>;
};

export type QueryCountCourseCategoryQueryArgs = {
  filter?: InputMaybe<FilterCountCourseCategoryInput>;
};

export type QueryCountCourseQueryArgs = {
  filter?: InputMaybe<FilterCountCourseInput>;
};

export type QueryCountDialogQueryArgs = {
  filter?: InputMaybe<FilterCountDialogInput>;
};

export type QueryCountEventQueryArgs = {
  filter?: InputMaybe<FilterCountEventInput>;
};

export type QueryCountFavoriteTopicQueryArgs = {
  filter?: InputMaybe<FilterCountFavoriteTopicInput>;
};

export type QueryCountFormTemplateQueryArgs = {
  filter?: InputMaybe<FilterCountFormTemplateInput>;
};

export type QueryCountHomeTaskQueryArgs = {
  filter?: InputMaybe<FilterCountHomeTaskInput>;
};

export type QueryCountLessonExerciseQueryArgs = {
  filter?: InputMaybe<FilterCountLessonExerciseInput>;
};

export type QueryCountLessonQueryArgs = {
  filter?: InputMaybe<FilterCountLessonInput>;
};

export type QueryCountMessageQueryArgs = {
  filter?: InputMaybe<FilterCountMessageInput>;
};

export type QueryCountPostQueryArgs = {
  filter?: InputMaybe<FilterCountPostInput>;
};

export type QueryCountSubscriptionQueryArgs = {
  filter?: InputMaybe<FilterCountSubscriptionInput>;
};

export type QueryCountTagQueryArgs = {
  filter?: InputMaybe<FilterCountTagInput>;
};

export type QueryCountUserGroupQueryArgs = {
  filter?: InputMaybe<FilterCountUserGroupInput>;
};

export type QueryCountUserQueryArgs = {
  filter?: InputMaybe<FilterCountUserInput>;
};

export type QueryCountVoteQueryArgs = {
  filter?: InputMaybe<FilterCountVoteInput>;
};

export type QueryFilesForExerciseArgs = {
  exerciseId: Scalars['MongoID']['input'];
  index: Scalars['Int']['input'];
  lessonId: Scalars['MongoID']['input'];
};

export type QueryFindByAliasCourseQueryArgs = {
  alias: Scalars['String']['input'];
};

export type QueryFindByAliasesLessonQueryArgs = {
  alias: Scalars['String']['input'];
  courseCategoryAlias: Scalars['String']['input'];
  lessonAlias: Scalars['String']['input'];
  lessonTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFindByCodeForActivationUserQueryArgs = {
  codeForActivation: Scalars['String']['input'];
};

export type QueryFindByCourseAndIndexCourseCategoryQueryArgs = {
  courseId: Scalars['MongoID']['input'];
  index: Scalars['Int']['input'];
};

export type QueryFindByIdCategoryQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdCompanyQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdConsultationQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdCourseCategoryQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdCourseMetricDefinitionArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdCourseQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdDialogQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdEventQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdFavoriteTopicQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdFormTemplateQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdHomeTaskQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdLessonExerciseQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdLessonQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdLessonTemplateQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdMessageQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdPostQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdSubscriptionQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdTagQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdUserGroupQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdUserQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdVoteQueryArgs = {
  _id: Scalars['MongoID']['input'];
};

export type QueryFindByIdsCategoryQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCategoryInput>;
};

export type QueryFindByIdsCompanyQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCompanyInput>;
};

export type QueryFindByIdsConsultationQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsConsultationInput>;
};

export type QueryFindByIdsCourseCategoryQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCourseCategoryInput>;
};

export type QueryFindByIdsCourseQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCourseInput>;
};

export type QueryFindByIdsDialogQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsDialogInput>;
};

export type QueryFindByIdsEventQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsEventInput>;
};

export type QueryFindByIdsFavoriteTopicQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsFavoriteTopicInput>;
};

export type QueryFindByIdsFormTemplateQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsFormTemplateInput>;
};

export type QueryFindByIdsHomeTaskQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsHomeTaskInput>;
};

export type QueryFindByIdsLessonExerciseQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsLessonExerciseInput>;
};

export type QueryFindByIdsLessonQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsLessonInput>;
};

export type QueryFindByIdsMessageQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsMessageInput>;
};

export type QueryFindByIdsPostQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPostInput>;
};

export type QueryFindByIdsSubscriptionQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsSubscriptionInput>;
};

export type QueryFindByIdsTagQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsTagInput>;
};

export type QueryFindByIdsUserGroupQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsUserGroupInput>;
};

export type QueryFindByIdsUserQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsUserInput>;
};

export type QueryFindByIdsVoteQueryArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsVoteInput>;
};

export type QueryFindByStudentIdLessonTemplateQueryArgs = {
  studentId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type QueryFindCourseInfoByIdsQueryArgs = {
  ids?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};

export type QueryFindCurrentUnfinishedLessonQueryArgs = {
  courseId: Scalars['MongoID']['input'];
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type QueryFindManyCategoryQueryArgs = {
  filter?: InputMaybe<FilterFindManyCategoryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCategoryInput>;
};

export type QueryFindManyCompanyQueryArgs = {
  filter?: InputMaybe<FilterFindManyCompanyInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCompanyInput>;
};

export type QueryFindManyConsultationQueryArgs = {
  filter?: InputMaybe<FilterFindManyConsultationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyConsultationInput>;
};

export type QueryFindManyCourseCategoryQueryArgs = {
  filter?: InputMaybe<FilterFindManyCourseCategoryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCourseCategoryInput>;
};

export type QueryFindManyCourseMetricDefinitionsArgs = {
  filter?: InputMaybe<FilterFindManyCourseMetricDefinitionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCourseMetricDefinitionInput>;
};

export type QueryFindManyCourseQueryArgs = {
  filter?: InputMaybe<FilterFindManyCourseInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCourseInput>;
};

export type QueryFindManyDialogQueryArgs = {
  filter?: InputMaybe<FilterFindManyDialogInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDialogInput>;
};

export type QueryFindManyEventQueryArgs = {
  filter?: InputMaybe<FilterFindManyEventInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyEventInput>;
};

export type QueryFindManyFavoriteTopicQueryArgs = {
  filter?: InputMaybe<FilterFindManyFavoriteTopicInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyFavoriteTopicInput>;
};

export type QueryFindManyFormTemplateQueryArgs = {
  filter?: InputMaybe<FilterFindManyFormTemplateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyFormTemplateInput>;
};

export type QueryFindManyHomeTaskQueryArgs = {
  filter?: InputMaybe<FilterFindManyHomeTaskInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyHomeTaskInput>;
};

export type QueryFindManyLessonExerciseQueryArgs = {
  filter?: InputMaybe<FilterFindManyLessonExerciseInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLessonExerciseInput>;
};

export type QueryFindManyLessonQueryArgs = {
  filter?: InputMaybe<FilterFindManyLessonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLessonInput>;
};

export type QueryFindManyLessonTemplateQueryArgs = {
  filter?: InputMaybe<FilterFindManyLessonTemplateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLessonTemplateInput>;
};

export type QueryFindManyLightCourseCategoryQueryArgs = {
  filter?: InputMaybe<FilterFindManyCourseCategoryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCourseCategoryInput>;
};

export type QueryFindManyMessageQueryArgs = {
  filter?: InputMaybe<FilterFindManyMessageInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyMessageInput>;
};

export type QueryFindManyMetricValuesArgs = {
  filter?: InputMaybe<FilterFindManyMetricValueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyMetricValueInput>;
};

export type QueryFindManyPostQueryArgs = {
  filter?: InputMaybe<FilterFindManyPostInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPostInput>;
};

export type QueryFindManySubscriptionQueryArgs = {
  filter?: InputMaybe<FilterFindManySubscriptionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySubscriptionInput>;
};

export type QueryFindManyTagQueryArgs = {
  filter?: InputMaybe<FilterFindManyTagInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTagInput>;
};

export type QueryFindManyUserGroupQueryArgs = {
  filter?: InputMaybe<FilterFindManyUserGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserGroupInput>;
};

export type QueryFindManyUserQueryArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};

export type QueryFindManyVoteQueryArgs = {
  filter?: InputMaybe<FilterFindManyVoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVoteInput>;
};

export type QueryFindOneCategoryQueryArgs = {
  filter?: InputMaybe<FilterFindOneCategoryInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCategoryInput>;
};

export type QueryFindOneCompanyQueryArgs = {
  filter?: InputMaybe<FilterFindOneCompanyInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCompanyInput>;
};

export type QueryFindOneConsultationQueryArgs = {
  filter?: InputMaybe<FilterFindOneConsultationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneConsultationInput>;
};

export type QueryFindOneCourseCategoryQueryArgs = {
  filter?: InputMaybe<FilterFindOneCourseCategoryInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCourseCategoryInput>;
};

export type QueryFindOneCourseQueryArgs = {
  filter?: InputMaybe<FilterFindOneCourseInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCourseInput>;
};

export type QueryFindOneDialogQueryArgs = {
  filter?: InputMaybe<FilterFindOneDialogInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneDialogInput>;
};

export type QueryFindOneEventQueryArgs = {
  filter?: InputMaybe<FilterFindOneEventInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneEventInput>;
};

export type QueryFindOneFavoriteTopicQueryArgs = {
  filter?: InputMaybe<FilterFindOneFavoriteTopicInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneFavoriteTopicInput>;
};

export type QueryFindOneFormTemplateQueryArgs = {
  filter?: InputMaybe<FilterFindOneFormTemplateInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneFormTemplateInput>;
};

export type QueryFindOneHomeTaskQueryArgs = {
  filter?: InputMaybe<FilterFindOneHomeTaskInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneHomeTaskInput>;
};

export type QueryFindOneLessonExerciseQueryArgs = {
  filter?: InputMaybe<FilterFindOneLessonExerciseInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneLessonExerciseInput>;
};

export type QueryFindOneLessonQueryArgs = {
  filter?: InputMaybe<FilterFindOneLessonInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneLessonInput>;
};

export type QueryFindOneLessonTemplateQueryArgs = {
  filter?: InputMaybe<FilterFindOneLessonTemplateInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneLessonTemplateInput>;
};

export type QueryFindOneMessageQueryArgs = {
  filter?: InputMaybe<FilterFindOneMessageInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneMessageInput>;
};

export type QueryFindOnePostQueryArgs = {
  filter?: InputMaybe<FilterFindOnePostInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePostInput>;
};

export type QueryFindOneSubscriptionQueryArgs = {
  filter?: InputMaybe<FilterFindOneSubscriptionInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneSubscriptionInput>;
};

export type QueryFindOneTagQueryArgs = {
  filter?: InputMaybe<FilterFindOneTagInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneTagInput>;
};

export type QueryFindOneUserGroupQueryArgs = {
  filter?: InputMaybe<FilterFindOneUserGroupInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserGroupInput>;
};

export type QueryFindOneUserQueryArgs = {
  filter?: InputMaybe<FilterFindOneUserInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

export type QueryFindOneVoteQueryArgs = {
  filter?: InputMaybe<FilterFindOneVoteInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneVoteInput>;
};

export type QueryGetIdsByFilterFileQueryArgs = {
  filter?: InputMaybe<FilterPaginationFileInput>;
  sort?: InputMaybe<SortFindManyFileInput>;
};

export type QueryGetIdsByFilterLessonQueryArgs = {
  filter?: InputMaybe<FilterPaginationLessonInput>;
  sort?: InputMaybe<SortFindManyLessonInput>;
};

export type QueryGetMetricSeriesByCourseArgs = {
  course: Scalars['MongoID']['input'];
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  isVisibleToStudent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetSurveyAnalyticsByCourseArgs = {
  course: Scalars['MongoID']['input'];
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  student: Scalars['MongoID']['input'];
};

export type QueryIsLastLessonInModuleArgs = {
  lessonId: Scalars['MongoID']['input'];
};

export type QueryPaginationByCourseAndCategoryAliasLessonQueryArgs = {
  filter?: InputMaybe<FilterPaginationByCourseAndCategoryAliasLessonInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyLessonInput>;
};

export type QueryPaginationCategoryQueryArgs = {
  filter?: InputMaybe<FilterPaginationCategoryInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyCategoryInput>;
};

export type QueryPaginationCompanyQueryArgs = {
  filter?: InputMaybe<FilterFindManyCompanyInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCompanyInput>;
};

export type QueryPaginationConsultationQueryArgs = {
  filter?: InputMaybe<FilterFindManyConsultationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyConsultationInput>;
};

export type QueryPaginationCourseCategoryQueryArgs = {
  filter?: InputMaybe<FilterPaginationCourseCategoryInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortEnum>;
};

export type QueryPaginationCourseQueryArgs = {
  filter?: InputMaybe<FilterByTypeFindManyCourseInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyCourseInput>;
};

export type QueryPaginationDialogQueryArgs = {
  filter?: InputMaybe<FilterFindManyDialogWithUsersInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyDialogInput>;
};

export type QueryPaginationEventQueryArgs = {
  filter?: InputMaybe<FilterPaginationEventInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyEventInput>;
};

export type QueryPaginationFavoriteTopicQueryArgs = {
  filter?: InputMaybe<FilterFindManyFavoriteTopicInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyFavoriteTopicInput>;
};

export type QueryPaginationFileQueryArgs = {
  filter?: InputMaybe<FilterPaginationFileInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortEnum>;
};

export type QueryPaginationFormTemplateQueryArgs = {
  filter?: InputMaybe<FilterPaginationFormTemplateInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyFormTemplateInput>;
};

export type QueryPaginationHomeTaskQueryArgs = {
  filter?: InputMaybe<FilterFindManyHomeTaskInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyHomeTaskInput>;
};

export type QueryPaginationLessonExerciseQueryArgs = {
  filter?: InputMaybe<FilterPaginationLessonExerciseInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortEnum>;
};

export type QueryPaginationLessonQueryArgs = {
  filter?: InputMaybe<FilterPaginationLessonInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyLessonInput>;
};

export type QueryPaginationLessonTemplateQueryArgs = {
  filter?: InputMaybe<FilterPaginationLessonTemplateInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyLessonTemplateInput>;
};

export type QueryPaginationMessageQueryArgs = {
  filter?: InputMaybe<FilterFindManyMessageInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyMessageInput>;
};

export type QueryPaginationPostQueryArgs = {
  filter?: InputMaybe<FilterPaginationPostInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortEnum>;
};

export type QueryPaginationSubscriptionQueryArgs = {
  filter?: InputMaybe<FilterFindManySubscriptionInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySubscriptionInput>;
};

export type QueryPaginationTagQueryArgs = {
  filter?: InputMaybe<FilterFindManyTagInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTagInput>;
};

export type QueryPaginationUserGroupQueryArgs = {
  filter?: InputMaybe<FilterFindManyUserGroupWithUsersInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyUserGroupInput>;
};

export type QueryPaginationUserQueryArgs = {
  filter?: InputMaybe<FilterPaginationUserInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyUserInput>;
};

export type QueryPaginationUsersDialogQueryArgs = {
  filter?: InputMaybe<FilterFindManyDialogInput>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyDialogInput>;
};

export type QueryPaginationVoteQueryArgs = {
  filter?: InputMaybe<FilterFindManyVoteInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVoteInput>;
};

export type RemoveByIdCategoryPayload = {
  __typename?: 'RemoveByIdCategoryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<Category>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdCompanyPayload = {
  __typename?: 'RemoveByIdCompanyPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<Company>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdConsultationPayload = {
  __typename?: 'RemoveByIdConsultationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<Consultation>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdCourseCategoryPayload = {
  __typename?: 'RemoveByIdCourseCategoryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<CourseCategory>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdCourseMetricDefinitionPayload = {
  __typename?: 'RemoveByIdCourseMetricDefinitionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<CourseMetricDefinition>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdCoursePayload = {
  __typename?: 'RemoveByIdCoursePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<Course>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdDialogPayload = {
  __typename?: 'RemoveByIdDialogPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Dialog>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdEventPayload = {
  __typename?: 'RemoveByIdEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdFormTemplatePayload = {
  __typename?: 'RemoveByIdFormTemplatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<FormTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdHomeTaskPayload = {
  __typename?: 'RemoveByIdHomeTaskPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<HomeTask>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdLessonExercisePayload = {
  __typename?: 'RemoveByIdLessonExercisePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<LessonExercise>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdLessonPayload = {
  __typename?: 'RemoveByIdLessonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<Lesson>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdLessonTemplatePayload = {
  __typename?: 'RemoveByIdLessonTemplatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<LessonTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdPostPayload = {
  __typename?: 'RemoveByIdPostPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<Post>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdUserGroupPayload = {
  __typename?: 'RemoveByIdUserGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<UserGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdUserPayload = {
  __typename?: 'RemoveByIdUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveByPathFilesFolderFileDataTc = {
  __typename?: 'RemoveByPathFilesFolderFileDataTC';
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveManyFileResult = {
  __typename?: 'RemoveManyFileResult';
  affectedHomeTasks: Scalars['Int']['output'];
  affectedLessonExercises: Scalars['Int']['output'];
  affectedLessons: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  removedCount: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveManyLessonExerciseTc = {
  __typename?: 'RemoveManyLessonExerciseTC';
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RemoveOneSubscriptionPayload = {
  __typename?: 'RemoveOneSubscriptionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Removed document */
  record?: Maybe<Subscription>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ResponseStatus = {
  __typename?: 'ResponseStatus';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RuntimeError = ErrorInterface & {
  __typename?: 'RuntimeError';
  /** Runtime error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type SaveManyMetricValuesInput = {
  context?: InputMaybe<MetricValueContextInput>;
  course: Scalars['MongoID']['input'];
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  items?: InputMaybe<Array<MetricValueCreateItemInput>>;
  lesson?: InputMaybe<Scalars['MongoID']['input']>;
  lessonExercise?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  student: Scalars['MongoID']['input'];
};

export enum SortConnectionCategoryEnum {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionCompanyEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionConsultationEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionCourseCategoryEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionCourseEnum {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionDialogEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionEventEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionFavoriteTopicEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionFormTemplateEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionHomeTaskEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionLessonEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionLessonExerciseEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionMessageEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionPostEnum {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionSubscriptionEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionTagEnum {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionUserEnum {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  LoginAsc = 'LOGIN_ASC',
  LoginDesc = 'LOGIN_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionUserGroupEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortConnectionVoteEnum {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsCategoryInput {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsCompanyInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsConsultationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsCourseCategoryInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsCourseInput {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  CoursedirectionAsc = 'COURSEDIRECTION_ASC',
  CoursedirectionDesc = 'COURSEDIRECTION_DESC',
  CoursetypeAsc = 'COURSETYPE_ASC',
  CoursetypeDesc = 'COURSETYPE_DESC',
  CoursetypeIsremovedAsc = 'COURSETYPE__ISREMOVED_ASC',
  CoursetypeIsremovedDesc = 'COURSETYPE__ISREMOVED_DESC',
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  CreatorCreatedatAsc = 'CREATOR__CREATEDAT_ASC',
  CreatorCreatedatDesc = 'CREATOR__CREATEDAT_DESC',
  IsfreecourseAsc = 'ISFREECOURSE_ASC',
  IsfreecourseDesc = 'ISFREECOURSE_DESC',
  IsfreecourseIsremovedAsc = 'ISFREECOURSE__ISREMOVED_ASC',
  IsfreecourseIsremovedDesc = 'ISFREECOURSE__ISREMOVED_DESC',
  IsremovedAsc = 'ISREMOVED_ASC',
  IsremovedDesc = 'ISREMOVED_DESC',
  LanguageAsc = 'LANGUAGE_ASC',
  LanguageDesc = 'LANGUAGE_DESC',
  LanguageIsremovedAsc = 'LANGUAGE__ISREMOVED_ASC',
  LanguageIsremovedDesc = 'LANGUAGE__ISREMOVED_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PositionIsremovedAsc = 'POSITION__ISREMOVED_ASC',
  PositionIsremovedDesc = 'POSITION__ISREMOVED_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsDialogInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEventInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsFavoriteTopicInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  EntityAsc = 'ENTITY_ASC',
  EntityDesc = 'ENTITY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsFormTemplateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsHomeTaskInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsLessonExerciseInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsLessonInput {
  HometaskAsc = 'HOMETASK_ASC',
  HometaskDesc = 'HOMETASK_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsMessageInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  DialogAsc = 'DIALOG_ASC',
  DialogDesc = 'DIALOG_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPostInput {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsSubscriptionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsTagInput {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsUserGroupInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsUserInput {
  CodeforactivationAsc = 'CODEFORACTIVATION_ASC',
  CodeforactivationDesc = 'CODEFORACTIVATION_DESC',
  CodeforresetpasswordAsc = 'CODEFORRESETPASSWORD_ASC',
  CodeforresetpasswordDesc = 'CODEFORRESETPASSWORD_DESC',
  CompanyAsc = 'COMPANY_ASC',
  CompanyDesc = 'COMPANY_DESC',
  CompanyRoleAsc = 'COMPANY__ROLE_ASC',
  CompanyRoleDesc = 'COMPANY__ROLE_DESC',
  CompanyRoleIsremovedAsc = 'COMPANY__ROLE__ISREMOVED_ASC',
  CompanyRoleIsremovedDesc = 'COMPANY__ROLE__ISREMOVED_DESC',
  CoursesCoursecategoryAsc = 'COURSES__COURSECATEGORY_ASC',
  CoursesCoursecategoryDesc = 'COURSES__COURSECATEGORY_DESC',
  CoursesCoursecategoryCoursesDataAsc = 'COURSES__COURSECATEGORY__COURSES__DATA_ASC',
  CoursesCoursecategoryCoursesDataDesc = 'COURSES__COURSECATEGORY__COURSES__DATA_DESC',
  CoursesDataAsc = 'COURSES__DATA_ASC',
  CoursesDataDesc = 'COURSES__DATA_DESC',
  CoursesDataRoleAsc = 'COURSES__DATA__ROLE_ASC',
  CoursesDataRoleDesc = 'COURSES__DATA__ROLE_DESC',
  CoursesDataRoleIsremovedAsc = 'COURSES__DATA__ROLE__ISREMOVED_ASC',
  CoursesDataRoleIsremovedDesc = 'COURSES__DATA__ROLE__ISREMOVED_DESC',
  CoursesManagerAsc = 'COURSES__MANAGER_ASC',
  CoursesManagerDesc = 'COURSES__MANAGER_DESC',
  CoursesManagerCoursesDataAsc = 'COURSES__MANAGER__COURSES__DATA_ASC',
  CoursesManagerCoursesDataDesc = 'COURSES__MANAGER__COURSES__DATA_DESC',
  CoursesManagerCoursesDataIsremovedAsc = 'COURSES__MANAGER__COURSES__DATA__ISREMOVED_ASC',
  CoursesManagerCoursesDataIsremovedDesc = 'COURSES__MANAGER__COURSES__DATA__ISREMOVED_DESC',
  CoursesTeacherAsc = 'COURSES__TEACHER_ASC',
  CoursesTeacherDesc = 'COURSES__TEACHER_DESC',
  CoursesTeacherCoursesDataAsc = 'COURSES__TEACHER__COURSES__DATA_ASC',
  CoursesTeacherCoursesDataDesc = 'COURSES__TEACHER__COURSES__DATA_DESC',
  CoursesTeacherCoursesDataIsremovedAsc = 'COURSES__TEACHER__COURSES__DATA__ISREMOVED_ASC',
  CoursesTeacherCoursesDataIsremovedDesc = 'COURSES__TEACHER__COURSES__DATA__ISREMOVED_DESC',
  DbidAsc = 'DBID_ASC',
  DbidDesc = 'DBID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FacebookidAsc = 'FACEBOOKID_ASC',
  FacebookidDesc = 'FACEBOOKID_DESC',
  FirstnameAsc = 'FIRSTNAME_ASC',
  FirstnameDesc = 'FIRSTNAME_DESC',
  IsactivatedAsc = 'ISACTIVATED_ASC',
  IsactivatedDesc = 'ISACTIVATED_DESC',
  IsremovedAsc = 'ISREMOVED_ASC',
  IsremovedDesc = 'ISREMOVED_DESC',
  IssubscribedtopostsAsc = 'ISSUBSCRIBEDTOPOSTS_ASC',
  IssubscribedtopostsDesc = 'ISSUBSCRIBEDTOPOSTS_DESC',
  LastnameAsc = 'LASTNAME_ASC',
  LastnameDesc = 'LASTNAME_DESC',
  LoginAsc = 'LOGIN_ASC',
  LoginDesc = 'LOGIN_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  ProviderAsc = 'PROVIDER_ASC',
  ProviderDesc = 'PROVIDER_DESC',
  RegisteredbyAsc = 'REGISTEREDBY_ASC',
  RegisteredbyDesc = 'REGISTEREDBY_DESC',
  RegisteredbyCreatedatAsc = 'REGISTEREDBY__CREATEDAT_ASC',
  RegisteredbyCreatedatDesc = 'REGISTEREDBY__CREATEDAT_DESC',
  RoleAsc = 'ROLE_ASC',
  RoleDesc = 'ROLE_DESC',
  RoleIsactivatedAsc = 'ROLE__ISACTIVATED_ASC',
  RoleIsactivatedDesc = 'ROLE__ISACTIVATED_DESC',
  RoleIsactivatedIsremovedAsc = 'ROLE__ISACTIVATED__ISREMOVED_ASC',
  RoleIsactivatedIsremovedDesc = 'ROLE__ISACTIVATED__ISREMOVED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsVoteInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyCategoryInput {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyCompanyInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyConsultationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyCourseCategoryInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyCourseInput {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  CoursedirectionAsc = 'COURSEDIRECTION_ASC',
  CoursedirectionDesc = 'COURSEDIRECTION_DESC',
  CoursetypeAsc = 'COURSETYPE_ASC',
  CoursetypeDesc = 'COURSETYPE_DESC',
  CoursetypeIsremovedAsc = 'COURSETYPE__ISREMOVED_ASC',
  CoursetypeIsremovedDesc = 'COURSETYPE__ISREMOVED_DESC',
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  CreatorCreatedatAsc = 'CREATOR__CREATEDAT_ASC',
  CreatorCreatedatDesc = 'CREATOR__CREATEDAT_DESC',
  IsfreecourseAsc = 'ISFREECOURSE_ASC',
  IsfreecourseDesc = 'ISFREECOURSE_DESC',
  IsfreecourseIsremovedAsc = 'ISFREECOURSE__ISREMOVED_ASC',
  IsfreecourseIsremovedDesc = 'ISFREECOURSE__ISREMOVED_DESC',
  IsremovedAsc = 'ISREMOVED_ASC',
  IsremovedDesc = 'ISREMOVED_DESC',
  LanguageAsc = 'LANGUAGE_ASC',
  LanguageDesc = 'LANGUAGE_DESC',
  LanguageIsremovedAsc = 'LANGUAGE__ISREMOVED_ASC',
  LanguageIsremovedDesc = 'LANGUAGE__ISREMOVED_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PositionIsremovedAsc = 'POSITION__ISREMOVED_ASC',
  PositionIsremovedDesc = 'POSITION__ISREMOVED_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyCourseMetricDefinitionInput {
  CoursecategoryAsc = 'COURSECATEGORY_ASC',
  CoursecategoryDesc = 'COURSECATEGORY_DESC',
  CourseAsc = 'COURSE_ASC',
  CourseDesc = 'COURSE_DESC',
  CourseIsactiveAsc = 'COURSE__ISACTIVE_ASC',
  CourseIsactiveDesc = 'COURSE__ISACTIVE_DESC',
  CourseIsactiveIsarchivedAsc = 'COURSE__ISACTIVE__ISARCHIVED_ASC',
  CourseIsactiveIsarchivedDesc = 'COURSE__ISACTIVE__ISARCHIVED_DESC',
  CourseKeyAsc = 'COURSE__KEY_ASC',
  CourseKeyDesc = 'COURSE__KEY_DESC',
  CourseOrderAsc = 'COURSE__ORDER_ASC',
  CourseOrderDesc = 'COURSE__ORDER_DESC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  OrderAsc = 'ORDER_ASC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyDialogInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEventInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyFavoriteTopicInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  EntityAsc = 'ENTITY_ASC',
  EntityDesc = 'ENTITY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyFileInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  CreatorCreatedatAsc = 'CREATOR__CREATEDAT_ASC',
  CreatorCreatedatDesc = 'CREATOR__CREATEDAT_DESC',
  DataCourseAsc = 'DATA__COURSE_ASC',
  DataCourseDesc = 'DATA__COURSE_DESC',
  DataCourseCreatedatAsc = 'DATA__COURSE__CREATEDAT_ASC',
  DataCourseCreatedatDesc = 'DATA__COURSE__CREATEDAT_DESC',
  DataFolderAsc = 'DATA__FOLDER_ASC',
  DataFolderDesc = 'DATA__FOLDER_DESC',
  DataFolderIsfolderAsc = 'DATA__FOLDER__ISFOLDER_ASC',
  DataFolderIsfolderDesc = 'DATA__FOLDER__ISFOLDER_DESC',
  DataFolderIsfolderNameAsc = 'DATA__FOLDER__ISFOLDER__NAME_ASC',
  DataFolderIsfolderNameDesc = 'DATA__FOLDER__ISFOLDER__NAME_DESC',
  DataParentfileAsc = 'DATA__PARENTFILE_ASC',
  DataParentfileDesc = 'DATA__PARENTFILE_DESC',
  IsfolderAsc = 'ISFOLDER_ASC',
  IsfolderDesc = 'ISFOLDER_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PathAsc = 'PATH_ASC',
  PathDesc = 'PATH_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyFormTemplateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyHomeTaskInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyLessonExerciseInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyLessonInput {
  HometaskAsc = 'HOMETASK_ASC',
  HometaskDesc = 'HOMETASK_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyLessonTemplateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyMessageInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  DialogAsc = 'DIALOG_ASC',
  DialogDesc = 'DIALOG_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyMetricValueInput {
  CoursecategoryAsc = 'COURSECATEGORY_ASC',
  CoursecategoryDesc = 'COURSECATEGORY_DESC',
  CourseAsc = 'COURSE_ASC',
  CourseDesc = 'COURSE_DESC',
  CourseCoursecategoryAsc = 'COURSE__COURSECATEGORY_ASC',
  CourseCoursecategoryDesc = 'COURSE__COURSECATEGORY_DESC',
  CourseCoursecategoryStudentAsc = 'COURSE__COURSECATEGORY__STUDENT_ASC',
  CourseCoursecategoryStudentDesc = 'COURSE__COURSECATEGORY__STUDENT_DESC',
  CourseCoursecategoryStudentMetrickeyAsc = 'COURSE__COURSECATEGORY__STUDENT__METRICKEY_ASC',
  CourseCoursecategoryStudentMetrickeyDesc = 'COURSE__COURSECATEGORY__STUDENT__METRICKEY_DESC',
  CourseCoursecategoryStudentMetrickeyCreatedatAsc = 'COURSE__COURSECATEGORY__STUDENT__METRICKEY__CREATEDAT_ASC',
  CourseCoursecategoryStudentMetrickeyCreatedatDesc = 'COURSE__COURSECATEGORY__STUDENT__METRICKEY__CREATEDAT_DESC',
  CourseStudentAsc = 'COURSE__STUDENT_ASC',
  CourseStudentDesc = 'COURSE__STUDENT_DESC',
  CourseStudentLessonAsc = 'COURSE__STUDENT__LESSON_ASC',
  CourseStudentLessonDesc = 'COURSE__STUDENT__LESSON_DESC',
  CourseStudentLessonLessonexerciseAsc = 'COURSE__STUDENT__LESSON__LESSONEXERCISE_ASC',
  CourseStudentLessonLessonexerciseDesc = 'COURSE__STUDENT__LESSON__LESSONEXERCISE_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  LessonexerciseAsc = 'LESSONEXERCISE_ASC',
  LessonexerciseDesc = 'LESSONEXERCISE_DESC',
  LessonAsc = 'LESSON_ASC',
  LessonDesc = 'LESSON_DESC',
  LessonOrderAsc = 'LESSON_ORDER_ASC',
  MetricdefinitionAsc = 'METRICDEFINITION_ASC',
  MetricdefinitionDesc = 'METRICDEFINITION_DESC',
  MetricdefinitionStudentAsc = 'METRICDEFINITION__STUDENT_ASC',
  MetricdefinitionStudentDesc = 'METRICDEFINITION__STUDENT_DESC',
  MetricdefinitionStudentCreatedatAsc = 'METRICDEFINITION__STUDENT__CREATEDAT_ASC',
  MetricdefinitionStudentCreatedatDesc = 'METRICDEFINITION__STUDENT__CREATEDAT_DESC',
  MetrickeyAsc = 'METRICKEY_ASC',
  MetrickeyDesc = 'METRICKEY_DESC',
  StudentAsc = 'STUDENT_ASC',
  StudentDesc = 'STUDENT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPostInput {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManySubscriptionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyTagInput {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyUserGroupInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyUserInput {
  CodeforactivationAsc = 'CODEFORACTIVATION_ASC',
  CodeforactivationDesc = 'CODEFORACTIVATION_DESC',
  CodeforresetpasswordAsc = 'CODEFORRESETPASSWORD_ASC',
  CodeforresetpasswordDesc = 'CODEFORRESETPASSWORD_DESC',
  CompanyAsc = 'COMPANY_ASC',
  CompanyDesc = 'COMPANY_DESC',
  CompanyRoleAsc = 'COMPANY__ROLE_ASC',
  CompanyRoleDesc = 'COMPANY__ROLE_DESC',
  CompanyRoleIsremovedAsc = 'COMPANY__ROLE__ISREMOVED_ASC',
  CompanyRoleIsremovedDesc = 'COMPANY__ROLE__ISREMOVED_DESC',
  CoursesCoursecategoryAsc = 'COURSES__COURSECATEGORY_ASC',
  CoursesCoursecategoryDesc = 'COURSES__COURSECATEGORY_DESC',
  CoursesCoursecategoryCoursesDataAsc = 'COURSES__COURSECATEGORY__COURSES__DATA_ASC',
  CoursesCoursecategoryCoursesDataDesc = 'COURSES__COURSECATEGORY__COURSES__DATA_DESC',
  CoursesDataAsc = 'COURSES__DATA_ASC',
  CoursesDataDesc = 'COURSES__DATA_DESC',
  CoursesDataRoleAsc = 'COURSES__DATA__ROLE_ASC',
  CoursesDataRoleDesc = 'COURSES__DATA__ROLE_DESC',
  CoursesDataRoleIsremovedAsc = 'COURSES__DATA__ROLE__ISREMOVED_ASC',
  CoursesDataRoleIsremovedDesc = 'COURSES__DATA__ROLE__ISREMOVED_DESC',
  CoursesManagerAsc = 'COURSES__MANAGER_ASC',
  CoursesManagerDesc = 'COURSES__MANAGER_DESC',
  CoursesManagerCoursesDataAsc = 'COURSES__MANAGER__COURSES__DATA_ASC',
  CoursesManagerCoursesDataDesc = 'COURSES__MANAGER__COURSES__DATA_DESC',
  CoursesManagerCoursesDataIsremovedAsc = 'COURSES__MANAGER__COURSES__DATA__ISREMOVED_ASC',
  CoursesManagerCoursesDataIsremovedDesc = 'COURSES__MANAGER__COURSES__DATA__ISREMOVED_DESC',
  CoursesTeacherAsc = 'COURSES__TEACHER_ASC',
  CoursesTeacherDesc = 'COURSES__TEACHER_DESC',
  CoursesTeacherCoursesDataAsc = 'COURSES__TEACHER__COURSES__DATA_ASC',
  CoursesTeacherCoursesDataDesc = 'COURSES__TEACHER__COURSES__DATA_DESC',
  CoursesTeacherCoursesDataIsremovedAsc = 'COURSES__TEACHER__COURSES__DATA__ISREMOVED_ASC',
  CoursesTeacherCoursesDataIsremovedDesc = 'COURSES__TEACHER__COURSES__DATA__ISREMOVED_DESC',
  DbidAsc = 'DBID_ASC',
  DbidDesc = 'DBID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FacebookidAsc = 'FACEBOOKID_ASC',
  FacebookidDesc = 'FACEBOOKID_DESC',
  FirstnameAsc = 'FIRSTNAME_ASC',
  FirstnameDesc = 'FIRSTNAME_DESC',
  IsactivatedAsc = 'ISACTIVATED_ASC',
  IsactivatedDesc = 'ISACTIVATED_DESC',
  IsremovedAsc = 'ISREMOVED_ASC',
  IsremovedDesc = 'ISREMOVED_DESC',
  IssubscribedtopostsAsc = 'ISSUBSCRIBEDTOPOSTS_ASC',
  IssubscribedtopostsDesc = 'ISSUBSCRIBEDTOPOSTS_DESC',
  LastnameAsc = 'LASTNAME_ASC',
  LastnameDesc = 'LASTNAME_DESC',
  LoginAsc = 'LOGIN_ASC',
  LoginDesc = 'LOGIN_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  ProviderAsc = 'PROVIDER_ASC',
  ProviderDesc = 'PROVIDER_DESC',
  RegisteredbyAsc = 'REGISTEREDBY_ASC',
  RegisteredbyDesc = 'REGISTEREDBY_DESC',
  RegisteredbyCreatedatAsc = 'REGISTEREDBY__CREATEDAT_ASC',
  RegisteredbyCreatedatDesc = 'REGISTEREDBY__CREATEDAT_DESC',
  RoleAsc = 'ROLE_ASC',
  RoleDesc = 'ROLE_DESC',
  RoleIsactivatedAsc = 'ROLE__ISACTIVATED_ASC',
  RoleIsactivatedDesc = 'ROLE__ISACTIVATED_DESC',
  RoleIsactivatedIsremovedAsc = 'ROLE__ISACTIVATED__ISREMOVED_ASC',
  RoleIsactivatedIsremovedDesc = 'ROLE__ISACTIVATED__ISREMOVED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyVoteInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneCategoryInput {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneCompanyInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneConsultationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneCourseCategoryInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneCourseInput {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  CoursedirectionAsc = 'COURSEDIRECTION_ASC',
  CoursedirectionDesc = 'COURSEDIRECTION_DESC',
  CoursetypeAsc = 'COURSETYPE_ASC',
  CoursetypeDesc = 'COURSETYPE_DESC',
  CoursetypeIsremovedAsc = 'COURSETYPE__ISREMOVED_ASC',
  CoursetypeIsremovedDesc = 'COURSETYPE__ISREMOVED_DESC',
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  CreatorCreatedatAsc = 'CREATOR__CREATEDAT_ASC',
  CreatorCreatedatDesc = 'CREATOR__CREATEDAT_DESC',
  IsfreecourseAsc = 'ISFREECOURSE_ASC',
  IsfreecourseDesc = 'ISFREECOURSE_DESC',
  IsfreecourseIsremovedAsc = 'ISFREECOURSE__ISREMOVED_ASC',
  IsfreecourseIsremovedDesc = 'ISFREECOURSE__ISREMOVED_DESC',
  IsremovedAsc = 'ISREMOVED_ASC',
  IsremovedDesc = 'ISREMOVED_DESC',
  LanguageAsc = 'LANGUAGE_ASC',
  LanguageDesc = 'LANGUAGE_DESC',
  LanguageIsremovedAsc = 'LANGUAGE__ISREMOVED_ASC',
  LanguageIsremovedDesc = 'LANGUAGE__ISREMOVED_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PositionIsremovedAsc = 'POSITION__ISREMOVED_ASC',
  PositionIsremovedDesc = 'POSITION__ISREMOVED_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneCourseMetricDefinitionInput {
  CoursecategoryAsc = 'COURSECATEGORY_ASC',
  CoursecategoryDesc = 'COURSECATEGORY_DESC',
  CourseAsc = 'COURSE_ASC',
  CourseDesc = 'COURSE_DESC',
  CourseIsactiveAsc = 'COURSE__ISACTIVE_ASC',
  CourseIsactiveDesc = 'COURSE__ISACTIVE_DESC',
  CourseIsactiveIsarchivedAsc = 'COURSE__ISACTIVE__ISARCHIVED_ASC',
  CourseIsactiveIsarchivedDesc = 'COURSE__ISACTIVE__ISARCHIVED_DESC',
  CourseKeyAsc = 'COURSE__KEY_ASC',
  CourseKeyDesc = 'COURSE__KEY_DESC',
  CourseOrderAsc = 'COURSE__ORDER_ASC',
  CourseOrderDesc = 'COURSE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneDialogInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEventInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneFavoriteTopicInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  EntityAsc = 'ENTITY_ASC',
  EntityDesc = 'ENTITY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneFormTemplateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneHomeTaskInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneLessonExerciseInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneLessonInput {
  HometaskAsc = 'HOMETASK_ASC',
  HometaskDesc = 'HOMETASK_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneLessonTemplateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneMessageInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  DialogAsc = 'DIALOG_ASC',
  DialogDesc = 'DIALOG_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePostInput {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneSubscriptionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneTagInput {
  AliasAsc = 'ALIAS_ASC',
  AliasDesc = 'ALIAS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneUserGroupInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneUserInput {
  CodeforactivationAsc = 'CODEFORACTIVATION_ASC',
  CodeforactivationDesc = 'CODEFORACTIVATION_DESC',
  CodeforresetpasswordAsc = 'CODEFORRESETPASSWORD_ASC',
  CodeforresetpasswordDesc = 'CODEFORRESETPASSWORD_DESC',
  CompanyAsc = 'COMPANY_ASC',
  CompanyDesc = 'COMPANY_DESC',
  CompanyRoleAsc = 'COMPANY__ROLE_ASC',
  CompanyRoleDesc = 'COMPANY__ROLE_DESC',
  CompanyRoleIsremovedAsc = 'COMPANY__ROLE__ISREMOVED_ASC',
  CompanyRoleIsremovedDesc = 'COMPANY__ROLE__ISREMOVED_DESC',
  CoursesCoursecategoryAsc = 'COURSES__COURSECATEGORY_ASC',
  CoursesCoursecategoryDesc = 'COURSES__COURSECATEGORY_DESC',
  CoursesCoursecategoryCoursesDataAsc = 'COURSES__COURSECATEGORY__COURSES__DATA_ASC',
  CoursesCoursecategoryCoursesDataDesc = 'COURSES__COURSECATEGORY__COURSES__DATA_DESC',
  CoursesDataAsc = 'COURSES__DATA_ASC',
  CoursesDataDesc = 'COURSES__DATA_DESC',
  CoursesDataRoleAsc = 'COURSES__DATA__ROLE_ASC',
  CoursesDataRoleDesc = 'COURSES__DATA__ROLE_DESC',
  CoursesDataRoleIsremovedAsc = 'COURSES__DATA__ROLE__ISREMOVED_ASC',
  CoursesDataRoleIsremovedDesc = 'COURSES__DATA__ROLE__ISREMOVED_DESC',
  CoursesManagerAsc = 'COURSES__MANAGER_ASC',
  CoursesManagerDesc = 'COURSES__MANAGER_DESC',
  CoursesManagerCoursesDataAsc = 'COURSES__MANAGER__COURSES__DATA_ASC',
  CoursesManagerCoursesDataDesc = 'COURSES__MANAGER__COURSES__DATA_DESC',
  CoursesManagerCoursesDataIsremovedAsc = 'COURSES__MANAGER__COURSES__DATA__ISREMOVED_ASC',
  CoursesManagerCoursesDataIsremovedDesc = 'COURSES__MANAGER__COURSES__DATA__ISREMOVED_DESC',
  CoursesTeacherAsc = 'COURSES__TEACHER_ASC',
  CoursesTeacherDesc = 'COURSES__TEACHER_DESC',
  CoursesTeacherCoursesDataAsc = 'COURSES__TEACHER__COURSES__DATA_ASC',
  CoursesTeacherCoursesDataDesc = 'COURSES__TEACHER__COURSES__DATA_DESC',
  CoursesTeacherCoursesDataIsremovedAsc = 'COURSES__TEACHER__COURSES__DATA__ISREMOVED_ASC',
  CoursesTeacherCoursesDataIsremovedDesc = 'COURSES__TEACHER__COURSES__DATA__ISREMOVED_DESC',
  DbidAsc = 'DBID_ASC',
  DbidDesc = 'DBID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FacebookidAsc = 'FACEBOOKID_ASC',
  FacebookidDesc = 'FACEBOOKID_DESC',
  FirstnameAsc = 'FIRSTNAME_ASC',
  FirstnameDesc = 'FIRSTNAME_DESC',
  IsactivatedAsc = 'ISACTIVATED_ASC',
  IsactivatedDesc = 'ISACTIVATED_DESC',
  IsremovedAsc = 'ISREMOVED_ASC',
  IsremovedDesc = 'ISREMOVED_DESC',
  IssubscribedtopostsAsc = 'ISSUBSCRIBEDTOPOSTS_ASC',
  IssubscribedtopostsDesc = 'ISSUBSCRIBEDTOPOSTS_DESC',
  LastnameAsc = 'LASTNAME_ASC',
  LastnameDesc = 'LASTNAME_DESC',
  LoginAsc = 'LOGIN_ASC',
  LoginDesc = 'LOGIN_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  ProviderAsc = 'PROVIDER_ASC',
  ProviderDesc = 'PROVIDER_DESC',
  RegisteredbyAsc = 'REGISTEREDBY_ASC',
  RegisteredbyDesc = 'REGISTEREDBY_DESC',
  RegisteredbyCreatedatAsc = 'REGISTEREDBY__CREATEDAT_ASC',
  RegisteredbyCreatedatDesc = 'REGISTEREDBY__CREATEDAT_DESC',
  RoleAsc = 'ROLE_ASC',
  RoleDesc = 'ROLE_DESC',
  RoleIsactivatedAsc = 'ROLE__ISACTIVATED_ASC',
  RoleIsactivatedDesc = 'ROLE__ISACTIVATED_DESC',
  RoleIsactivatedIsremovedAsc = 'ROLE__ISACTIVATED__ISREMOVED_ASC',
  RoleIsactivatedIsremovedDesc = 'ROLE__ISACTIVATED__ISREMOVED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneVoteInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export type StudentSurveyField = {
  __typename?: 'StudentSurveyField';
  field?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  _id: Scalars['MongoID']['output'];
  categories?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  codeForUnsubscribe?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  isUnsubscribed?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type SubscriptionConnection = {
  __typename?: 'SubscriptionConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<SubscriptionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SubscriptionEdge = {
  __typename?: 'SubscriptionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Subscription;
};

/** List of items with pagination. */
export type SubscriptionPagination = {
  __typename?: 'SubscriptionPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Subscription>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Tag = {
  __typename?: 'Tag';
  _id: Scalars['MongoID']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<Scalars['MongoID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type TagConnection = {
  __typename?: 'TagConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<TagEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TagEdge = {
  __typename?: 'TagEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Tag;
};

export type TagInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type TagPagination = {
  __typename?: 'TagPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Tag>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TeacherShort = {
  __typename?: 'TeacherShort';
  _id: Scalars['MongoID']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  login?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdCategoryInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<UpdateByIdFileInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<UpdateByIdFileInput>;
};

export type UpdateByIdCategoryPayload = {
  __typename?: 'UpdateByIdCategoryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<Category>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdCompanyCourseDirectionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  courseDirectionName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCompanyInput = {
  courseDirections?: InputMaybe<Array<InputMaybe<UpdateByIdCompanyCourseDirectionsInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<UpdateByIdCompanySettingsInput>;
  thumbnail?: InputMaybe<UpdateByIdFileInput>;
};

export type UpdateByIdCompanyPayload = {
  __typename?: 'UpdateByIdCompanyPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<Company>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdCompanySettingsInput = {
  isShowCompanyLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdConsultationInput = {
  consultationStatus?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['MongoID']['input']>;
  isConsulted?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdConsultationPayload = {
  __typename?: 'UpdateByIdConsultationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<Consultation>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdCourseCategoryDataInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  isCommonCourseCategory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdCourseCategoryInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<UpdateByIdCourseCategoryDataInput>;
  image?: InputMaybe<UpdateByIdFileInput>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCourseCategoryPayload = {
  __typename?: 'UpdateByIdCourseCategoryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<CourseCategory>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdCourseInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  countOfVotes?: InputMaybe<Scalars['Float']['input']>;
  courseDirection?: InputMaybe<Scalars['MongoID']['input']>;
  courseType?: InputMaybe<EnumCourseCourseType>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<InputMaybe<UpdateByIdFileInput>>>;
  image?: InputMaybe<UpdateByIdFileInput>;
  isFreeCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  isTrialLessons?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<EnumCourseLanguage>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<UpdateByIdCourseSettingsInput>;
  tags?: InputMaybe<Array<InputMaybe<UpdateByIdTagInput>>>;
  thumbnail?: InputMaybe<UpdateByIdFileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalModules?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  videos?: InputMaybe<Array<InputMaybe<UpdateByIdFileInput>>>;
  voteRate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdCourseMetricDefinitionPayload = {
  __typename?: 'UpdateByIdCourseMetricDefinitionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CourseMetricDefinition>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCoursePayload = {
  __typename?: 'UpdateByIdCoursePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<Course>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdCourseSettingsInput = {
  brandColor?: InputMaybe<Scalars['String']['input']>;
  isAutoSelectionOfFilesWhenDragging?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoShowingOfNextFileExercise?: InputMaybe<Scalars['Boolean']['input']>;
  isBlockBreadcrumbsNavigationInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabledCompleteLessonInfoForStudent?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableModuleForTeacher?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableAutomaticTransitionToExerciseFile?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableSurveyByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isExerciseSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesListOpenedInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesOpenedInModal?: InputMaybe<Scalars['Boolean']['input']>;
  isGoNextAfterCompletionFile?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenCameraWhenSharingScreen?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenLessonIsNotCompleteButton?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenSlidesRibbonInPresentation?: InputMaybe<Scalars['Boolean']['input']>;
  isHideShowingOfExercisesInLessonCardsForStudent?: InputMaybe<Scalars['Boolean']['input']>;
  isProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  isSelectionOfAnyLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentAbilityToDrawDuringTheLesson?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentAbilityToRecordLesson?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdEventDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  lesson?: InputMaybe<Scalars['MongoID']['input']>;
  studentsGroup?: InputMaybe<Scalars['MongoID']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdEventInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<UpdateByIdEventDataInput>;
  dateTime?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdEventPayload = {
  __typename?: 'UpdateByIdEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdFileInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<FileDataInput>;
  isFolder?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdFilePayload = {
  __typename?: 'UpdateByIdFilePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<File>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdFormTemplateDataFieldsFormFieldItemsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFormTemplateDataFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  formFieldItems?: InputMaybe<Array<InputMaybe<UpdateByIdFormTemplateDataFieldsFormFieldItemsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFormTemplateDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  fields?: InputMaybe<Array<InputMaybe<UpdateByIdFormTemplateDataFieldsInput>>>;
};

export type UpdateByIdFormTemplateInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<UpdateByIdFormTemplateDataInput>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFormTemplatePayload = {
  __typename?: 'UpdateByIdFormTemplatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<FormTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdHomeTaskDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdHomeTaskInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<UpdateByIdHomeTaskDataInput>;
  files?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdHomeTaskPayload = {
  __typename?: 'UpdateByIdHomeTaskPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<HomeTask>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdLessonDataFilesOfExercisesFilesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  id?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLessonDataFilesOfExercisesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  exerciseId?: InputMaybe<Scalars['MongoID']['input']>;
  files?: InputMaybe<Array<InputMaybe<UpdateByIdLessonDataFilesOfExercisesFilesInput>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLessonDataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  filesOfExercises?: InputMaybe<Array<InputMaybe<UpdateByIdLessonDataFilesOfExercisesInput>>>;
  homeTaskStatus?: InputMaybe<Scalars['String']['input']>;
  isZeroLesson?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdLessonExerciseDataInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  isTodo?: InputMaybe<Scalars['Boolean']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdLessonExerciseFilesStatusesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLessonExerciseInput = {
  attachments?: InputMaybe<Array<InputMaybe<UpdateByIdFileInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<UpdateByIdLessonExerciseDataInput>;
  files?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  filesStatuses?: InputMaybe<Array<InputMaybe<UpdateByIdLessonExerciseFilesStatusesInput>>>;
  image?: InputMaybe<UpdateByIdFileInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  originalLessonExercise?: InputMaybe<Scalars['MongoID']['input']>;
  slides?: InputMaybe<Array<InputMaybe<UpdateByIdLessonExerciseSlidesInput>>>;
  thumbnail?: InputMaybe<UpdateByIdFileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<UpdateByIdFileInput>>>;
};

export type UpdateByIdLessonExercisePayload = {
  __typename?: 'UpdateByIdLessonExercisePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<LessonExercise>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdLessonExerciseSlidesInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  slide?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdLessonInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<UpdateByIdFileInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<UpdateByIdLessonDataInput>;
  files?: InputMaybe<Array<InputMaybe<UpdateByIdFileInput>>>;
  homeTask?: InputMaybe<Scalars['MongoID']['input']>;
  image?: InputMaybe<UpdateByIdFileInput>;
  lessonExercises?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesAboutStudent?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  studentMark?: InputMaybe<Scalars['Float']['input']>;
  studentSurvey?: InputMaybe<Array<InputMaybe<Array<InputMaybe<UpdateByIdLessonStudentSurveyInput>>>>>;
  thumbnail?: InputMaybe<UpdateByIdFileInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoCallStatus?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<UpdateByIdFileInput>>>;
  workOnHomeTask?: InputMaybe<UpdateByIdLessonWorkOnHomeTaskInput>;
};

export type UpdateByIdLessonPayload = {
  __typename?: 'UpdateByIdLessonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<Lesson>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdLessonStudentSurveyInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLessonTemplateInput = {
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  isPersonalLessonTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherLessonTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  student?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdLessonTemplatePayload = {
  __typename?: 'UpdateByIdLessonTemplatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<LessonTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdLessonWorkOnHomeTaskInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdPostInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  countOfVotes?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<UpdateByIdFileInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeyWords?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  thumbnail?: InputMaybe<UpdateByIdFileInput>;
  timeForReading?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  voteRate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPostPayload = {
  __typename?: 'UpdateByIdPostPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<Post>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdTagInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdUserCoursesCompleteCourseCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdUserCoursesInput = {
  completeCourseCategories?: InputMaybe<Array<InputMaybe<UpdateByIdUserCoursesCompleteCourseCategoriesInput>>>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategoryProgress?: InputMaybe<Scalars['Float']['input']>;
  courseCategoryTotalLessons?: InputMaybe<Scalars['Int']['input']>;
  currentLesson?: InputMaybe<Scalars['MongoID']['input']>;
  currentLessonExercise?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Scalars['MongoID']['input']>;
  isFinishedCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isPurchasedCourse?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  manager?: InputMaybe<Scalars['MongoID']['input']>;
  paymentData?: InputMaybe<UpdateByIdUserCoursesPaymentDataInput>;
  teacher?: InputMaybe<Scalars['MongoID']['input']>;
  zeroLessonDateTime?: InputMaybe<Scalars['Date']['input']>;
  zeroLessonStatus?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdUserCoursesPaymentDataInput = {
  acq_id?: InputMaybe<Scalars['Float']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_credit?: InputMaybe<Scalars['Float']['input']>;
  card_mask?: InputMaybe<Scalars['String']['input']>;
  create_date?: InputMaybe<Scalars['Date']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  liqpay_order_id?: InputMaybe<Scalars['String']['input']>;
  payment_id?: InputMaybe<Scalars['Float']['input']>;
  transaction_id?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdUserGroupDataCompleteCourseCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdUserGroupDataInput = {
  completeCourseCategories?: InputMaybe<Array<InputMaybe<UpdateByIdUserGroupDataCompleteCourseCategoriesInput>>>;
  course?: InputMaybe<Scalars['MongoID']['input']>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  teacher?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdUserGroupInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  creator?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<UpdateByIdUserGroupDataInput>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<UpdateByIdUserGroupUsersInput>>>;
};

export type UpdateByIdUserGroupPayload = {
  __typename?: 'UpdateByIdUserGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<UserGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdUserGroupUsersInput = {
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdUserInput = {
  age?: InputMaybe<Scalars['Float']['input']>;
  avatar?: InputMaybe<UpdateByIdFileInput>;
  codeForActivation?: InputMaybe<Scalars['String']['input']>;
  codeForResetPassword?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['MongoID']['input']>;
  countOfSentMessages?: InputMaybe<Scalars['Float']['input']>;
  countOfUnreadMessages?: InputMaybe<Scalars['Float']['input']>;
  courses?: InputMaybe<Array<InputMaybe<UpdateByIdUserCoursesInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dbId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  isSubscribedToPosts?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperTeacherMode?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  registeredBy?: InputMaybe<Scalars['MongoID']['input']>;
  role?: InputMaybe<EnumUserRole>;
  subscriptions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userOnboarding?: InputMaybe<UpdateByIdUserUserOnboardingInput>;
};

export type UpdateByIdUserPayload = {
  __typename?: 'UpdateByIdUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdUserUserOnboardingInput = {
  videoCourse?: InputMaybe<UpdateByIdUserUserOnboardingVideoCourseInput>;
};

export type UpdateByIdUserUserOnboardingVideoCourseInput = {
  modulePlayer?: InputMaybe<UpdateByIdUserUserOnboardingVideoCourseModulePlayerInput>;
};

export type UpdateByIdUserUserOnboardingVideoCourseModulePlayerInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  lastStep?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateDataOrderExerciseLessonInput = {
  course: Scalars['MongoID']['input'];
  filesOfExercises?: InputMaybe<Array<InputMaybe<UpdateFilesOfExercisesOrderExerciseLessonInput>>>;
  homeTaskStatus?: InputMaybe<Scalars['String']['input']>;
  student: Scalars['MongoID']['input'];
};

export type UpdateFilesFolderFileDataTc = {
  __typename?: 'UpdateFilesFolderFileDataTC';
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateFilesOfExercisesDataExerciseLessonInput = {
  id: Scalars['MongoID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFilesOfExercisesOrderExerciseLessonInput = {
  exerciseId: Scalars['MongoID']['input'];
  files?: InputMaybe<Array<InputMaybe<UpdateFilesOfExercisesDataExerciseLessonInput>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneLessonTemplatePayload = {
  __typename?: 'UpdateOneLessonTemplatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  message?: Maybe<Scalars['String']['output']>;
  /** Updated document */
  record?: Maybe<LessonTemplate>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateOrderCourseCategoryInput = {
  _id: Scalars['MongoID']['input'];
  id: Scalars['Int']['input'];
};

export type UpdateOrderExerciseLessonInput = {
  data?: InputMaybe<UpdateDataOrderExerciseLessonInput>;
  lessonExercises?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};

export type UpdateOrderLessonInput = {
  _id: Scalars['MongoID']['input'];
  id: Scalars['Int']['input'];
};

export type UpdateResponseType = {
  __typename?: 'UpdateResponseType';
  _id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateStudentLevelCourseUserInput = {
  completeCourseCategories?: InputMaybe<Array<InputMaybe<CompleteCourseCategoryInput>>>;
  courseCategory?: InputMaybe<Scalars['MongoID']['input']>;
  currentLesson?: InputMaybe<Scalars['MongoID']['input']>;
  currentLessonExercise?: InputMaybe<Scalars['MongoID']['input']>;
  data?: InputMaybe<Scalars['MongoID']['input']>;
  isFinishedCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isPurchasedCourse?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTemplate?: InputMaybe<Scalars['MongoID']['input']>;
  manager?: InputMaybe<Scalars['MongoID']['input']>;
  teacher?: InputMaybe<Scalars['MongoID']['input']>;
  zeroLessonDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  zeroLessonStatus?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStudentLevelCourseUserType = {
  __typename?: 'UpdateStudentLevelCourseUserType';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateStudentLevelUserGroupType = {
  __typename?: 'UpdateStudentLevelUserGroupType';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateStudentLevelUserInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  courses?: InputMaybe<Array<InputMaybe<UpdateStudentLevelCourseUserInput>>>;
};

export type UploadFileMutationTc = {
  __typename?: 'UploadFileMutationTC';
  uploadId?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['MongoID']['output'];
  age?: Maybe<Scalars['Float']['output']>;
  avatar?: Maybe<File>;
  codeForActivation?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['MongoID']['output']>;
  countOfSentMessages?: Maybe<Scalars['Float']['output']>;
  countOfUnreadMessages?: Maybe<Scalars['Float']['output']>;
  courses?: Maybe<Array<Maybe<UserCourses>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dbId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isActivated?: Maybe<Scalars['Boolean']['output']>;
  isRemoved?: Maybe<Scalars['Boolean']['output']>;
  isSubscribedToPosts?: Maybe<Scalars['Boolean']['output']>;
  isSuperTeacherMode?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  registeredBy?: Maybe<Scalars['MongoID']['output']>;
  role: EnumUserRole;
  subscriptions: Array<Subscription>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userOnboarding?: Maybe<UserUserOnboarding>;
};

export type UserSubscriptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsSubscriptionInput>;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserCourses = {
  __typename?: 'UserCourses';
  completeCourseCategories?: Maybe<Array<Maybe<UserCoursesCompleteCourseCategories>>>;
  courseCategoriesCount?: Maybe<Scalars['Int']['output']>;
  courseCategory?: Maybe<Scalars['MongoID']['output']>;
  courseCategoryProgress?: Maybe<Scalars['Float']['output']>;
  courseCategoryTotalLessons?: Maybe<Scalars['Int']['output']>;
  currentLesson?: Maybe<Scalars['MongoID']['output']>;
  currentLessonExercise?: Maybe<Scalars['MongoID']['output']>;
  data?: Maybe<Course>;
  isFinishedCourse?: Maybe<Scalars['Boolean']['output']>;
  isPurchasedCourse?: Maybe<Scalars['Boolean']['output']>;
  lessonTemplate?: Maybe<Scalars['MongoID']['output']>;
  manager?: Maybe<Scalars['MongoID']['output']>;
  paymentData?: Maybe<UserCoursesPaymentData>;
  studentsInCourseCount?: Maybe<Scalars['Int']['output']>;
  teacher?: Maybe<User>;
  zeroLessonDateTime?: Maybe<Scalars['Date']['output']>;
  zeroLessonStatus?: Maybe<Scalars['String']['output']>;
};

export type UserCoursesCompleteCourseCategories = {
  __typename?: 'UserCoursesCompleteCourseCategories';
  _id: Scalars['MongoID']['output'];
  lessonTemplate?: Maybe<Scalars['MongoID']['output']>;
};

export type UserCoursesPaymentData = {
  __typename?: 'UserCoursesPaymentData';
  acq_id?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amount_credit?: Maybe<Scalars['Float']['output']>;
  card_mask?: Maybe<Scalars['String']['output']>;
  create_date?: Maybe<Scalars['Date']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  liqpay_order_id?: Maybe<Scalars['String']['output']>;
  payment_id?: Maybe<Scalars['Float']['output']>;
  transaction_id?: Maybe<Scalars['Float']['output']>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: User;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  data?: Maybe<UserGroupData>;
  isRemoved?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<UserGroupUsers>>>;
};

export type UserGroupCreatorArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

/** A connection to a list of items. */
export type UserGroupConnection = {
  __typename?: 'UserGroupConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<UserGroupEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserGroupData = {
  __typename?: 'UserGroupData';
  completeCourseCategories?: Maybe<Array<Maybe<UserGroupDataCompleteCourseCategories>>>;
  course?: Maybe<Course>;
  courseCategory?: Maybe<CourseCategory>;
  courseCategoryProgress?: Maybe<Scalars['Float']['output']>;
  courseCategoryTotalLessons?: Maybe<Scalars['Int']['output']>;
  lessonTemplate?: Maybe<LessonTemplate>;
  teacher?: Maybe<User>;
};

export type UserGroupDataCourseArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCourseInput>;
};

export type UserGroupDataCourseCategoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCourseCategoryInput>;
};

export type UserGroupDataLessonTemplateArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneLessonTemplateInput>;
};

export type UserGroupDataTeacherArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

export type UserGroupDataCompleteCourseCategories = {
  __typename?: 'UserGroupDataCompleteCourseCategories';
  _id?: Maybe<Scalars['MongoID']['output']>;
  lessonTemplate?: Maybe<Scalars['MongoID']['output']>;
};

/** An edge in a connection. */
export type UserGroupEdge = {
  __typename?: 'UserGroupEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserGroup;
};

export type UserGroupUsers = {
  __typename?: 'UserGroupUsers';
  user?: Maybe<User>;
};

export type UserGroupsPaginationType = {
  __typename?: 'UserGroupsPaginationType';
  items?: Maybe<Array<Maybe<UserGroup>>>;
  pageInfo?: Maybe<PaginationType>;
};

export type UserPaginationType = {
  __typename?: 'UserPaginationType';
  items?: Maybe<Array<Maybe<User>>>;
  pageInfo?: Maybe<PageInfoType>;
};

export type UserUserOnboarding = {
  __typename?: 'UserUserOnboarding';
  videoCourse?: Maybe<UserUserOnboardingVideoCourse>;
};

export type UserUserOnboardingVideoCourse = {
  __typename?: 'UserUserOnboardingVideoCourse';
  modulePlayer?: Maybe<UserUserOnboardingVideoCourseModulePlayer>;
};

export type UserUserOnboardingVideoCourseModulePlayer = {
  __typename?: 'UserUserOnboardingVideoCourseModulePlayer';
  completed?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  dismissed?: Maybe<Scalars['Boolean']['output']>;
  lastStep?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ValidationError = ErrorInterface & {
  __typename?: 'ValidationError';
  /** List of validator errors */
  errors?: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']['output']>;
};

export type ValidatorError = {
  __typename?: 'ValidatorError';
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int']['output'];
  /** Validation error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']['output']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type Vote = {
  __typename?: 'Vote';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  entity?: Maybe<Scalars['String']['output']>;
  isVoted?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  voteRate?: Maybe<Scalars['Float']['output']>;
};

/** A connection to a list of items. */
export type VoteConnection = {
  __typename?: 'VoteConnection';
  /** Total object count. */
  count: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  edges: Array<VoteEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VoteEdge = {
  __typename?: 'VoteEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Vote;
};

/** List of items with pagination. */
export type VotePagination = {
  __typename?: 'VotePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Vote>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type FindCreateManyTagMutation = {
  __typename?: 'findCreateManyTagMutation';
  message?: Maybe<Scalars['String']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PopularArticlesItemFragmentFragment = {
  __typename?: 'Post';
  _id: any;
  title?: string | null;
  alias?: string | null;
  image?: { __typename?: 'File'; path?: string | null } | null;
} & { ' $fragmentName'?: 'PopularArticlesItemFragmentFragment' };

export type TopRatedCategoriesItemFragmentFragment = {
  __typename?: 'Category';
  _id: any;
  name?: string | null;
  alias?: string | null;
} & { ' $fragmentName'?: 'TopRatedCategoriesItemFragmentFragment' };

export type BlogMenuQueryQueryVariables = Exact<{
  postsLimit: Scalars['Int']['input'];
  categoriesLimit: Scalars['Int']['input'];
  postsFilter?: InputMaybe<FilterFindManyPostInput>;
  categoriesFilter?: InputMaybe<FilterFindManyCategoryInput>;
}>;

export type BlogMenuQueryQuery = {
  __typename?: 'Query';
  popularArticles: Array<
    { __typename?: 'Post' } & {
      ' $fragmentRefs'?: { PopularArticlesItemFragmentFragment: PopularArticlesItemFragmentFragment };
    }
  >;
  topRatedCategories: Array<
    { __typename?: 'Category' } & {
      ' $fragmentRefs'?: { TopRatedCategoriesItemFragmentFragment: TopRatedCategoriesItemFragmentFragment };
    }
  >;
};

export type PopularCourseItemFragmentFragment = {
  __typename?: 'Course';
  _id: any;
  title: string;
  alias: string;
  language: EnumCourseLanguage;
  courseType: EnumCourseCourseType;
  isPublished?: boolean | null;
  price?: number | null;
  currency?: string | null;
  isFreeCourse?: boolean | null;
  image?: { __typename?: 'File'; path?: string | null } | null;
  thumbnail?: { __typename?: 'File'; path?: string | null } | null;
} & { ' $fragmentName'?: 'PopularCourseItemFragmentFragment' };

export type PopularCoursesQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  freeFilter?: InputMaybe<FilterFindManyCourseInput>;
  paidFilter?: InputMaybe<FilterFindManyCourseInput>;
  sort?: InputMaybe<SortFindManyCourseInput>;
}>;

export type PopularCoursesQueryQuery = {
  __typename?: 'Query';
  freeCourses: Array<
    { __typename?: 'Course' } & {
      ' $fragmentRefs'?: { PopularCourseItemFragmentFragment: PopularCourseItemFragmentFragment };
    }
  >;
  paidCourses: Array<
    { __typename?: 'Course' } & {
      ' $fragmentRefs'?: { PopularCourseItemFragmentFragment: PopularCourseItemFragmentFragment };
    }
  >;
};

export type FindManySubscriptionCategoriesQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<FilterFindManyCategoryInput>;
  sort?: InputMaybe<SortFindManyCategoryInput>;
}>;

export type FindManySubscriptionCategoriesQueryQuery = {
  __typename?: 'Query';
  findManyCategoryQuery: Array<{
    __typename?: 'Category';
    _id: any;
    name?: string | null;
    alias?: string | null;
    language?: string | null;
    isPublished?: boolean | null;
  }>;
};

export const PopularArticlesItemFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PopularArticlesItemFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Post' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'path' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PopularArticlesItemFragmentFragment, unknown>;
export const TopRatedCategoriesItemFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TopRatedCategoriesItemFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TopRatedCategoriesItemFragmentFragment, unknown>;
export const PopularCourseItemFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PopularCourseItemFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Course' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'courseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'price' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFreeCourse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'path' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'path' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PopularCourseItemFragmentFragment, unknown>;
export const BlogMenuQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'blogMenuQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'postsLimit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'categoriesLimit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'postsFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterFindManyPostInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'categoriesFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterFindManyCategoryInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'popularArticles' },
            name: { kind: 'Name', value: 'findManyPostQuery' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'postsFilter' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'skip' }, value: { kind: 'IntValue', value: '0' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'postsLimit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'EnumValue', value: '_ID_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PopularArticlesItemFragment' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'topRatedCategories' },
            name: { kind: 'Name', value: 'findManyCategoryQuery' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'categoriesFilter' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'skip' }, value: { kind: 'IntValue', value: '0' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'categoriesLimit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'EnumValue', value: '_ID_ASC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TopRatedCategoriesItemFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PopularArticlesItemFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Post' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'path' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TopRatedCategoriesItemFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlogMenuQueryQuery, BlogMenuQueryQueryVariables>;
export const PopularCoursesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'popularCoursesQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'freeFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterFindManyCourseInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paidFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterFindManyCourseInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortFindManyCourseInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'freeCourses' },
            name: { kind: 'Name', value: 'findManyCourseQuery' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'freeFilter' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'skip' }, value: { kind: 'IntValue', value: '0' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PopularCourseItemFragment' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'paidCourses' },
            name: { kind: 'Name', value: 'findManyCourseQuery' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'paidFilter' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'skip' }, value: { kind: 'IntValue', value: '0' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PopularCourseItemFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PopularCourseItemFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Course' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'courseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'price' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFreeCourse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'path' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'path' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PopularCoursesQueryQuery, PopularCoursesQueryQueryVariables>;
export const FindManySubscriptionCategoriesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'findManySubscriptionCategoriesQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FilterFindManyCategoryInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortFindManyCategoryInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'findManyCategoryQuery' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FindManySubscriptionCategoriesQueryQuery,
  FindManySubscriptionCategoriesQueryQueryVariables
>;
